/* ⛔ UN SIGNAL QUI ABANDONNE, SUR CHAQUE APPEL AU STUDIO (23/08/2026). Mesure du jour, dans un
   vrai navigateur, sur un article : `runway.dcomdtf.app` etant tombe, `/blog-log` a mis
   30 338 ms et `/search-log/vue-article` 30 070 ms avant de rendre la main. La page s'affiche
   quand meme, mais `load` n'arrive qu'apres une demi-minute : les mesures de vitesse comptent
   ce temps-la, et tout ce qui attend `load` attend avec.
   Une balise de mesure ne doit jamais couter plus qu'elle ne rapporte : 2,5 s, puis elle
   abandonne. ⚠️ AUCUN DEPOT DE FICHIER ICI : un envoi de photo prend legitimement plus
   longtemps, il garde son temps. */
function afSignalCourt(ms) {
  try { return AbortSignal.timeout(ms || 2500); } catch (e) { return undefined; }
}
/* Murmure theme — cart drawer (Shopify AJAX API), search, toast, generic selectors */
(function () {
  "use strict";
  /* ⛔⛔ LE TIROIR N'A PAS SON PROPRE FORMAT DE PRIX. Il en avait un, et il etait FAUX sur cinq
     marches sur treize : « fr-FR » et « € » ecrits en dur ici rendaient « 1 849,00 € » pour un
     panier tcheque de 1 849 Kč, soit vingt-cinq fois le prix reel, sur l'ecran qui precede
     immediatement le paiement. Mesure du 21/08/2026 sur /cs-eun/ : lignes, cadres, remise et
     sous-total, tous marques €, tous en couronnes. Adrien : « ca affiche le prix en euro dans
     le drawer ».
     ⚠️ LE MONTANT, LUI, ETAIT JUSTE : /cart.js rend des centiemes DANS LA DEVISE DU MARCHE. Seul
     le symbole mentait, ce qui est le pire des deux cas : rien ne clochait a la lecture, et
     l'erreur ne se voyait qu'en connaissant le catalogue.
     `MURMURE_MONEY` applique le format regle dans Shopify, qui suit la devise du marche. C'est
     deja la source de product.js, gallery-wall.js, sur-mesure.js et panneau-mariage.js : le
     tiroir etait le dernier a en inventer un second. Le repli garde l'insecable de l'ancienne
     version, mais prend la devise ACTIVE, jamais l'euro. */
  /* LE PARCOURS PROFESSIONNEL DANS LE TIROIR DE PANIER.
     ⛔ ICI ON CONVERTIT CE QUI EST REELLEMENT DEBITE, RIEN D'AUTRE. Ailleurs sur le site le prix
     pro se calcule sur le prix DE BASE, promo du grand public ecartee. Le panier, lui, annonce ce
     que la caisse va prendre : y afficher la grille plutot que le montant debite ferait un total
     qui ne correspond a rien au paiement. Seule la conversion hors taxes s'applique.
     ⛔ ET SANS TAUX CONNU, PAS DE HORS TAXES : hors Union aucun taux ne s'applique. */
  var PRO = document.documentElement.getAttribute("data-pro") === "1";
  var TVA = parseFloat(document.documentElement.getAttribute("data-tva") || "0") || 0;
  var PRO_HT = PRO && TVA > 0;
  var HT = document.documentElement.getAttribute("data-ht") || "";

  var money = function (cents) {
    if (typeof window.MURMURE_MONEY === "function") return window.MURMURE_MONEY(cents);
    var v = Number(cents);
    if (!isFinite(v)) v = 0;
    try {
      return new Intl.NumberFormat((window.Shopify && window.Shopify.locale) || "fr",
        { style: "currency", currency: deviseActive() }).format(v / 100);
    } catch (e) {
      return (v / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2 }) + "\u00a0€";
    }
  };

  /* LE MONTANT DES MARCHANDISES DANS LE PARCOURS PRO : le meme, converti hors taxes.
     ⛔ IL ENVELOPPE `money`, IL NE LE REMPLACE PAS. `money` est verrouille par
     tests/tiroir-devise.test.js dans sa forme EXACTE : il doit deleguer au format de la boutique
     des sa premiere ligne. Le 21/08/2026 le tiroir annoncait « 1 849,00 € » pour un panier
     tcheque de 1 849 Kc, et ce verrou existe pour que ca ne revienne pas. Ma premiere version
     glissait la conversion AVANT cette ligne : le crochet de pre-commit a refuse le commit, et
     il avait raison.
     ⛔ ET IL NE S'APPLIQUE PAS A TOUT. Le seuil de livraison offerte est un montant TTC : le
     convertir changerait la promesse, pas sa presentation. Seules les marchandises passent ici. */
  var moneyAff = function (cents) {
    if (!PRO_HT) return money(cents);
    return money(Math.round(Number(cents) / (1 + TVA / 100))) + (HT ? " " + HT : "");
  };
  function deviseActive() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EUR";
  }
  /* ⛔⛔ ET LES SEUILS EN EURO NE SE COMPARENT PAS A UN TOTAL EN COURONNES. Meme mesure, meme
     jour, autre moitie du meme defaut : `threshold` (50 €) et `from` (4,99 a 19,99 €) sont
     ecrits en centimes d'EURO dans theme.liquid, et etaient compares tels quels a
     `cart.total_price`, qui est en centiemes de la DEVISE DU MARCHE. Sur /cs-eun/, la livraison
     offerte se declenchait donc a 5 000 haleru, soit 50 Kč, environ 2 € : une promesse
     commerciale tenue vingt-cinq fois trop tot, et « des 4,99 » qui annoncait 4,99 Kč de port.
     ⚠️ LE TAUX EST CELUI DE LA BOUTIQUE, PAS UN TAUX INVENTE : `Shopify.currency.rate` est ce
     que Shopify applique lui-meme aux prix du catalogue. Mesure de controle sur /cs-eun/ :
     16,90 € rendus 417,00 Kč, 12,60 € rendus 311,00 Kč, 24,50 € rendus 605,00 Kč, soit le taux
     puis un arrondi a l'unite superieure. On applique le meme, pour qu'un seuil tombe sur la
     meme marche que les prix qu'il compare.
     ⚠️ ET SUR LES HUIT MARCHES EN EURO, `rate` VAUT 1 : la conversion est alors l'identite, et
     aucune de ces lignes ne change ce qui s'y affichait. */
  function enDeviseDuMarche(centsEuro) {
    if (typeof window.MURMURE_EN_DEVISE === "function") return window.MURMURE_EN_DEVISE(centsEuro);
    var v = Number(centsEuro);
    if (!isFinite(v)) return 0;
    var taux = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    if (!isFinite(taux) || taux <= 0 || taux === 1) return v;
    return Math.ceil(v * taux / 100) * 100;
  }
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ⛔⛔ LES APOSTROPHES DES TRADUCTIONS ARRIVENT EN `&#39;` DANS LE JAVASCRIPT, ET S'Y VOIENT.
     Le filtre `t` de Shopify rend du texte DEJA echappe pour le HTML ; `| json` le met ensuite
     entre guillemets tel quel. Une chaine posee par `textContent` affiche donc l'entite en
     toutes lettres. Releve le 21/08/2026 sur la fiche : « Ces photos n&#39;ont pas pu etre
     lues », qui est un message montre au client quand un depot echoue, et « Creez un ensemble
     d&#39;affiches harmonieux » dans le menu.
     Le defaut est ancien et n'a rien a voir avec un fichier en particulier : il tient au couple
     `t` + `json`, present partout. On le repare donc UNE fois, ici, sur les sacs de
     traductions connus, et EN PLACE : les autres scripts capturent `window.MURMURE_I18N` dans
     leur propre `var T` au demarrage, et une copie decodee a cote les laisserait avec l'ancienne.
     ⚠️ `textarea` ET NON `div` : le contenu d'un `textarea` est analyse comme du TEXTE, jamais
     comme du balisage. Un `div.innerHTML` executerait ce qu'on lui donne. */
  var deshtml = function (v) {
    if (typeof v !== "string" || v.indexOf("&") < 0) return v;
    var t = document.createElement("textarea");
    t.innerHTML = v;
    return t.value;
  };
  window.murDeshtml = deshtml;
  var decodeSac = function (sac) {
    if (!sac || typeof sac !== "object") return sac;
    for (var k in sac) {
      if (Object.prototype.hasOwnProperty.call(sac, k)) sac[k] = deshtml(sac[k]);
    }
    return sac;
  };
  decodeSac(window.MURMURE_I18N);
  decodeSac(window.__pdpPanneauT);

  var SHIP = window.MURMURE_SHIP || {};
  var T = window.MURMURE_I18N || {};
  var PROMO = window.MURMURE_PROMO || {};
  var UPSELL = window.MURMURE_CART_UPSELL || [];
  var SEARCH_CHIPS = window.MURMURE_SEARCH_CHIPS || [];
  /* Racine de langue (« / », « /nl », « /de »...) : chaque adresse de recherche la porte,
     sinon les suggestions interrogent l'index francais depuis les autres langues. */
  var RACINE_LOCALE = String(window.MURMURE_RACINE || "/").replace(/\/$/, "");
  function t(k, fb) { return T[k] || fb; }
  var FREE_SHIP = enDeviseDuMarche(typeof SHIP.threshold === "number" ? SHIP.threshold : 5000);
  /* Le tarif le moins cher de la zone du CLIENT, sous le seuil de gratuité (évite la surprise
     au checkout). Il vient de `layout/theme.liquid`, qui le choisit sur le pays : 4,99 en
     France, 5,99 dans l'UE, 19,99 au Royaume-Uni, 12,99 en AELE. Le repli à 499 ne vaut que
     si le pays est inconnu, et il ne vaut que pour la France : c'est le seul cas où il est
     juste. Voir le bloc ⛔ de theme.liquid avant d'y toucher. */
  var SHIP_FROM = enDeviseDuMarche(typeof SHIP.from === "number" ? SHIP.from : 499);

  /* Livraison offerte — se base sur le total réel du panier, pas sur le prix du produit.
     Pilote la barre de la page produit ET le titre du bloc recommandations : un seul
     calcul, donc pas de risque que les deux montants se contredisent. */
  function renderShipBar(totalCents) {
    var left = Math.max(0, FREE_SHIP - totalCents);
    var free = left <= 0;

    var bar = $("#ship-bar");
    if (bar) {
      var msg = $("#ship-bar-msg"), fill = $("#ship-bar-fill");
      if (fill) fill.style.width = (FREE_SHIP > 0 ? Math.min(100, (totalCents / FREE_SHIP) * 100) : 100) + "%";
      if (msg) msg.textContent = free ? t("ship_reached", "Livraison offerte ✓") : t("ship_left", "Plus que __AMT__ pour en profiter").replace("__AMT__", money(left));
      bar.setAttribute("data-free", free ? "true" : "false");
    }

    $$("[data-ship-left]").forEach(function (e) { e.textContent = money(left); });
    var reco = $("#reco");
    if (reco) {
      reco.setAttribute("data-free", free ? "true" : "false");
      var fEl = reco.querySelector("[data-reco-free]"), lEl = reco.querySelector("[data-reco-left]");
      if (fEl) fEl.hidden = !free;
      if (lEl) lEl.hidden = free;
      var fIntro = reco.querySelector("[data-reco-intro-free]"), lIntro = reco.querySelector("[data-reco-intro-left]");
      if (fIntro) fIntro.hidden = !free;
      if (lIntro) lIntro.hidden = free;
    }
  }
  window.murRenderShipBar = renderShipBar;

  var toastTimer = null;
  function toast(msg) {
    var t = $("#mur-toast"); if (!t) return;
    t.textContent = "✓ " + msg; t.style.display = "block";
    t.style.animation = "none"; void t.offsetWidth; t.style.animation = "mur-toast 2.2s ease forwards";
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.style.display = "none"; }, 2200);
  }
  window.murToast = toast;

  /* ---- Cart drawer ---- */
  /* ⛔⛔ ON NE MESURE PAS UN EN-TETE EN TRAIN DE S'ANIMER (Adrien, 29/08/2026 : « le collapse au
     scroll est instable, ca fait des jumps a l'ecran »). Releve sous WebKit a 390 px, en
     descendant puis en remontant : 175, 82, puis 142, 143 et 171 au retour — trois hauteurs qui
     n'existent a AUCUN moment d'equilibre. Ce sont des images intermediaires de la transition
     CSS, et `--site-header-h` les ecrivait telles quelles dans la variable que la cale collante
     et l'epingle de la galerie consomment : chaque image deplacait la page.
     ⚠️ C'EST LA MEME FAUTE QUE LA COURSE DU MENU, un cran plus loin. Celle-la avait ete corrigee
     en figeant la valeur ; ici il ne s'agit pas de figer mais d'attendre : l'en-tete a deux
     etats d'equilibre, et seuls ces deux-la ont un sens pour qui s'en sert.
     ⚠️ `getAnimations` N'EXISTE PAS PARTOUT : sans elle on mesure comme avant, ce qui rend le
     comportement d'aujourd'hui plutot qu'une page figee. */
  function enteteSAnime(header) {
    try {
      if (typeof header.getAnimations !== "function") return false;
      return header.getAnimations({ subtree: true }).some(function (a) {
        return a.playState === "running";
      });
    } catch (e) { return false; }
  }
  var syncHeaderRelance = null;
  var syncHeaderEssais = 0;
  function syncHeaderH() {
    var header = document.querySelector(".site-header");
    if (!header) return;
    if (enteteSAnime(header)) {
      /* ⛔ ON INSISTE JUSQU'A L'EQUILIBRE, PAS UNE SEULE FOIS. Une relance unique reprenait la
         mesure 90 ms plus tard, souvent encore en pleine animation, et abandonnait ensuite : la
         variable restait sur une valeur intermediaire jusqu'au geste suivant. Releve sous WebKit :
         l'en-tete revenait a 143 px en haut de page au lieu de ses 175.
         ⚠️ ET LE NOMBRE D'ESSAIS EST BORNE. Une animation sans fin — un bandeau qui pulse, un
         compteur — ferait tourner cette relance pour toujours ; au bout d'une seconde on mesure
         ce qu'on a, ce qui rend le comportement d'avant plutot qu'une variable jamais ecrite. */
      if (!syncHeaderRelance && syncHeaderEssais < 12) {
        syncHeaderEssais += 1;
        syncHeaderRelance = setTimeout(function () {
          syncHeaderRelance = null;
          syncHeaderH();
        }, 90);
        return;
      }
      if (syncHeaderRelance) return;
    }
    syncHeaderEssais = 0;
    document.documentElement.style.setProperty(
      "--site-header-h",
      Math.round(header.getBoundingClientRect().height) + "px"
    );
    /* ⛔ ET LA HAUTEUR DE LA BARRE PROMO, POUR LA MEME RAISON QUE `--promise-h` : elle change
       avec la langue et avec la presence du compteur, et un nombre ecrit en dur ferait mentir
       la cale au premier changement. C'est elle qui reste a l'ecran quand l'en-tete se retracte
       sur les fiches configurateur ; le reste passe au-dessus du bord. */
    var hPromo = promoEl() ? Math.round(promoEl().getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty("--promo-h", hPromo + "px");
    /* ⛔ LA COURSE DU MENU SE RETIENT ICI, PAS AU DEFILEMENT. C'est la distance que l'en-tete
       parcourt avant qu'il ne reste que le bandeau, et les deux hauteurs sont connues a cet
       endroit precis. La relire a chaque geste par `getComputedStyle` forcerait un recalcul de
       style a chaque pixel, et ferait dependre le defilement d'une API que les bancs n'ont pas
       (deux d'entre eux sont tombes dessus : `getComputedStyle is not defined` sous Node).
       Une valeur mesurée une fois, relue partout. */
    /* ⛔ LA COURSE SE FIGE A LA PREMIERE MESURE, ET C'EST TOUT LE CORRECTIF (Adrien, serie 308 :
       « je la vois grandir puis revenir a sa position initiale »).

       C'ETAIT UNE BOUCLE, et elle se lit dans sa phrase. La galerie s'agrandit quand le
       defilement depasse la course ; mais l'en-tete se COMPACTE au-dela de 64 px, donc sa
       hauteur reelle diminue, donc `syncHeaderH` recalculait une course plus courte, donc le
       seuil passait sous la position courante et la classe se retirait. L'image grandissait,
       la course changeait, l'image revenait. Une valeur qui sert de SEUIL ne peut pas etre
       recalculee par ce que le franchissement du seuil provoque.

       ⚠️ LA COURSE EST UNE CONSTANTE DE MISE EN PAGE, pas une mesure vivante : c'est la hauteur
       que l'en-tete DEPLIE doit parcourir avant qu'il ne reste que le bandeau. Elle se prend une
       fois, en haut de page, et ne bouge plus. `--site-header-h`, elle, continue de suivre
       l'etat compact : les deux repondent a deux questions differentes, et les confondre est ce
       qui a fait osciller l'ecran. */
    if (window.__murCourseMenu === undefined || (window.pageYOffset || 0) < 8) {
      window.__murCourseMenu = Math.max(0,
        Math.round(header.getBoundingClientRect().height) - hPromo);
    }
  }
  function promoEl() { return document.querySelector(".summer-bar"); }

  /* ⛔ LA HAUTEUR DE L'EN-TETE SE POSE AU CHARGEMENT, PAS SEULEMENT AU HASARD D'UN GESTE
     (mesure du 15/08/2026 sur affichely.com : `--site-header-h` valait la CHAINE VIDE).
     Les quatre appels existants sont tous conditionnels : deux vivent dans le compte a rebours
     de la promo, qui sort par un `return` des que la barre n'est pas la ou que sa date manque,
     et deux ne partent qu'a l'ouverture du tiroir panier. Sur une fiche produit ordinaire, la
     variable n'etait donc JAMAIS ecrite.
     ⚠️ ET C'EST CE QUI A RENDU MON CORRECTIF DU MATIN INERTE. `--pdp-sticky-top` vaut
     `calc(var(--site-header-h, 0px) - var(--promise-h, 0px) + 16px)` : avec la variable absente,
     le repli a 0px s'applique et la cale retombe a 16px, exactement le comportement d'avant.
     J'ai livre, commente et pousse une correction qui ne changeait rien, et le defaut
     (« l'image passe sous le menu ») est reste entier. Un repli bien choisi rend une panne
     invisible : c'est utile en production, c'est un piege a la relecture.
     ⚠️ ET ELLE SUIT L'EN-TETE : `ResizeObserver` couvre le passage en mode compact, la rotation
     et la disparition de la barre promo, sans qu'aucun de ces cas ait a etre nomme ici. */
  (function poserHauteurEntete() {
    syncHeaderH();
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", syncHeaderH);
    }
    window.addEventListener("load", syncHeaderH);
    window.addEventListener("resize", syncHeaderH);
    var cible = document.querySelector(".site-header");
    if (cible && typeof ResizeObserver === "function") {
      new ResizeObserver(syncHeaderH).observe(cible);
    }
  })();

  /* Compte à rebours barre promo (sous le menu).
     Segments HTML « 5j · 5h · 1min · 14s » : chiffre collé à l'unité, écart via CSS gap
     (évite le letter-spacing qui écartait chaque caractère). */
  (function initSummerCountdown() {
    var bar = document.querySelector("[data-summer-countdown]");
    if (!bar) return;
    var timer = bar.querySelector("[data-summer-timer]");
    if (!timer) return;
    var end = Date.parse(bar.getAttribute("data-summer-end") || "");
    if (!end) {
      /* `ends` vient de `snippets/promo-fin.liquid` et porte désormais l'heure et le décalage.
         L'ancien code y ajoutait « T23:59:59+02:00 » en dur, ce qui produisait une date
         invalide dès que la valeur était complète. On n'ajoute donc l'heure que si elle manque. */
      /* ⛔ PLUS DE DATE DE REPLI (12/08/2026). Elle valait « 2026-07-31 », deja passee au
         moment ou ce repli a ete ecrit : le jour ou il aurait servi, le compte a rebours
         serait parti a zero, ou aurait affiche une fin qui n'etait celle d'aucune campagne.
         Sans date connue, on cache le compteur — le bandeau reste, il ne ment pas. */
      var ends = PROMO.ends || "";
      if (ends) end = Date.parse(ends.indexOf("T") > -1 ? ends : ends + "T23:59:59+02:00");
    }
    if (!end) { timer.hidden = true; return; }
    var uD = (bar.getAttribute("data-u-d") || "j").trim();
    var uH = (bar.getAttribute("data-u-h") || "h").trim();
    var uM = (bar.getAttribute("data-u-m") || "min").trim();
    var uS = (bar.getAttribute("data-u-s") || "s").trim();
    var ended = false;
    function seg(n, u) {
      return '<span class="summer-bar__seg"><strong>' + n + '</strong><span class="summer-bar__u">' + u + "</span></span>";
    }
    function render(d, h, m, s) {
      timer.innerHTML = seg(d, uD) + seg(h, uH) + seg(m, uM) + seg(s, uS);
    }
    function tick() {
      if (ended) return;
      var ms = end - Date.now();
      if (ms <= 0) {
        ended = true;
        render(0, 0, 0, 0);
        bar.hidden = true;
        syncHeaderH();
        return;
      }
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      render(d, h, m, s);
    }
    tick();
    setInterval(tick, 1000);
    requestAnimationFrame(function () { syncHeaderH(); });
  })();
  function setCartOpen(on) {
    document.body.classList.toggle("cart-open", !!on);
    // Chatwoot : le launcher flottant passe devant le CTA panier sur mobile.
    try {
      if (on && window.$chatwoot && typeof window.$chatwoot.toggle === "function") {
        window.__cartHidChat = true;
        window.$chatwoot.toggle("close");
      }
    } catch (_) { /* ignore */ }
  }
  function openDrawer() {
    syncHeaderH();
    // Ferme le tiroir nav s'il est ouvert (panier mobile = plein écran).
    document.body.classList.remove("nav-open");
    var nt = document.querySelector("[data-nav-toggle]");
    if (nt) nt.setAttribute("aria-expanded", "false");
    var nav = document.querySelector("[data-nav]");
    if (nav) nav.classList.remove("open");
    var nov = document.querySelector("[data-nav-overlay]");
    if (nov) { nov.classList.remove("open"); nov.hidden = true; }
    $("#cart-overlay").classList.add("open");
    $("#cart-drawer").classList.add("open");
    setCartOpen(true);
    resyncPanier();
  }
  /* ⛔ LE TIROIR NE SE RESYNCHRONISAIT JAMAIS A L'OUVERTURE. Son contenu venait d'UN SEUL
     `fetchCart().then(renderCart)` joue au chargement de la page, et `openDrawer` ne faisait
     qu'ajouter des classes. Tant que rien n'est fait DANS le tiroir, l'ecran reste donc fige
     sur l'etat du panier au moment ou la page a ete servie. Tout ce qui change le panier
     ailleurs passe inapercu : un second onglet, un retour arriere depuis le paiement (la page
     revient du cache navigateur sans rejouer un seul script), un panier vide par Shopify apres
     une commande. Adrien, 13/08/2026, capture a l'appui : en-tete « Panier (1) », une seule
     ligne a 39,00, et pourtant SOUS-TOTAL 50,99 avec la barre qui annonce la livraison offerte.
     ⚠️ LE COUT DE L'ERREUR EST ASYMETRIQUE. Un appel de trop a /cart.js ne coute qu'une
     requete ; un total perime annonce la gratuite sur un panier qui ne la merite plus, juste
     avant le paiement. On resynchronise donc a CHAQUE ouverture, et au retour du cache. */
  function resyncPanier() {
    /* ⚠️ PAS DE REQUETE SI LE PANIER VIENT D'ETRE RENDU. `addToCart` recupere le panier, le rend,
       PUIS ouvre le tiroir : re-demander la meme chose 5 ms plus tard n'apprend rien, coute une
       requete a chaque ajout, et decale tout ce qui suit. Mesure faite le 13/08/2026 : cet appel
       de trop faisait echouer `tests/origine.test.js` une fois sur douze, sur une course qui
       existait deja mais que personne ne declenchait. La fenetre couvre l'ouverture qui suit un
       ajout, pas une ouverture faite a la main quelques secondes plus tard. */
    if (Date.now() - dernierRendu < 800) return;
    fetchCart().then(renderCart).catch(function () {});
  }
  window.addEventListener("pageshow", function (e) {
    /* `persisted` : la page revient du cache arriere/avant, aucun script n'a ete rejoue. */
    if (e.persisted) resyncPanier();
  });
  function closeDrawer() {
    $("#cart-overlay").classList.remove("open");
    $("#cart-drawer").classList.remove("open");
    setCartOpen(false);
  }
  window.murOpenCart = openDrawer; window.murCloseCart = closeDrawer;
  window.addEventListener("resize", function () {
    if (document.body.classList.contains("cart-open")) syncHeaderH();
  });

  /** Badge promo façon Desenio : « -10% » plein rouge, calculé sur le prix barré de LA LIGNE.
   *
   * ⛔ AUCUN REPLI SUR LA PROMO GLOBALE. Il y en avait un : faute de prix barré, la ligne
   * recevait quand même « -25 % » dès que la promo d'été était active. Or les accessoires n'y
   * sont pas : le panier annonçait « -25 % » à côté d'un cadre facturé 29,00 € plein tarif
   * (Adrien, 05/08/2026). Un badge de remise sur un article non remisé n'est pas un défaut
   * d'affichage, c'est une annonce de prix fausse, et elle se lit juste avant le paiement.
   *
   * La remise d'une ligne, c'est l'écart entre son prix barré et son prix. Rien d'autre ne le
   * sait, et surtout pas un drapeau de campagne posé sur la boutique entière. */
  function promoBadgeLabel(compareAt, price) {
    if (compareAt > price && price > 0) {
      var pct = Math.round((1 - price / compareAt) * 100);
      if (pct > 0) return "-" + pct + "%";
    }
    return "";
  }

  function compareAtUnit(item) {
    window.__caCache = window.__caCache || {};
    return window.__caCache["v:" + item.variant_id] || 0;
  }

  /** Économies affichées : remises panier Shopify + écart compare_at (promo −10 %). */
  /* Code promo — le champ n'existe QUE pour qui en a reçu un.
   *
   * Un champ « code promo » visible de tous coûte des ventes : il annonce à celui qui n'en a
   * pas qu'il paie le prix fort, et l'envoie chercher un code ailleurs plutôt que payer. Il
   * n'apparaît donc que si le navigateur porte un code non expiré, déposé par la popup de
   * sortie (`exit-survey.liquid`, clé `affichely:promo`).
   *
   * Shopify n'accepte pas de code par POST /cart : le seul chemin est /discount/<CODE>, qui
   * applique la remise à la session puis redirige. On revient sur la page courante avec
   * ?promo=1, ce qui rouvre le tiroir : le client VOIT la remise sur son total avant de
   * payer, et un code expiré se découvre ici plutôt que dans le tunnel de paiement. */
  function promoStocke() {
    try {
      var brut = localStorage.getItem("affichely:promo");
      if (!brut) return null;
      var p = JSON.parse(brut);
      if (!p || !p.code) return null;
      // Les codes de la popup valent deux heures. Expiré, on le retire plutôt que de
      // proposer au client un geste qui échouera.
      if (p.expires_at && new Date(p.expires_at).getTime() <= Date.now()) {
        localStorage.removeItem("affichely:promo");
        return null;
      }
      return p;
    } catch (e) { return null; }
  }

  function promoBloc(cart) {
    /* ⚠️ Ne pas se fier à `cart.total_discount` : il additionne TOUTES les remises, y
       compris les automatiques. La promo d'été en est une, donc ce total est non nul sur
       presque tous les paniers — et l'annoncer « Code appliqué » disait au client qu'il
       avait saisi un code alors qu'il n'avait rien fait. C'est ce qui s'affichait par
       défaut le 29/07.
       Seul `discount_applications` porte le type : on ne reconnaît que `discount_code`. */
    var apps = (cart && cart.discount_applications) || [];
    var codeApplique = null;
    for (var i = 0; i < apps.length; i += 1) {
      if (apps[i] && apps[i].type === "discount_code") { codeApplique = apps[i]; break; }
    }
    if (codeApplique) {
      var montant = Number(codeApplique.total_allocated_amount) || 0;
      return '<div class="cart-promo cart-promo--ok">' +
        "<span>" + t("cart_promo_applied", "Code appliqué") +
          (codeApplique.title ? " · " + String(codeApplique.title) : "") + "</span>" +
        (montant > 0 ? "<strong>−" + money(montant) + "</strong>" : "") +
        "</div>";
    }
    var p = promoStocke();
    if (!p) return "";
    var retour = location.pathname + (location.search ? location.search + "&" : "?") + "promo=1";
    return '<form class="cart-promo" data-promo-form action="/discount" method="get">' +
      '<label class="cart-promo__label" for="cart-promo-code">' +
        t("cart_promo_label", "Votre code de réduction") + "</label>" +
      '<div class="cart-promo__row">' +
        '<input id="cart-promo-code" class="cart-promo__input" name="code" type="text" ' +
          'value="' + String(p.code).replace(/"/g, "&quot;") + '" ' +
          'autocapitalize="characters" spellcheck="false" ' +
          'data-promo-retour="' + retour.replace(/"/g, "&quot;") + '">' +
        '<button type="submit" class="cart-promo__go">' + t("cart_promo_apply", "Appliquer") + "</button>" +
      "</div></form>";
  }

  /* Le formulaire ne peut pas poster tel quel : Shopify attend /discount/<CODE>, pas un
     paramètre. On construit l'URL au moment du clic, ce qui laisse le client corriger le
     code pré-rempli s'il en a un autre. */
  document.addEventListener("submit", function (e) {
    var f = e.target && e.target.closest && e.target.closest("[data-promo-form]");
    if (!f) return;
    e.preventDefault();
    var champ = f.querySelector(".cart-promo__input");
    var code = champ && champ.value.trim().toUpperCase();
    if (!code) return;
    var retour = (champ.getAttribute("data-promo-retour") || "/");
    /* ⛔ AVEC LA RACINE DE LANGUE. Sans elle, un client allemand qui saisit son code atterrit
       sur la racine FRANCAISE : il change de marche au moment de payer, et il le voit. */
    location.href = RACINE_LOCALE + "/discount/" + encodeURIComponent(code)
      + "?redirect=" + encodeURIComponent(retour);
  });

  /* ⛔⛔ LE TARIF PROFESSIONNEL S'APPLIQUE PAR UN CODE, POSE QUAND LE PANIER SE REND (Adrien,
     29/08/2026 : « la remise B2B doit s'appliquer a l'achat si ?pro=1 est dans l'url »).
     ⛔ POURQUOI PAS UNE REMISE AUTOMATIQUE : elle suit le PRODUIT dans le panier, jamais le
     parcours ni le client. Les affiches du catalogue sont les memes des deux cotes, donc une
     automatique aux taux pro les donnerait AUSSI au grand public. Un code ne s'applique que s'il
     est pose, et le parcours pro est le seul a le poser.
     ⛔ ET IL FAUT UNE NAVIGATION. `fetch('/discount/<CODE>')` rend 200 et suit la redirection,
     mais le panier ne bouge pas : mesure du 29/08, cinq affiches, remise inchangee avant et
     apres. Shopify lie le code a la session par la navigation, pas par la requete. On passe donc
     par `/discount/…?redirect=…&promo=1`, le meme chemin que le code promo juste au-dessus, qui
     rouvre le tiroir au retour : le professionnel VOIT sa remise avant de payer.
     ⚠️ UNE SEULE TENTATIVE PAR ETAT DE PANIER. Si Shopify refuse le code — minimum non atteint
     sur les articles eligibles, code retire — la navigation ne changerait rien et se rejouerait
     a l'infini. La cle de garde porte le code ET le nombre d'articles : changer le panier
     redonne droit a un essai, rester dessus n'en donne qu'un. */
  function proPalier(n) {
    var table = window.__proPaliers || [];
    var choisi = null;
    for (var i = 0; i < table.length; i += 1) if (n >= table[i].n) choisi = table[i];
    return choisi;
  }
  function proPoseLeTarif(cart) {
    try {
      if (!document.documentElement.hasAttribute("data-pro")) return;
      var p = proPalier(cart.item_count || 0);
      if (!p) return;
      /* ⛔ SHOPIFY ETIQUETTE LA REMISE AVEC LE CODE, PAS AVEC SON TITRE. Mesure du 29/08 sur un
         panier reel : la ligne s'appelle « PRO5-A7K », pas « Pro catalogue 5+ (-18 %) ». Compare
         au titre, ce test n'aurait JAMAIS reconnu une remise deja posee, et le tarif se serait
         repose a chaque changement de panier. */
      var deja = false;
      (cart.items || []).forEach(function (a) {
        (a.discounts || []).forEach(function (d) {
          if (String(d.title || "").toUpperCase() === p.code.toUpperCase()) deja = true;
        });
      });
      if (deja) return;
      /* ⛔⛔ LA GARDE EST DATEE, PAS DEFINITIVE. Elle est ecrite JUSTE AVANT la navigation, donc
         avant de savoir si celle-ci aboutit : si un autre script part en premier, ou si l'onglet
         se ferme, une garde definitive priverait ce panier de son tarif pour toute la session.
         Vingt secondes laissent une navigation aboutir et empechent la boucle serree d'un code
         que Shopify refuse. */
      var cle = "affichely:pro-tarif:" + p.code + ":" + (cart.item_count || 0);
      try {
        var vu = parseInt(sessionStorage.getItem(cle) || "0", 10);
        if (vu && Date.now() - vu < 20000) return;
        sessionStorage.setItem(cle, String(Date.now()));
      } catch (e) { return; }   /* sans memoire, on ne tente pas : le risque est une boucle */
      var retour = location.pathname + (location.search ? location.search + "&" : "?") + "promo=1";
      location.href = RACINE_LOCALE + "/discount/" + encodeURIComponent(p.code)
        + "?redirect=" + encodeURIComponent(retour);
    } catch (e) { /* jamais bloquer le rendu du panier pour une remise */ }
  }

  /* Retour de /discount : on rouvre le tiroir pour que la remise se voie tout de suite. */
  document.addEventListener("DOMContentLoaded", function () {
    if (!/[?&]promo=1(&|$)/.test(location.search)) return;
    try {
      var u = new URL(location.href);
      u.searchParams.delete("promo");
      history.replaceState(null, "", u.pathname + (u.search || "") + u.hash);
    } catch (e) { /* URL non supportée : le paramètre reste, sans conséquence */ }
    var ouvre = document.querySelector("[data-open-cart]");
    if (ouvre) ouvre.click();
  });

  /* L'economie venue des PRIX BARRES seuls : c'est elle, et elle seule, qui autorise a citer
     le taux de la campagne. Une remise de code est reelle mais porte SON taux a elle.
     ⛔⛔ ELLE SE MESURE CONTRE `original_price`, PAS CONTRE `final_price` (Adrien, 28/08/2026 :
     « je ne comprends pas quelle promo et prix degressif s'applique en B2C »). `final_price` est
     le prix APRES les remises de panier : cette fonction comptait donc la remise de lot, et
     `computeSavings` la rajoutait juste apres. Mesure sur un panier reel de 5 × « Le grain de la
     pierre » 30X40 : tarif 19,90, prix promo 16,90, remise de lot -15 % soit 12,65 €. La ligne
     « REDUCTION » annoncait **40,30 €** au lieu de 27,65 — exactement 27,65 + 12,65, la remise
     de lot payee deux fois. Le badge « -28 % » a cote, lui, etait juste : il se calcule
     autrement, et c'est ce desaccord entre deux chiffres voisins qui a rendu la page
     incomprehensible.
     ⚠️ ET CE N'EST PAS QU'UNE ADDITION FAUSSE : le nom de la fonction disait deja ce qu'elle
     devait mesurer — le prix BARRE seul. En lisant `final_price` elle mesurait autre chose que
     son nom, et son appelant lui faisait confiance. `cartHasPromo` s'en sert aussi : avec
     `final_price`, une simple remise de panier sur un article sans prix barre lui faisait
     annoncer « votre -25 % est applique », le mensonge meme que le commentaire d'en dessous dit
     avoir purge trois fois. */
  function compareAtSavings(cart) {
    var compareSave = 0;
    (cart.items || []).forEach(function (i) {
      var ca = compareAtUnit(i);
      var plein = i.original_price || i.price || i.final_price;
      if (ca > plein) compareSave += (ca - plein) * i.quantity;
    });
    return compareSave;
  }

  function computeSavings(cart) {
    return (cart.total_discount || 0) + compareAtSavings(cart);
  }

  /* ⛔ TROISIEME REPLI GLOBAL, ET LE DERNIER (12/08/2026). Les deux premiers ont ete purges le
     05/08 — `promoBadgeLabel`, puis le badge de ligne juste en dessous — pour la meme raison :
     les accessoires ne sont PAS dans la promo, et coller une remise sur un cadre facture plein
     tarif est une annonce de prix fausse. Celui-ci a survecu aux deux, dans une fonction voisine
     et sous un autre nom.
     CE QU'IL FAISAIT : un panier ne contenant qu'un cadre declenchait le message « Ajoute, votre
     -25 % est applique », juste avant le paiement, sur un article vendu plein tarif.
     LA REGLE, LA MEME QUE POUR LES DEUX AUTRES : une remise se LIT sur le panier, elle ne se
     deduit pas d'un drapeau de campagne pose sur la boutique entiere. `computeSavings` compare
     deja chaque ligne a son prix barre, et `total_discount` porte les remises Shopify : les
     deux repondent a la question, et elles y repondent juste. */
  /* ⛔ LE TOAST QUI CITE LE TAUX NE SORT QUE SUR LES PRIX BARRES (second audit, 12/08/2026).
     Il sortait pour TOUTE economie, remises de code comprises — or son texte cite le taux de la
     CAMPAGNE, substitue a __PCT__. Un client qui utilise le code -10 % de la popup de sortie,
     apres la fin de la campagne, lisait « votre -25 % est applique » : deux mensonges en un,
     le taux et l'existence meme de la promo. Le metachamp garde son taux apres la fin, donc le
     texte etait pret a mentir pour toujours.
     Une remise de code recoit le toast ordinaire ; le paiement, lui, affiche le vrai montant. */
  function cartHasPromo(cart) {
    return compareAtSavings(cart) > 0;
  }

  /* ⛔ « SOUVENT ACHETE AVEC » DISAIT N'IMPORTE QUOI, ET LE LIBELLE MENTAIT (Adrien,
     04/09/2026 : « les produits suggeres n'ont rien a voir avec l'affiche »).
     CE QU'IL Y AVAIT : `MURMURE_CART_UPSELL`, les 16 premieres affiches de
     `toutes-les-affiches` ecrites une fois dans le layout, donc les MEILLEURES VENTES, les
     memes pour tout le monde et sur toutes les pages. Sous une affiche de chambre d'enfant,
     la vignette proposait un olivier mediterraneen.

     CE QU'ON FAIT : on demande la PIECE de l'affiche au panier, puis les affiches de cette
     piece. `/cart.js` ne porte aucun metachamp, d'ou les deux vues (`?view=piece`, puis
     `?view=upsell`) : c'est le seul endroit d'ou Liquid repond a une question du navigateur.

     ⚠️ LA LISTE DES MEILLEURES VENTES RESTE, EN REPLI. Une affiche sans piece (10 sur 2 258),
     un reseau qui tombe, une piece sans stock : la vignette doit sortir quand meme. Ce qui
     change, c'est qu'elle n'est plus le PREMIER choix. */
  var UPSELL_MAX = 300, UPSELL_LOT = 15;
  var UPSELL_ETAT = null;
  var PIECE_CACHE = {};

  function texte(url) {
    var root = String(window.MURMURE_RACINE || '/').replace(/\/$/, '');
    if (root && url.indexOf(root + '/') !== 0) url = root + url;
    return fetch(url, { cache: 'no-cache' }).then(function (r) {
      if (!r.ok) throw new Error('Recommandations indisponibles');
      return r.text();
    });
  }

  function etatUpsell(cart) {
    var h = cart && cart.items && cart.items[0] && cart.items[0].handle;
    return UPSELL_ETAT && UPSELL_ETAT.handle === h ? UPSELL_ETAT : null;
  }

  function pickUpsell(cart) {
    var inCart = {}, selected = [], etat = etatUpsell(cart);
    (cart.items || []).forEach(function (i) { inCart[i.product_id] = 1; });
    // Tant que la piece a une suite, ses prochaines affiches passent avant le catalogue.
    var listes = etat && etat.produits.length
      ? (etat.catalogue || etat.fin ? [etat.produits, UPSELL] : [etat.produits])
      : [UPSELL];
    for (var l = 0; l < listes.length; l++) {
      var L = listes[l] || [];
      for (var n = 0; n < L.length; n++) {
        if (L[n] && L[n].variant_id && !inCart[L[n].id]) {
          selected.push(L[n]); inCart[L[n].id] = 1;
          if (selected.length === UPSELL_MAX) return selected;
        }
      }
    }
    return selected;
  }

  /* Une page de DONNEES a la fois. Liquid est pagine par 50 ; seules 15 cartes sont
     ajoutees au DOM a chaque passage. La fin explicite permet de traverser une page dont
     tous les produits sont indisponibles, personnalisables ou deja au panier. */
  function suiteUpsell(cart, cible) {
    var etat = etatUpsell(cart);
    if (!etat) return Promise.resolve();
    if (etat.requete) return etat.requete.then(function () { return suiteUpsell(cart, cible); });
    if (etat.fin || (etat.charge && pickUpsell(cart).length >= Math.min(cible, UPSELL_MAX))) return Promise.resolve();
    if (!etat.page) {
      if (etat.catalogue) { etat.fin = true; return Promise.resolve(); }
      etat.catalogue = true; etat.page = 1; etat.filtre = '';
    }
    var page = etat.page;
    var url = window.MURMURE_CART_UPSELL_URL || '/collections/toutes-les-affiches';
    etat.requete = texte(url + '?view=upsell&page=' + page + etat.filtre).then(function (textePage) {
      if (UPSELL_ETAT !== etat) return;
      var donnees = JSON.parse(textePage);
      if (!Array.isArray(donnees)) throw new Error('Recommandations invalides');
      var meta = donnees.find(function (p) { return p && Object.prototype.hasOwnProperty.call(p, '_next_page'); });
      var next = meta && Number(meta._next_page);
      etat.page = next > page ? next : null;
      etat.charge = true;
      var connus = {};
      etat.produits.forEach(function (p) { connus[p.id] = true; });
      donnees.forEach(function (p) {
        if (p && p.id && p.variant_id && !connus[p.id]) {
          etat.produits.push(p); connus[p.id] = true;
        }
      });
    }).then(function () { etat.requete = null; }, function (erreur) {
      etat.requete = null;
      throw erreur; // Ne pas avancer la page : le prochain defilement pourra reessayer.
    });
    return etat.requete.then(function () {
      if (UPSELL_ETAT === etat) return suiteUpsell(cart, cible);
    });
  }

  /* Une seule initialisation par affiche, partagee entre les rendus du panier. Une reponse
     tardive ne remplace jamais les recommandations d'un autre produit. */
  function majUpsellPiece(cart, redessine) {
    var h = cart && cart.items && cart.items[0] && cart.items[0].handle;
    if (!h) { UPSELL_ETAT = null; return Promise.resolve(); }
    var etat = etatUpsell(cart);
    if (etat && etat.pret) return Promise.resolve();
    if (!etat) {
      etat = UPSELL_ETAT = { handle: h, produits: [], page: 1, filtre: '', catalogue: false, charge: false, fin: false };
      etat.initialisation = (PIECE_CACHE[h] !== undefined
        ? Promise.resolve(PIECE_CACHE[h])
        : texte('/products/' + encodeURIComponent(h) + '?view=piece').then(function (t) {
            var ids = String(t || '').trim().split(',').map(function (x) { return x.trim(); }).filter(Boolean);
            PIECE_CACHE[h] = ids;
            return ids;
          }).catch(function () { return []; })
      ).then(function (ids) {
        if (UPSELL_ETAT !== etat) return;
        etat.catalogue = !ids.length;
        etat.filtre = ids.map(function (id) {
          return '&filter.p.m.custom.piece=gid%3A%2F%2Fshopify%2FMetaobject%2F' + encodeURIComponent(id);
        }).join('');
        return suiteUpsell(cart, UPSELL_LOT);
      }).catch(function () { /* Les premieres cartes restent utilisables hors reseau. */ })
        .then(function () { etat.pret = true; });
    }
    return etat.initialisation.then(function () {
      if (UPSELL_ETAT === etat && typeof redessine === 'function') redessine();
    });
  }

  function arreterUpsell(conteneur) {
    if (conteneur && conteneur._arreterUpsell) conteneur._arreterUpsell();
  }

  /* Observer la derniere vraie carte : aucune carte vide ne s'ajoute au slider mobile.
     L'observateur tient compte des ancetres qui defilent, horizontalement ou verticalement.
     Le scroll sert aussi de nouvelle tentative si le reseau avait echoue. */
  function suivreUpsell(conteneur, cart) {
    arreterUpsell(conteneur);
    var bloc = conteneur.querySelector('.cart-upsell');
    var liste = bloc && bloc.querySelector('.cart-upsell__list');
    if (!liste) return;
    var actif = true, occupe = false, observateur, dernier, retryApres = 0;
    function observerFin() {
      if (observateur) observateur.disconnect();
      dernier = liste.lastElementChild;
      if (dernier && liste.children.length < UPSELL_MAX && observateur) observateur.observe(dernier);
    }
    function ajouter() {
      if (!actif || occupe || Date.now() < retryApres || liste.children.length >= UPSELL_MAX) return;
      occupe = true;
      var cible = Math.min(UPSELL_MAX, liste.children.length + UPSELL_LOT);
      majUpsellPiece(cart).then(function () { return suiteUpsell(cart, cible); }).then(function () {
        if (!actif || !bloc.isConnected) return;
        var presents = {};
        liste.querySelectorAll('[data-upsell-product]').forEach(function (el) { presents[el.getAttribute('data-upsell-product')] = true; });
        var produits = pickUpsell(cart).filter(function (p) { return !presents[p.id]; }).slice(0, cible - liste.children.length);
        if (!produits.length) return;
        var fragment = document.createElement('div');
        fragment.innerHTML = renderUpsellHtml(cart, produits);
        var cartes = fragment.querySelector('.cart-upsell__list');
        if (cartes) while (cartes.firstElementChild) liste.appendChild(cartes.firstElementChild);
        observerFin();
      }).catch(function () { retryApres = Date.now() + 2000; }).then(function () { occupe = false; });
    }
    function auDefilement() {
      if (!dernier) return;
      var r = dernier.getBoundingClientRect(), b = bloc.getBoundingClientRect(), l = liste.getBoundingClientRect();
      if (r.top < Math.min(b.bottom, window.innerHeight) + 200 && r.bottom > Math.max(b.top, 0)
        && r.left < Math.min(l.right, window.innerWidth) + 200 && r.right > Math.max(l.left, 0)) ajouter();
    }
    if ('IntersectionObserver' in window) observateur = new IntersectionObserver(function (entrees) {
      if (entrees.some(function (e) { return e.isIntersecting; })) ajouter();
    }, { rootMargin: '200px' });
    bloc.addEventListener('scroll', auDefilement, { passive: true, capture: true });
    window.addEventListener('scroll', auDefilement, { passive: true });
    conteneur._arreterUpsell = function () {
      actif = false;
      if (observateur) observateur.disconnect();
      bloc.removeEventListener('scroll', auDefilement, true);
      window.removeEventListener('scroll', auDefilement);
      conteneur._arreterUpsell = null;
    };
    observerFin();
  }

  /* ⛔ ON NE REDESSINE QUE LA VIGNETTE, PAS LE PANIER. Rappeler `renderCart` aurait remplace
     les lignes pendant que le client y touche, et remis la piste a zero. On echange le seul
     noeud `.cart-upsell`, dans le conteneur qui l'a. */
  function remplacerUpsell(conteneur, cart) {
    if (!conteneur || conteneur._upsellCart !== cart) return;
    arreterUpsell(conteneur);
    var html = renderUpsellHtml(cart);
    var trio = conteneur.querySelector("[data-cart-trio-slot]");
    if (trio) trio.outerHTML = renderTrioHtml(cart);
    var vieux = conteneur.querySelector(".cart-upsell");
    if (!html) { if (vieux) vieux.remove(); return; }
    var t = document.createElement("div");
    t.innerHTML = html;
    var neuf = t.firstElementChild;
    if (!neuf) return;
    if (vieux) vieux.replaceWith(neuf);
    else conteneur.appendChild(neuf);
    suivreUpsell(conteneur, cart);
  }

  // Échappement HTML pour tout ce qui vient du panier / upsell (titres, props, URLs).
  // Sans ça, une propriété `<img onerror=…>` injectée via /cart/add.js s'exécutait dans le tiroir.
  function escHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* ⛔ LA BARRE EST CONSTRUITE ICI, ET NULLE PART AILLEURS. Elle vivait au milieu de `renderCart`,
     donc uniquement dans le tiroir : la page /cart ne la montrait pas, alors que c'est l'ecran
     ou l'on decide d'ajouter une affiche de plus (Adrien, 11/08/2026). La recopier aurait fait un
     cinquieme doublon dans la meme journee ; elle sort en fonction, les deux ecrans l'appellent.
     ⚠️ Le seuil vient de `SHIP.threshold`, pas d'un nombre ecrit ici : il se regle dans le theme,
     et deux valeurs en dur finiraient par diverger comme le reste. */
  function shipBarHtml(total) {
    var free = total >= FREE_SHIP;
    var left = Math.max(0, FREE_SHIP - total);
    var pct = FREE_SHIP > 0 ? Math.min(100, (total / FREE_SHIP) * 100) : 100;
    var msg = free
      ? t("shipping_free", "Offerte ✓")
      : t("cart_ship_left", "Plus que __AMT__ pour la livraison offerte").replace("__AMT__", money(left));
    return '<div class="cart-ship">' +
      '<div class="cart-ship__track" aria-hidden="true"><div class="cart-ship__fill" style="width:' + pct + '%"></div></div>' +
      '<p class="cart-ship__msg' + (free ? " is-free" : "") + '">' + msg + "</p>" +
      "</div>";
  }

  function renderTrioHtml(cart) {
    return window.afCartTrio ? window.afCartTrio.slot(cart, pickUpsell(cart).slice(0, 3)) : "";
  }

  function renderUpsellHtml(cart, produits) {
    var products = produits || pickUpsell(cart).slice(0, UPSELL_LOT);
    if (!products.length) return "";
    var cards = products.map(function (u) {
      // Pas de badge promo ici : ça faisait ressembler l'upsell à une ligne panier.
      /* ⛔ ET LE PARCOURS PRO N'A NI PRIX BARRE NI TTC, MEME ICI. Cette vignette vit DANS le tiroir,
         sous des lignes en hors taxes : mesure du 22/08/2026, elle affichait « 14,90 € 12,60 € »
         juste sous « 264,17 € HT ». Une suggestion d'achat qui ne parle pas la meme monnaie que le
         panier au-dessus d'elle se lit comme une erreur de prix.
         ⚠️ Le prix pro part du prix PLEIN, comme partout ailleurs : c'est `compare_at` quand il
         existe, le prix courant sinon. */
      var proPlein = (u.compare_at && u.compare_at > u.price) ? u.compare_at : u.price;
      var priceHtml = PRO_HT
        ? '<span class="cart-upsell__now">' + moneyAff(proPlein) + "</span>"
        : '<span class="cart-upsell__now">' + money(u.price) + "</span>";
      if (!PRO_HT && u.compare_at && u.compare_at > u.price) {
        priceHtml = "<s>" + money(u.compare_at) + '</s> <span class="cart-upsell__now">' + money(u.price) + "</span>";
      }
      var unlocksFree = cart.total_price < FREE_SHIP && (cart.total_price + u.price) >= FREE_SHIP;
      var hint = unlocksFree
        ? '<p class="cart-upsell__hint">' + t("cart_upsell_free_ship", "Ajoutez-la → livraison offerte") + "</p>"
        : "";
      var uUrl = escHtml(u.url || "#");
      var uImg = escHtml(u.image || "");
      var uTitle = escHtml(u.title || "");
      return '<article class="cart-upsell__card" data-upsell-product="' + escHtml(u.id) + '">' +
        '<a class="cart-upsell__img" href="' + uUrl + '" aria-label="' + uTitle + '"><img src="' + uImg + '" alt="" loading="lazy" width="160" height="210"></a>' +
        '<div class="cart-upsell__meta">' +
        '<a class="cart-upsell__title" href="' + uUrl + '">' + uTitle + "</a>" +
        '<div class="cart-upsell__price">' + priceHtml + "</div>" + hint +
        '</div>' +
        '<a class="cart-upsell__add" href="' + uUrl + '">' + t("cart_upsell_view", "Voir") + '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 13 13 3M6 3h7v7"/></svg></a>' +
        "</article>";
    }).join('');
    return '<aside class="cart-upsell" aria-label="' + escHtml(t("cart_upsell_title", "Souvent acheté avec")) + '">' +
      '<h2 class="cart-upsell__label">' + t("cart_upsell_title", "Souvent acheté avec") + '</h2>' +
      '<div class="cart-upsell__list">' + cards + '</div></aside>';
  }

  /* Panier vide : un tiroir vide est un cul-de-sac, on y propose les tendances.
     ⚠️ Ce bloc doit se lire comme une VITRINE, pas comme un contenu de panier. D'où le trait
     de séparation, le sur-titre, et surtout la phrase qui le dit en toutes lettres : sans elle,
     six affiches empilées sous « votre panier est vide » se lisent comme une contradiction.
     Les cartes viennent de la vue `rail`, donc du même snippet que partout ailleurs : les
     réécrire ici en ferait une seconde version de la carte produit, qui finirait par diverger. */
  /* L'icône du panier vide : un cadre vide, légèrement de travers, avec son clou.
     Le cercle qu'elle remplace ne disait rien du tout. Un cadre encore vide dit la même chose
     que la phrase en dessous, mais dans le langage de la maison, et l'inclinaison suffit à
     donner le ton sans tomber dans la mascotte. */
  function marqueVide() {
    /* ⛔ UN CADRE VIDE, D'APLOMB, AU TRAIT. Le dessin d'avant etait incline de cinq degres et
       rempli : le vocabulaire d'un pictogramme d'application. Toute la fiche produit est passee
       au trait grave et a l'angle vif ; le panier vide, seul ecran ou l'on n'a que ce dessin a
       regarder, etait reste en arriere. Deux fils partant d'un clou, un cadre, son
       passe-partout, et rien dedans : c'est exactement ce que dit un panier vide. */
    return '<svg class="cart-empty__mark" viewBox="0 0 64 64" aria-hidden="true" focusable="false">' +
      '<circle cx="32" cy="7.5" r="1.9"/>' +
      '<path d="M32 9.4 16.8 21M32 9.4 47.2 21"/>' +
      '<rect x="16" y="21" width="32" height="32"/>' +
      '<rect x="21.5" y="26.5" width="21" height="21"/>' +
      '</svg>';
  }

  function tendancesVides() {
    return '<div class="cart-tend" data-cart-tend hidden>' +
      '<div class="cart-tend__head">' +
        '<span class="cart-tend__eyebrow">' + escHtml(t("cart_discover_trends", "Découvrez les tendances")) + '</span>' +
      '</div>' +
      '<div class="cart-tend__grid" data-cart-tend-grid></div>' +
      '<div class="cart-tend__sentinelle" data-cart-tend-fin aria-hidden="true"></div></div>';
  }
  /* Défilement infini : le tiroir est la seule surface qui défile, c'est donc lui la racine de
     l'observateur. Sans `root`, l'IntersectionObserver se cale sur la fenêtre et la sentinelle
     est vue comme visible en permanence, ce qui déclenche toutes les pages d'un coup.

     ⛔ L'ETAT EST LOCAL A CHAQUE BLOC, PAS AU MODULE. Il vivait dans trois variables partagées,
     ce qui tenait tant qu'un seul bloc existait. La page introuvable en pose un second, dans la
     page : ouvrir le tiroir par-dessus remettait le compteur à zéro et les deux se seraient
     renvoyé les mêmes pages. Un compteur par bloc, et ils s'ignorent.

     `depart` permet à une page d'avoir déjà rendu ses premières cartes côté serveur : elle
     annonce la dernière page servie, le défilement reprend à la suivante. */
  function remplirTendances(body) {
    var bloc = body.querySelector("[data-cart-tend]");
    var grille = body.querySelector("[data-cart-tend-grid]");
    var fin = body.querySelector("[data-cart-tend-fin]");
    if (!bloc || !grille) return;
    var page = parseInt(bloc.getAttribute("data-cart-tend-page") || "0", 10) || 0;
    var fini = false, occupe = false;
    var base = t("cart_trends_url", "/collections/tendances-deco");

    function charger() {
      if (occupe || fini) return;
      occupe = true;
      page += 1;
      fetch(base + "?view=rail&page=" + page, { headers: { "X-Requested-With": "fetch" } })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function (html) {
          var bac = document.createElement("div");
          bac.innerHTML = html;
          // Le marqueur de fin de la vue `rail` : sans lui on redemanderait des pages vides.
          if (bac.querySelector("[data-rail-fin]")) fini = true;
          var cartes = bac.querySelectorAll(".prod-card");
          if (!cartes.length) { fini = true; occupe = false; return; }
          for (var i = 0; i < cartes.length; i++) grille.appendChild(cartes[i]);
          bloc.hidden = false;
          occupe = false;
        })
        .catch(function () { fini = true; occupe = false; });
    }

    // Une grille déjà servie par le serveur n'a rien à recharger : on attend le défilement.
    if (!grille.querySelector(".prod-card")) charger();
    if (fin && "IntersectionObserver" in window) {
      var racine = body.classList && body.classList.contains("cart-drawer__body")
        ? body
        : (body.closest ? body.closest(".cart-drawer__body") : null);
      new IntersectionObserver(function (entrees) {
        if (entrees[0] && entrees[0].isIntersecting) charger();
      }, { root: racine, rootMargin: "300px" }).observe(fin);
    }
  }

  /* Hors du tiroir, une page peut poser la même vitrine : la page introuvable le fait. Elle
     rend ses premières cartes côté serveur (une page vide qui attend le JS ne dit rien à qui
     arrive sur une URL morte), puis le défilement prend la suite. */
  document.addEventListener("DOMContentLoaded", function () {
    var enPage = document.querySelector("[data-tend-infini]");
    if (enPage) remplirTendances(enPage);
  });

  /* ⛔ LA PAGE /cart DIT LES MEMES TROIS CHOSES QUE LE TIROIR : barre de livraison offerte,
     « souvent achete avec », moyens de paiement (Adrien, 11/08/2026 : « il manque aussi la barre
     de livraison gratuite et souvent achete avec et les icones de paiement par rapport au drawer
     panier »). Les icones sont du Liquid, elles arrivent par un snippet partage ; ces deux-la
     sont construites en JS a partir de /cart.js, donc elles se remplissent ici, PAR LES MEMES
     FONCTIONS que le tiroir. Aucune ligne de rendu n'est ecrite deux fois.
     ⚠️ ET ON NE PASSE PAS PAR `renderCart` : elle ecrit dans #drawer-body, #drawer-foot et
     #drawer-ship, qui sont au tiroir. L'appeler pour la page reviendrait a laisser un ecran
     ecrire dans l'autre, ce qui a deja coute le prix barre du tiroir aujourd'hui. */
  document.addEventListener("DOMContentLoaded", function () {
    var page = $(".cart-page");
    if (!page) return;
    var slotShip = $("#page-ship", page), slotUp = $("#page-upsell", page);
    if (!slotShip && !slotUp) return;
    fetchCart().then(function (cart) {
      if (!cart || !cart.item_count) return;
      if (slotShip) { slotShip.hidden = false; slotShip.innerHTML = shipBarHtml(cart.total_price); }
      if (slotUp) {
        slotUp._upsellCart = cart;
        var html = renderUpsellHtml(cart);
        if (html) { slotUp.hidden = false; slotUp.innerHTML = renderTrioHtml(cart) + html; suivreUpsell(slotUp, cart); }
        majUpsellPiece(cart, function () { slotUp.hidden = false; remplacerUpsell(slotUp, cart); });
      }
    }).catch(function () {});
  });

  /* Le total du panier, en centimes, tel qu'il vient d'etre rendu : c'est lui
     qu'on envoie avec le passage au paiement. */
  var dernierTotalPanier = 0;
  /* L'instant du dernier rendu reussi : il sert a ne pas redemander un panier qu'on vient
     d'ecrire (voir `resyncPanier`). Zero au chargement, donc la premiere ouverture du tiroir
     resynchronise toujours. */
  var dernierRendu = 0;
  function renderCart(cart) {
    /* Rien n'est ecrit tant qu'on ne tient pas un panier entier : le compteur, la barre et le
       pied doivent bouger ensemble ou pas du tout. Un rendu a moitie fait est PIRE qu'un ecran
       fige, parce qu'il a l'air a jour. */
    if (!cart || !Array.isArray(cart.items)) return;
    dernierRendu = Date.now();
    proPoseLeTarif(cart);
    dernierTotalPanier = Number(cart.total_price) || 0;
    renderShipBar(cart.total_price);
    var countEls = $$("[data-cart-count]");
    countEls.forEach(function (e) { e.textContent = cart.item_count; e.style.display = cart.item_count > 0 ? "inline-flex" : "none"; });
    var label = $("#drawer-count"); if (label) label.textContent = "(" + cart.item_count + ")";
    var body = $("#drawer-body"), foot = $("#drawer-foot"), shipSlot = $("#drawer-ship");
    if (!body) return;
    arreterUpsell(body);
    body._upsellCart = cart;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty">' +
        marqueVide() +
        '<div class="cart-empty__title">' + t("cart_empty", "Votre panier est vide") + '</div>' +
        '<p class="cart-empty__text">' + t("cart_empty_sub", "Créez une affiche personnalisée ou explorez nos collections.") + '</p>' +
        '<button class="cart-empty__button" data-close-cart>' + t("cart_continue", "Continuer mes achats") + '</button></div>' +
        tendancesVides();
      remplirTendances(body);
      if (foot) foot.innerHTML = "";
      if (shipSlot) { shipSlot.innerHTML = ""; shipSlot.hidden = true; }
      var payEmpty = $("#cart-pay");
      if (payEmpty) payEmpty.hidden = true;
      return;
    }
    var items = cart.items.map(function (i, idx) {
      /* ⛔ « DEFAULT TITLE » N'EST PAS UNE OPTION. Shopify donne quand meme une
         variante aux produits qui n'en ont pas, et la nomme « Title / Default
         Title » : le crochet d'accrochage mural affichait donc « Default Title »
         sous son nom dans le panier (Adrien, 03/08/2026). Le signal fiable est
         `variant_title`, nul dans ce cas precis, pose par Shopify et independant de
         la langue ; se fier au texte « Default Title » aurait laisse passer les
         autres langues. Le cadre, lui, a de vraies options et les garde. */
      /* ⛔ UNE LIGNE SUR MESURE N'A PAS DE VARIANTE A MONTRER. Sa variante EST son palier de
         prix (« 20,00 € ») : affichee, elle repetait le prix deux lignes plus bas et se lisait
         comme une erreur. Ce que le client doit lire, ce sont ses cotes et son affiche, qui
         voyagent en proprietes visibles. */
      var surMesure = !!(i.properties && i.properties._sm_produit);
      var opts = (i.variant_title == null || surMesure) ? ""
        : (i.options_with_values || []).map(function (o) { return escHtml(o.value); }).join(" · ");
      var props = "";
      if (i.properties) {
        for (var k in i.properties) {
          if (k.charAt(0) !== "_" && i.properties[k]) props += " · " + escHtml(i.properties[k]);
        }
      }
      var lineDiscount = (i.original_line_price || 0) > i.final_line_price;
      var caUnit = compareAtUnit(i);
      var unitPrice = i.final_price || Math.round(i.final_line_price / Math.max(1, i.quantity));
      /* ⚠️ DEUX BADGES DIFFERENTS SOUS LE MEME NOM. Celui-ci vient du prix barre, c'est-a-dire de
         la promo du grand public : le parcours pro l'ignore. Celui du bloc suivant vient d'une
         VRAIE remise de panier, la degressive : elle le concerne, et elle reste. */
      /* ⛔⛔ LE BADGE DIT L'ECART ENTRE LES DEUX PRIX AFFICHES, ET RIEN D'AUTRE (Adrien,
         28/08/2026 : « je ne comprends pas quelle promo et prix degressif s'applique en B2C »).
         Il y avait DEUX calculs pour une meme ligne, et c'est le premier arrive qui gagnait :
         celui-ci, l'ecart au prix barre (-28 % sur le panier mesure), et un repli quelques lignes
         plus bas, l'ecart de la remise de panier (-15 %). Le premier ne rend rien tant que
         `__caCache` est vide — il se remplit apres coup — donc le meme panier affichait -28 % ou
         -15 % selon l'instant. Deux nombres pour une seule ligne, dont un seul correspondait aux
         deux montants ecrits juste a cote.
         ⚠️ LA REFERENCE EST CELLE QU'ON BARRE : `priceWas` prend le prix barre s'il existe, sinon
         le prix de ligne d'origine. Le badge lit la MEME valeur, sinon il decrit un rapport que
         personne ne voit. */
      var refUnit = Math.max(caUnit, i.original_price || 0);
      var badgeTxt = PRO_HT ? "" : promoBadgeLabel(refUnit, unitPrice);
      /* ⛔ SECOND REPLI GLOBAL, ET IL A SURVECU AU PREMIER. `promoBadgeLabel` a ete purgee de son
         repli sur PROMO_ON le 05/08/2026, mais celui-ci, ecrit juste apres et en dur, continuait
         de coller « -25 % » a toute ligne des que la campagne etait active. Le panier annoncait
         donc une remise sur un cadre facture plein tarif, les accessoires n'etant pas dans la
         promo. Une annonce de prix fausse, lue juste avant le paiement.
         Une remise de PANIER (Shopify) est reelle et merite son badge, mais son taux se CALCULE
         sur la ligne : le supposer a 25 % etait deja faux pour toute autre remise. */
      /* ⚠️ LE REPLI QUI VIVAIT ICI EST PARTI AVEC LA COURSE. Il calculait l'ecart de la remise de
         PANIER seule, ce qui donnait un second taux pour la meme ligne : sur le panier mesure du
         28/08, -15 % a cote d'un « 71,85 € 99,50 € » dont l'ecart est de 28 %. `refUnit`
         ci-dessus couvre desormais les deux cas — prix barre, remise de panier, ou les deux — et
         il n'y a plus qu'un seul chemin, donc plus rien a departager. */
      // Affiche perso : la vignette est la photo déposée (_perso_preview / _perso_url),
      // pas l'image produit (souvent vide). Le resize _160x200 ne marche que sur le CDN Shopify.
      var lineProps = i.properties || {};
      /* ⛔ ET SA VIGNETTE VIENT DE L'AFFICHE, pas du produit-support, qui n'a pas d'image : le
         panier montrait un carre vide juste avant le paiement.
         ⚠️ LA PROPRIETE EST ECRITE PAR L'ACHETEUR : on n'accepte que ce qui a la forme d'une
         image de notre CDN. N'importe qui peut poster vers /cart/add.js avec la propriete de
         son choix, et un `src` arbitraire ferait charger une image d'un autre domaine sur notre
         page. Meme prudence que l'echappement des proprietes, pour la meme raison. */
      var smImg = surMesure && /^(https?:)?\/\/[^"'<>\s]*\/cdn\/shop\//.test(lineProps._sm_image || "")
        ? lineProps._sm_image : "";
      var imgSrc = smImg || lineProps._perso_preview || lineProps._perso_url || i.image || "";
      if (imgSrc && /cdn\.shopify\.com|\/cdn\/shop\//.test(imgSrc)) {
        imgSrc = imgSrc.replace(/(\.[a-z]+)(\?|$)/i, "_160x200$1$2");
      }
      imgSrc = escHtml(imgSrc);
      /* ⚠️ ET SON LIEN MENE A L'AFFICHE, pas a la fiche technique du support. Meme prudence :
         on n'accepte qu'un chemin RELATIF de notre boutique, jamais une adresse complete, qui
         ferait de notre panier un tremplin vers un autre domaine. */
      var smUrl = surMesure && /^\/[^\/\\]/.test(lineProps._sm_url || "") ? lineProps._sm_url : "";
      var lineUrl = escHtml(smUrl || i.url || "#");
      var title = escHtml(i.product_title || "");
      /* Le prix barre et le badge disent la promo du grand public : le parcours pro l'ignore.
         La remise degressive, elle, reste dite dans le total (« Reduction »). */
      var showSale = PRO_HT ? false : (lineDiscount || (caUnit > unitPrice));
      var sizeLabel = (opts || "").replace(/\s*·\s*/g, " · ");
      var metaExtra = props ? String(props).replace(/^\s*·\s*/, "") : "";
      var priceNow = moneyAff(i.final_line_price);
      var priceWas = showSale
        ? moneyAff(caUnit > unitPrice ? caUnit * i.quantity : i.original_line_price)
        : "";
      // Structure type galerie (réf. Desenio) :
      // image | titre + taille + prix + badge
      //       | qty noire  ……  poubelle
      return '<div class="cart-line" data-variant="' + escHtml(i.variant_id) + '">' +
        '<a class="cart-line__image" href="' + lineUrl + '">' +
        (imgSrc ? '<img src="' + imgSrc + '" alt="">' : "") + "</a>" +
        '<div class="cart-line__main">' +
          '<div class="cart-line__head">' +
            '<div class="cart-line__info">' +
              '<a class="cart-line__title" href="' + lineUrl + '">' + title + "</a>" +
              (sizeLabel || metaExtra
                ? '<div class="cart-line__meta">' + sizeLabel + (metaExtra ? (sizeLabel ? " · " : "") + metaExtra : "") + "</div>"
                : "") +
              '<div class="cart-line__price' + (showSale ? " is-sale" : "") + '">' +
                '<span class="cart-line__now">' + priceNow + "</span>" +
                (priceWas ? "<s>" + priceWas + "</s>" : "") +
              "</div>" +
            "</div>" +
            (badgeTxt ? '<span class="cart-line__badge">' + escHtml(badgeTxt) + "</span>" : "") +
          "</div>" +
          '<div class="cart-line__bottom">' +
            '<div class="cart-line__qty">' +
              '<button type="button" data-line="' + (idx + 1) + '" data-qty="' + (i.quantity - 1) + '" aria-label="' + escHtml(t("cart_qty_less", "Moins")) + '">−</button>' +
              '<span>' + i.quantity + "</span>" +
              '<button type="button" data-line="' + (idx + 1) + '" data-qty="' + (i.quantity + 1) + '" aria-label="' + escHtml(t("cart_qty_more", "Plus")) + '">+</button>' +
            "</div>" +
            '<button type="button" class="cart-line__remove" data-remove="' + (idx + 1) + '" aria-label="' + escHtml(t("cart_remove", "Retirer")) + '">' +
              '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                '<path d="M4 7h16"/><path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/><path d="M7 7l1 13h8l1-13"/><path d="M10 11v6M14 11v6"/>' +
              "</svg>" +
            "</button>" +
          "</div>" +
        "</div></div>";
    }).join("");
    body.innerHTML = '<div class="cart-lines">' + items + renderTrioHtml(cart) + "</div>" + renderUpsellHtml(cart);
    suivreUpsell(body, cart);
    majUpsellPiece(cart, function () { remplacerUpsell(body, cart); });

    // Barre livraison offerte : tout en haut de la vue panier (sous le titre).
    if (shipSlot) {
      shipSlot.hidden = false;
      shipSlot.innerHTML = shipBarHtml(cart.total_price);
    }
    if (foot) {
      /* ⛔⛔ `free` ETAIT DECLARE DANS LE BLOC DE LA BARRE DE LIVRAISON, ET LE PIED S'EN SERVAIT.
         En sortant la barre en fonction (`shipBarHtml`), j'ai emporte le `var free` avec elle :
         `shipRowRight` plus bas levait un ReferenceError, tout le `if (foot)` mourait, et le
         tiroir partait EN PRODUCTION sans total, sans « Passer commande » et sans les icones de
         paiement. `enrichCompareAt` est appele apres ce bloc : il ne tournait plus non plus, d'ou
         les prix barres et les badges disparus. Un seul symptome visible, une seule cause, et
         elle bloquait l'achat depuis le tiroir. Releve par Adrien, 11/08/2026.
         ⚠️ LA LECON : extraire un bloc, c'est verifier ce que la SUITE lisait dedans. Une
         variable de fonction n'appartient pas au bloc ou elle est ecrite, elle appartient a la
         fonction entiere, et rien ne le signale a la lecture. Le banc `pied-tiroir.test.js`
         execute desormais `renderCart` pour de vrai plutot que de relire le fichier. */
      var free = cart.total_price >= FREE_SHIP;
      var savings = computeSavings(cart);
      /* ⛔⛔ DANS LE PARCOURS PROFESSIONNEL, LE BOUTON FAIT SE DECLARER (Adrien, 23/08/2026 :
         « on peut meme oublier la creation de compte et simplement mettre "commander en tant que
         professionnel" dans le CTA, et le CTA secondaire particuliers en dessous »).
         C'est la reponse a un probleme de PUBLICITE, pas de mise en page : un particulier qui
         clique une annonce B2B et achete ici nourrit l'apprentissage de la campagne, qui se met
         alors a chercher des particuliers. Le compte obligatoire aurait filtre, au prix d'un
         frein sur les vrais professionnels — refuse. Un mot qui demande de se declarer ne coute
         rien a qui l'est, et fait reculer qui ne l'est pas.
         ⚠️ LE MOT NE DEPEND PAS DU NOMBRE D'ARTICLES ici : « Commander mon affiche » /
         « mes affiches » decrit la marchandise, celui-ci decrit QUI commande, et cela ne se met
         pas au pluriel. */
      var pro = document.documentElement.getAttribute("data-pro") === "1";
      var ctaLabel = pro
        ? t("cart_checkout_pro", "Commander en tant que professionnel")
        : (cart.item_count === 1
          ? t("cart_checkout_one", "Commander mon affiche")
          : t("cart_checkout_other", "Commander mes affiches"));
      /* `is-free` porte la même classe et la même couleur que la barre du haut
         (`.cart-ship__msg.is-free`) : les deux disent la même chose, elles se lisent pareil.
         La classe est posée ici, jamais le texte : la phrase vient des locales, donc les
         treize langues changent de couleur du même geste.
         ⚠️ CETTE COULEUR EST LE ROUGE DEPUIS LE 15/08/2026 (Adrien : « mets "Livraison
         offerte ✓" en rouge dans cart drawer », tous appareils). Elle était verte avant, et ce
         commentaire le disait encore : la teinte se lit dans `base.css`, pas ici. */
      var shipRowRight = free
        ? '<strong class="is-free">' + t("shipping_free", "Offerte ✓") + "</strong>"
        : "<strong>" + t("shipping_price_from", "dès __AMT__").replace("__AMT__", money(SHIP_FROM)) + "</strong>";
      var hasPerso = (cart.items || []).some(function (i) {
        return i.properties && (i.properties._perso || i.properties._perso_url);
      });
      var trustLine = hasPerso
        ? t("cart_reassure_custom", "Produit personnalisé : non repris")
        : t("cart_reassure_returns", "Retours sous 30 jours") + " · " + t("cart_reassure_atelier", "Atelier de Fayence");
      foot.innerHTML = '<div class="cart-drawer__foot">' +
        '<div class="cart-totals">' +
          (savings > 0
            ? '<div class="cart-totals__row cart-totals__row--save"><span>' + t("cart_reduction", "Réduction") + "</span><strong>−" + moneyAff(savings) + "</strong></div>"
            : "") +
          '<div class="cart-totals__row cart-totals__row--sub"><span>' + t("cart_subtotal", "Sous-total") + '</span><strong>' + moneyAff(cart.total_price) + "</strong></div>" +
        "</div>" +
        '<div class="cart-totals__ship"><span>' + t("shipping", "Livraison") + "</span>" + shipRowRight + "</div>" +
        promoBloc(cart) +
        '<a href="/checkout" class="cart-checkout">' + ctaLabel + "</a>" +
        /* ⛔ LA PORTE DE SORTIE EST SOUS LE BOUTON, PAS AILLEURS. C'est le dernier ecran avant le
           paiement : c'est la que quelqu'un qui n'est pas professionnel s'en rend compte, et il
           doit pouvoir partir sans perdre son panier. `?pro=0` retire le drapeau de session ; le
           panier, lui, est le MEME objet des deux cotes — meme boutique, memes variantes, le hors
           taxes n'etant qu'un affichage. Il n'y a donc rien a transferer, et c'est pour ca que
           cette sortie ne coute rien.
           ⚠️ IL NE PORTE PAS `.cart-checkout` : cette classe est ce que guette l'ecouteur de
           mesure du tunnel, quelques centaines de lignes plus bas. Un clic de SORTIE compte comme
           un depart au paiement aurait fausse le taux, en le gonflant de ceux qui renoncent. */
        (pro
          ? '<a href="/cart?pro=0" class="cart-particulier">'
            + t("cart_suis_particulier", "Je suis un particulier") + "</a>"
          : "") +
        '<p class="cart-trust">' + trustLine + "</p>" +
        "</div>";
      var pay = $("#cart-pay");
      if (pay) pay.hidden = false;
    }
    enrichCompareAt(cart);
  }

  // Prix barré dans le panier : /cart.js n'expose pas compare_at_price. On le lit dans le
  // JSON produit (mis en cache par variante) et on injecte le prix de référence rayé quand
  // il dépasse le prix payé. Rendu d'abord sans, puis enrichi en asynchrone.
  function enrichCompareAt(cart) {
    if (!cart.items || !cart.items.length) return;
    window.__caCache = window.__caCache || {};
    var handles = {};
    cart.items.forEach(function (i) { handles[i.handle] = 1; });
    Object.keys(handles).forEach(function (h) {
      if (window.__caCache["h:" + h]) { applyCA(); return; }
      /* ⛔ LA RACINE DE LANGUE, SANS QUOI RIEN NE S'AFFICHE HORS DU FRANCAIS. Le panier est lu
         par `urlPanier("/cart.js")`, donc `/de/cart.js`, et Shopify y rend le handle TRADUIT.
         Cette adresse-ci partait sans prefixe : elle demandait un handle allemand a la racine
         francaise. Mesure du 15/08/2026 :
             /products/poster-druckservice-fur-unternehmen.js      -> 404
             /de/products/poster-druckservice-fur-unternehmen.js   -> 200
         Le cache restait donc vide sur les DOUZE marches traduits, et le tiroir sortait sans
         prix barre, sans badge « -25 % » et sans ligne « Reduction » (Adrien, 15/08 : capture
         du tiroir allemand a cote du francais). Meme mecanique que les liens de l'en-tete
         corriges le matin meme : un chemin francais fige, une ressource traduite, une 404.
         ⚠️ ET LE `catch` VIDE EST CE QUI L'A CACHE. Un echec de decoration ne doit pas
         deranger le client, mais il doit se voir de la console, sinon il vit des semaines. */
      fetch(urlPanier("/products/" + h + ".js"), { headers: { Accept: "application/json" } })
        .then(function (r) {
          if (!r.ok) throw new Error("produit illisible : " + r.status);
          return r.json();
        })
        .then(function (p) {
          window.__caCache["h:" + h] = 1;
          (p.variants || []).forEach(function (v) { window.__caCache["v:" + v.id] = v.compare_at_price || 0; });
          applyCA();
        }).catch(function (e) {
          if (window.console && console.warn) console.warn("prix barre du tiroir :", h, e && e.message);
        });
    });
    function applyCA() {
      /* ⛔ DANS LE TIROIR SEULEMENT, ET LA PORTEE EST TOUTE LA CORRECTION. Cette boucle apparie
         les lignes du DOM aux articles du panier PAR INDICE. Tant que la page /cart avait son
         propre vocabulaire, `.cart-line` ne designait que le tiroir. Depuis qu'elle emprunte
         celui du tiroir (11/08/2026), le selecteur rendait QUATRE elements pour DEUX articles :
         les indices 0 et 1 tombaient sur la page, 2 et 3 sur `cart.items[2]`, qui n'existe pas.
         Le tiroir ressortait donc sans prix barre et sans badge « -25 % », sur la page /cart
         uniquement. Mesure du 11/08 : page barre=true badge=-25%, tiroir barre=false badge=null.
         ⚠️ ET LA PAGE N'A BESOIN DE RIEN : son Liquid connait `compare_at_price` et rend deja le
         barre. Cette fonction n'existe que parce que /cart.js ne l'expose pas au JS du tiroir.
         ⚠️ LA LECON DU PARTAGE DE CLASSES : partager une feuille, c'est aussi partager les
         SELECTEURS. Le gain est reel, le prix est qu'un `document.querySelectorAll` non borne
         attrape desormais deux ecrans. On borne a l'ecran concerne, une fois pour toutes. */
      /* ⛔ LE TIROIR ENTIER, PAS SON CORPS. Premiere correction : `#drawer-body`, qui contient
         bien les lignes. Mais `.cart-totals` et `.cart-totals__row--save` vivent dans
         `#drawer-FOOT`, un frere : les deux recherches ci-dessous ne trouvaient plus rien, et
         la ligne « Reduction » ne s'inserait plus du tout dans le tiroir. Corrige un defaut,
         ouvert un autre, par une portee prise trop bas. `#cart-drawer` couvre le ship, le corps,
         le pied et les moyens de paiement, et exclut la page : c'est la bonne frontiere. */
      var tiroir = $("#cart-drawer") || document;
      $$(".cart-line", tiroir).forEach(function (el, idx) {
        var i = cart.items[idx]; if (!i) return;
        var ca = window.__caCache["v:" + i.variant_id] || 0;
        var priceEl = el.querySelector(".cart-line__price");
        if (!priceEl || !(ca > i.final_price)) return;
        /* ⛔ CE BLOC REECRIT LE PRIX DE LIGNE APRES COUP, ET IL AVAIT ECHAPPE AU PARCOURS PRO.
           Mesure du 22/08/2026, tiroir en `?pro=1` : les totaux disaient bien « 264,17 € HT »
           pendant que la ligne affichait « 317,00 € 497,50 € », c'est-a-dire du TTC avec le prix
           barre de la promo grand public. Le rendu initial etait juste ; l'enrichissement
           asynchrone repassait derriere avec `money` et le prix de reference. */
        if (PRO_HT) {
          priceEl.classList.remove("is-sale");
          priceEl.innerHTML = '<span class="cart-line__now">' + moneyAff(i.final_line_price) + "</span>";
          return;
        }
        priceEl.classList.add("is-sale");
        priceEl.innerHTML = '<span class="cart-line__now">' + money(i.final_line_price) + "</span><s>" + money(ca * i.quantity) + "</s>";
        var lbl = promoBadgeLabel(Math.max(ca, i.original_price || 0), i.final_price);
        var badge = el.querySelector(".cart-line__badge");
        if (badge) {
          badge.textContent = lbl;
        } else {
          var head = el.querySelector(".cart-line__head");
          if (lbl && head) head.insertAdjacentHTML("beforeend", '<span class="cart-line__badge">' + lbl + "</span>");
        }
      });
      var savings = computeSavings(cart);
      if (savings > 0) {
        /* Meme raison : le recapitulatif de la page porte aussi `cart-totals__row--save`, et
           c'est LUI que ce `$` attrapait en premier, la page precedant le tiroir dans le DOM.
           Le tiroir se reecrivait donc la ligne de reduction de la page, deja juste. */
        var saveRow = $(".cart-totals__row--save", tiroir);
        var html = "<span>" + t("cart_reduction", "Réduction") + "</span><strong>−" + moneyAff(savings) + "</strong>";
        if (saveRow) {
          saveRow.innerHTML = html;
        } else {
          var totals = $(".cart-totals", tiroir);
          if (totals) {
            totals.insertAdjacentHTML(
              "afterbegin",
              '<div class="cart-totals__row cart-totals__row--save">' + html + "</div>"
            );
          }
        }
      }
    }
  }

  /* ⛔ TOUJOURS LA RACINE DE LANGUE SUR LES ADRESSES PANIER. Écrites en dur (« /cart.js »),
     elles répondaient en FRANÇAIS : un germanophone voyait le titre de sa ligne en
     français dans son panier (03/08/2026). La même leçon avait déjà été apprise pour
     la recherche (RACINE_LOCALE) et dans product.js (murUrl). */
  function urlPanier(chemin) { return RACINE_LOCALE + chemin; }
  function fetchCart() { return fetch(urlPanier("/cart.js"), { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }); }
  function changeLine(line, qty) {
    return fetch(urlPanier("/cart/change.js"), { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* ⛔ SHOPIFY NE REND PAS TOUJOURS UN PANIER. Sur un indice de ligne devenu faux (deux
           onglets, un double clic, un panier vide entre-temps) il rend un objet d'erreur
           `{status, message, description}`, sans `items`. `renderCart` y lisait `cart.items`
           APRES avoir deja ecrit le compteur et la barre : le tiroir gardait alors un total
           d'un panier et des lignes d'un autre. On ne rend que ce qui est un panier ; sinon on
           redemande l'etat vrai au serveur plutot que d'en afficher un faux. */
        if (cart && Array.isArray(cart.items)) return renderCart(cart);
        return resyncPanier();
      })
      .catch(function () { return resyncPanier(); });
  }
  /* Passage au paiement : dernier point mesurable avant que Shopify prenne la main. On
     l'attrape sur le clic, pas sur la commande — une commande n'est jamais reliée à la
     popup, et on ne cherche pas à l'être.

     ⛔ IL Y A DEUX BOUTONS « COMMANDER », PAS UN. Le tiroir rend un lien
     `<a href="/checkout">`, mais la page /cart rend un `<button name="checkout">`
     dans le formulaire du panier : la garde ne visait que le lien, donc TOUT
     paiement parti de la page panier passait sous le radar, et les Sorties
     affichaient « 0 passage au paiement » a cote de commandes bien reelles
     (Adrien, 03/08/2026). Le submit du formulaire est ecoute en plus du clic :
     on valide aussi au clavier. Le doublon ne coute rien, le serveur ne garde
     qu'un evenement par jeton. */
  function noteCheckout(depuis) {
    try {
      /* ⛔ AVANT LA GARDE SUR `MurExitSuite`. La popup de sortie peut ne pas etre chargee ; le
         geste, lui, doit partir chez Google dans tous les cas. Les ranger dans le meme `if`
         ferait dependre une conversion publicitaire de la presence d'un questionnaire. */
      if (window.afBaliser) {
        var poseG = depuis && depuis.closest && depuis.closest("[data-cart-total]");
        var centsG = poseG ? parseInt(poseG.getAttribute("data-cart-total"), 10) : dernierTotalPanier;
        window.afBaliser("paiement_initie", centsG || dernierTotalPanier || 0);
      }
      if (!window.MurExitSuite) return;
      /* ⛔ Le montant vient du panier REELLEMENT rendu, pas d'un `[data-cart-total]`
         pose au hasard : cet attribut n'existait sur aucune page du theme, et
         « Panier au paiement » valait donc toujours 0 euro. Le tiroir tient le
         total a jour a chaque rendu ; la page /cart, servie par Liquid, le porte
         sur son bouton. */
      var pose = depuis && depuis.closest && depuis.closest("[data-cart-total]");
      var cents = pose ? parseInt(pose.getAttribute("data-cart-total"), 10) : dernierTotalPanier;
      window.MurExitSuite("checkout", cents || dernierTotalPanier || 0);
    } catch (err) {}
  }
  /* ⛔⛔ LA DECLARATION PROFESSIONNELLE SE POSE SUR LE PANIER, AU CLIC (Adrien, 23/08/2026 :
     « c'est forcement quelqu'un qui a achete apres avoir clique sur le CTA pro du panier »).
     Il a tranche le critere lui-meme, et il a raison : l'adresse d'arrivee du visiteur ne prouve
     rien — la commande 1325 en est la preuve, elle est arrivee par Google Shopping et Meta la
     compte quand meme. Le seul fait solide est un GESTE : avoir clique le bouton qui dit
     « Commander en tant que professionnel ».
     ⚠️ EN MODE PRO, CE BOUTON EST LE SEUL : la page rend celui du grand public en `b2c-seul` et
     le tiroir n'en construit qu'un. Un clic sur `.cart-checkout` sous `data-pro` EST donc la
     declaration, sans avoir a distinguer deux boutons qui ne coexistent jamais.
     ⛔ ON RETIENT LA NAVIGATION, MAIS JAMAIS LONGTEMPS. L'attribut doit etre ecrit AVANT que
     Shopify ne fige le panier a la caisse : envoye sans attendre, il pouvait arriver apres. On
     attend donc la reponse, avec une sortie de secours a 1200 ms — et en cas d'echec on part
     quand meme. Un signal publicitaire ne fera jamais rater une vente.
     ⚠️ ET RIEN N'EST POSE HORS DU PARCOURS PRO : marquer quiconque ouvre son panier en mode
     professionnel reviendrait a marquer le visiteur, pas son geste. */
  var declarationEnCours = false;
  function declarePro(cible, aller) {
    if (declarationEnCours) return false;
    declarationEnCours = true;
    var parti = false;
    var suite = function () { if (!parti) { parti = true; aller(); } };
    var minuteur = setTimeout(suite, 1200);
    /* ⛔ `window.fetch` ET NON `forigine` : cette variable existe dans TROIS enveloppes plus bas
       dans le fichier, et pas ici. Ecrite telle quelle, elle levait une ReferenceError attrapee
       par le `try` juste en dessous : la navigation se serait faite normalement, l'attribut ne
       serait jamais parti, et rien ne l'aurait signale. Une variable de fonction n'appartient
       pas au fichier, et rien ne le dit a la lecture. */
    try {
      window.fetch(afRacine() + "/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { _af_pro: "1" } })
      }).then(function () { clearTimeout(minuteur); suite(); })
        .catch(function () { clearTimeout(minuteur); suite(); });
    } catch (err) { clearTimeout(minuteur); suite(); }
    return true;
  }
  document.addEventListener("click", function (e) {
    var c = e.target && e.target.closest && e.target.closest(
      'a[href*="/checkout"], button[name="checkout"], input[name="checkout"], .cart-checkout');
    if (!c) return;
    noteCheckout(c);
    if (document.documentElement.getAttribute("data-pro") !== "1") return;
    if (declarationEnCours) return;
    e.preventDefault();
    var formulaire = c.closest ? c.closest("form") : null;
    declarePro(c, function () {
      if (c.tagName === "A" && c.getAttribute("href")) { window.location.href = c.getAttribute("href"); return; }
      if (formulaire) { formulaire.submit(); return; }
      window.location.href = afRacine() + "/checkout";
    });
  }, true);
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (f && f.tagName === "FORM" && /\/cart\b/.test(f.getAttribute("action") || "")) noteCheckout();
  }, true);

  /* Funnel « Accorder a ma piece » : une personne = un identifiant aleatoire local
     (af:vid), sans aucune donnee personnelle. L'import de photo leve un drapeau
     (af:mp) ; l'ajout au panier n'est journalise QUE pour ces personnes, et l'attribut
     de panier mp_vid porte l'attribution de la commande, lue cote Studio. */
  function afVid() {
    try {
      var v = localStorage.getItem("af:vid");
      if (!v) {
        v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
          : "v" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
        localStorage.setItem("af:vid", v);
      }
      return v;
    } catch (e) { return ""; }
  }
  /* ⛔ LA PORTE SE LIT UNE FOIS, A LA PREMIERE MESURE. « Ma piece » n'emet rien a l'arrivee :
     son premier evenement est l'import, parfois plusieurs minutes apres l'ouverture. Relire
     la porte a chaque evenement la trouverait deja consommee et le panier tomberait en
     « — » alors que l'import savait d'ou venait la personne (Adrien, 08/08/2026). */
  var portePiece = null;
  /* ⛔ LE MONTANT DU PANIER, PAS UNE COCHE (Adrien, 11/08/2026). Le Studio affichait « ✓ » :
     on savait qu'un panier avait suivi l'import, jamais ce qu'il pesait, si bien que deux
     lignes identiques a l'ecran pouvaient valoir 10 € et 120 €. Le total se lit sur
     /cart.js APRES l'ajout, donc c'est le panier reel et non une somme reconstituee.
     ⚠️ UN ECHEC NE BLOQUE RIEN : sans montant, l'evenement part quand meme et le Studio
     ecrit un tiret. Mieux vaut un trou visible qu'un funnel amput d'une ligne. */
  function afTotalPanier() {
    /* La racine de langue ici aussi : le panier est le meme, mais une adresse non prefixee
       traverse une redirection de marche pour rien, et c'est la derniere du fichier a l'oublier. */
    return fetch(urlPanier("/cart.js"), { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var t = Number(c && c.total_price);
        return isFinite(t) && t > 0 ? t / 100 : null;
      })
      .catch(function () { return null; });
  }
  function afMaPieceEnvoi(evenement, url, montant) {
    fetch("https://runway.dcomdtf.app/ma-piece-log", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        evenement: evenement, vid: afVid(), url: url || "", source: portePiece,
        montant: montant,
        device: matchMedia("(max-width:900px)").matches ? "mobile" : "desktop",
        locale: (window.Shopify && Shopify.locale) || document.documentElement.lang || ""
      }),
      keepalive: true, mode: "cors", credentials: "omit", signal: afSignalCourt(2500)
    }).catch(function () {});
  }
  function afMaPieceLog(evenement, url) {
    if (portePiece === null) {
      portePiece = (typeof window.afPorteCreation === "function" ? window.afPorteCreation() : "") || "";
    }
    if (evenement !== "panier") { afMaPieceEnvoi(evenement, url, null); return; }
    afTotalPanier().then(function (m) { afMaPieceEnvoi(evenement, url, m); });
  }
  /* ⛔ LA PHOTO DE LA PIECE PART SUR LE SERVEUR (Adrien, 03/08/2026, pour
     l'analyse statistique). C'est l'interieur de chez quelqu'un : elle n'est
     envoyee qu'a NOTRE depot, l'URL rendue n'est lue que dans le Studio, et un
     echec d'envoi ne bloque jamais l'affichage du mur, qui reste local.

     ⛔ ON ENVOIE L'IMAGE DECODEE, PAS LE FICHIER. Une photo prise a l'iPhone
     arrive en `image/heic`, que le depot refuse (415) : envoyer le fichier tel
     quel aurait perdu justement les gens qui photographient leur piece au
     telephone. L'image est deja decodee a l'ecran quand on arrive ici, donc on
     la reencode en JPEG au passage, ce qui borne aussi le poids. */
  window.afMaPieceImport = function (fichier, image) {
    try {
      localStorage.setItem("af:mp", "1");
      if (sessionStorage.getItem("af:mp-imp")) return;
      sessionStorage.setItem("af:mp-imp", "1");
      if (!fichier || !window.fetch) { afMaPieceLog("import"); return; }

      var envoyer = function (corps, type) {
        /* ⛔ `usage=room` : CETTE PHOTO NE S'IMPRIME JAMAIS (Adrien, 07/08/2026). Le depot
           servait trois usages et les rangeait tous sous le meme nommage, si bien que la photo
           du salon de quelqu'un etait techniquement une source d'impression valide. Le
           parametre est ce qui permet au serveur de la nommer `room_` et de la refuser ensuite
           partout ou un fichier part a la presse. */
        fetch("https://runway.dcomdtf.app/perso/upload?usage=room", {
          method: "POST", headers: { "Content-Type": type },
          body: corps, mode: "cors", credentials: "omit"
        })
          .then(function (r) { return r && r.ok ? r.json() : null; })
          .then(function (j) {
            var u = (j && (j.preview || j.url)) || "";
            afMaPieceLog("import", u);
            /* ⛔ L'ADRESSE DE LA PHOTO REMONTE A LA PAGE. Elle ne servait qu'au
               journal ; la pose a l'echelle en a besoin pour demander l'analyse a
               GPT sur serveur, et elle n'existe QUE dans cette reponse (Adrien, 03/08/2026).
               Un evenement plutot qu'un retour : l'envoi est asynchrone et la page
               a deja repris la main depuis longtemps quand il aboutit. */
            if (u) {
              try {
                window.afMaPiecePhotoUrl = u;
                window.dispatchEvent(new CustomEvent("af:piece-photo", { detail: { url: u } }));
              } catch (e) {}
            }
          })
          .catch(function () { afMaPieceLog("import"); });
      };
      var brut = function () {
        var t = String(fichier.type || "");
        if (t === "image/jpeg" || t === "image/png") envoyer(fichier, t);
        else afMaPieceLog("import");
      };

      var w = image && (image.naturalWidth || image.width);
      var h = image && (image.naturalHeight || image.height);
      if (!w || !h) { brut(); return; }
      var COTE = 1600, k = Math.min(1, COTE / Math.max(w, h));
      var toile = document.createElement("canvas");
      toile.width = Math.max(1, Math.round(w * k));
      toile.height = Math.max(1, Math.round(h * k));
      toile.getContext("2d").drawImage(image, 0, 0, toile.width, toile.height);
      if (!toile.toBlob) { brut(); return; }
      toile.toBlob(function (blob) {
        if (blob && blob.size) envoyer(blob, "image/jpeg"); else brut();
      }, "image/jpeg", 0.82);
    } catch (e) { try { afMaPieceLog("import"); } catch (e2) {} }
  };
  window.afMaPiecePanier = function () {
    try {
      if (localStorage.getItem("af:mp") !== "1") return;
      /* L'attribut se repose a chaque session : le panier a pu etre vide ou recree. */
      if (!sessionStorage.getItem("af:mp-attr")) {
        sessionStorage.setItem("af:mp-attr", "1");
        fetch(urlPanier("/cart/update.js"), {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: { mp_vid: afVid() } })
        }).catch(function () {});
      }
      if (sessionStorage.getItem("af:mp-pan")) return;
      sessionStorage.setItem("af:mp-pan", "1");
      afMaPieceLog("panier");
    } catch (e) {}
  };

  function addToCart(payload) {
    return fetch(urlPanier("/cart/add.js"), { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (data) { if (r.ok === false) throw new Error(data.description || data.message || "cart add failed"); return data; }); })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        renderCart(cart);
        /* Le panneau de creation, s'il est ouvert, se ferme sur un ajout : le client
           vient d'acheter, on le ramene a la fiche plutot que de le laisser devant
           deux couches. Le tiroir, lui, s'ouvre par-dessus tout. */
        /* ⛔ L'EVENEMENT PORTE LE TOTAL, et c'est le total D'APRES l'ajout : `cart` vient d'etre
           relu. Les funnels le lisaient eux-memes AVANT d'ajouter, donc sur un panier encore
           vide : la colonne « Panier HT » du Studio annoncait 0 € pour tout premier achat
           (Adrien, 20/08/2026). Le seul endroit qui connaisse le panier a jour est ici. */
        try { window.dispatchEvent(new CustomEvent("af:panier", { detail: { total: cart && cart.total_price } })); } catch (e) {}
        openDrawer();
        /* Attribution à la popup de sortie, si elle a été vue dans cette session. Le jeton
           vient d'elle, il est anonyme et meurt avec l'onglet ; ici on ne fait que dire
           « cette session a ajouté au panier ». Le total du panier accompagne l'événement
           pour distinguer un 21×30 d'un mur de six. */
        try { if (window.MurExitSuite) window.MurExitSuite("cart_add", cart && cart.total_price); } catch (e) {}
        try { window.afMaPiecePanier(); } catch (e) {}
        /* ⛔ SANS `|| PROMO_ON` : il rendait la purge ci-dessus inutile, puisqu'il suffisait
           que la campagne soit active pour que le message parte, quel que soit le panier. */
        if (cartHasPromo(cart)) {
          /* ⚠️ LE REPLI NE CITE PLUS DE TAUX. Il portait « -10 % », d'une campagne eteinte depuis :
             un repli qui vieillit annonce un chiffre faux le jour ou il sert. La vraie phrase
             vient des locales, avec le taux du Studio substitue a `__PCT__`. */
          toast(t("cart_added_promo", "Ajouté, votre remise est appliquée"));
        } else {
          toast(t("cart_added", "Ajouté au panier"));
        }
        return cart;
      });
  }
  window.murAddToCart = addToCart;

  /* Sélecteur de langue : le bouton drapeau ouvre la liste. Les options sont des
     <button type="submit">, donc sans JS la liste reste soumise au form 'localization'
     (elle est simplement toujours dépliée). */
  var langBox = $("[data-lang-picker]");
  if (langBox) {
    var langBtn = $("[data-lang-toggle]", langBox), langList = $(".lang-picker__list", langBox);
    if (langBtn && langList) {
      var setLang = function (open) {
        langList.hidden = !open;
        langBtn.setAttribute("aria-expanded", open ? "true" : "false");
      };
      langBtn.addEventListener("click", function () { setLang(langList.hidden); });
      document.addEventListener("click", function (e) { if (!langBox.contains(e.target)) setLang(false); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") setLang(false); });
    }
  }

  /* ---- Bas de collection : debut visible + Lire la suite (tous appareils) ----
     ⛔ LE TEXTE N'EST JAMAIS RETIRE DU DOM. Il est borne en hauteur par le CSS et rendu par
     Liquid dans le HTML servi : le robot le lit en entier, ouvert ou non. Charger ce texte en
     Ajax le rendrait invisible pour l'indexation, ce qui viderait de son sens le travail de
     couverture des mots-cles.
     ⚠️ Le bouton n'apparait que si le texte deborde VRAIMENT : sinon une collection au texte
     court proposerait de deplier trois lignes. */
  (function () {
    var body = $("#coll-bas-body"), btn = $("#coll-bas-more");
    if (!body || !btn) return;
    function sync() {
      if (body.getAttribute("data-ouvert") === "true") { btn.hidden = false; return; }
      btn.hidden = !(body.scrollHeight > body.clientHeight + 2);
    }
    btn.addEventListener("click", function () {
      var open = body.getAttribute("data-ouvert") === "true";
      body.setAttribute("data-ouvert", open ? "false" : "true");
      btn.setAttribute("aria-expanded", open ? "false" : "true");
      btn.textContent = open
        ? (btn.dataset.labelMore || "Voir plus")
        : (btn.dataset.labelLess || "Voir moins");
    });
    sync();
    window.addEventListener("resize", sync);
  })();

  /* ---- Description collection : 2 lignes + Voir plus (mobile) ---- */
  (function () {
    var box = $(".coll-desc"), body = $("#coll-desc-body"), btn = $("#coll-desc-more");
    if (!box || !body || !btn) return;
    function sync() {
      var mobile = window.matchMedia("(max-width: 768px)").matches;
      if (!mobile) {
        box.setAttribute("data-expanded", "false");
        btn.hidden = true;
        btn.setAttribute("aria-expanded", "false");
        btn.textContent = btn.dataset.labelMore || "Voir plus";
        return;
      }
      if (box.getAttribute("data-expanded") === "true") {
        btn.hidden = false;
        return;
      }
      /* Bouton seulement si le texte dépasse vraiment 2 lignes. */
      btn.hidden = !(body.scrollHeight > body.clientHeight + 2);
    }
    btn.addEventListener("click", function () {
      var open = box.getAttribute("data-expanded") === "true";
      box.setAttribute("data-expanded", open ? "false" : "true");
      btn.setAttribute("aria-expanded", open ? "false" : "true");
      btn.textContent = open
        ? (btn.dataset.labelMore || "Voir plus")
        : (btn.dataset.labelLess || "Voir moins");
    });
    sync();
    window.addEventListener("resize", sync);
  })();

  /* ---- Filtres de collection ----
     Desktop : submit au change + un seul details ouvert.
     Mobile : toolbar + bottom sheet ; changements batchés jusqu'à "Voir". */
  var filterForm = $("[data-filter-form]");
  if (filterForm) {
    var fBox = $("[data-filters]");
    var panel = fBox ? $("[data-filters-panel]", fBox) : null;
    var openBtn = fBox ? $("[data-filters-open]", fBox) : null;
    var mqMobile = window.matchMedia("(max-width:900px)");
    var sheetOpen = false;
    var sheetSnapshot = null;

    var isMobileFilters = function () {
      return mqMobile.matches;
    };

    var submitFilters = function () {
      filterForm.submit();
    };

    var snapshotFilters = function () {
      return $$("input[type='checkbox']", filterForm).map(function (input) {
        return { el: input, checked: input.checked };
      });
    };

    var restoreFilters = function () {
      if (!sheetSnapshot) return;
      sheetSnapshot.forEach(function (item) {
        if (item.el) item.el.checked = item.checked;
      });
      sheetSnapshot = null;
      $$("details.filters__group", filterForm).forEach(function (d) { d.open = false; });
      $$(".filters__swatch", filterForm).forEach(function (lab) {
        var inp = $("input", lab);
        lab.classList.toggle("is-active", !!(inp && inp.checked));
      });
    };

    var setSheet = function (open, opts) {
      if (!fBox || !panel || !openBtn) return;
      opts = opts || {};
      if (open) {
        sheetSnapshot = snapshotFilters();
      } else if (opts.revert) {
        restoreFilters();
      } else {
        sheetSnapshot = null;
      }
      sheetOpen = !!open;
      fBox.classList.toggle("is-open", sheetOpen);
      openBtn.setAttribute("aria-expanded", sheetOpen ? "true" : "false");
      document.body.classList.toggle("filters-sheet-open", sheetOpen);
      $$("[data-filters-close]", fBox).forEach(function (el) {
        if (el.classList && el.classList.contains("filters__backdrop")) {
          el.hidden = !sheetOpen;
        }
      });
      if (sheetOpen) {
        try {
          if (window.$chatwoot && typeof window.$chatwoot.toggle === "function") {
            window.$chatwoot.toggle("close");
          }
        } catch (_) { /* ignore */ }
        var closeBtn = $(".filters__panel-x", panel);
        if (closeBtn) closeBtn.focus();
      } else if (openBtn && opts.focusOpen !== false) {
        openBtn.focus();
      }
    };

    filterForm.addEventListener("change", function (e) {
      /* Tri : toujours immédiat. Filtres dans le sheet mobile : attendre "Voir". */
      if (e.target && e.target.matches && e.target.matches("[data-sort-select]")) {
        submitFilters();
        return;
      }
      if (isMobileFilters() && sheetOpen) return;
      submitFilters();
    });

    if (fBox && panel && openBtn) {
      openBtn.addEventListener("click", function () {
        setSheet(true);
      });
      $$("[data-filters-close]", fBox).forEach(function (btn) {
        btn.addEventListener("click", function () {
          var shouldApply = btn.hasAttribute("data-filters-apply");
          if (shouldApply && isMobileFilters()) {
            setSheet(false, { focusOpen: false });
            submitFilters();
            return;
          }
          setSheet(false, { revert: true });
        });
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && sheetOpen) setSheet(false, { revert: true });
      });
      if (mqMobile.addEventListener) {
        mqMobile.addEventListener("change", function () {
          if (!mqMobile.matches && sheetOpen) setSheet(false, { revert: true });
        });
      }
    }

    if (fBox) {
      var groups = $$("details.filters__group", fBox);
      groups.forEach(function (d) {
        d.addEventListener("toggle", function () {
          if (!d.open) return;
          groups.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
      document.addEventListener("click", function (e) {
        if (isMobileFilters()) return;
        if (fBox.contains(e.target)) return;
        groups.forEach(function (o) { o.open = false; });
      });
    }
  }

  /* ---- Collection : defilement infini ----
     Le lien "Voir plus" est la source de verite : sans JS il navigue vers la page
     suivante. Ici on l'observe, on va chercher la page et on recopie ses cartes.
     On garde le lien visible : l'observateur peut ne jamais se declencher (onglet
     en arriere-plan, mouvement reduit), le clic doit toujours marcher. */
  /* .coll__more — pas [data-more] seul : le bouton "Voir plus" de la description
     collection porte aussi data-more (libellé) et serait pris en premier. */
  var moreBox = $(".coll__more[data-more]");
  if (moreBox && window.fetch && window.DOMParser) {
    var grid = $("[data-products]");
    var moreLink = $("[data-more-link]", moreBox);
    var moreWait = $("[data-more-wait]", moreBox);
    var moreStatus = $("[data-more-status]");
    var loading = false;

    if (grid && moreLink) {
    var loadNext = function () {
      if (loading || !moreLink || !moreBox.isConnected || !moreLink.getAttribute("href")) return;
      loading = true;
      var url = moreLink.getAttribute("href");
      moreLink.hidden = true;
      if (moreWait) moreWait.hidden = false;
      fetch(url, { headers: { "X-Requested-With": "fetch" } })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var next = doc.querySelector("[data-products]");
          var cards = next ? Array.prototype.slice.call(next.children) : [];
          cards.forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
          if (moreStatus) {
            moreStatus.textContent = (moreStatus.getAttribute("data-tpl") || "#N#")
              .replace("#N#", grid.children.length);
          }
          var nextLink = doc.querySelector("[data-more-link]");
          /* Une page peut ne rien rendre alors que la suite existe : les affiches vendues
             sont epinglees en tete et retirees du flux, et si l'une d'elles occupait toute
             une page, celle-ci arrive vide. S'arreter la amputerait la collection. */
          if (nextLink) {
            /* href est absolu apres parsing : on repasse en relatif, sinon un
               changement de domaine (aperçu, prévisualisation) casserait le suivant. */
            moreLink.setAttribute("href", nextLink.getAttribute("href"));
            moreLink.hidden = false;
            loading = false;
            /* IO ne se re-déclenche pas si le bouton reste dans le viewport :
               enchaîner tant que le bas de page est encore visible. */
            requestAnimationFrame(function () {
              if (!moreBox.isConnected) return;
              var r = moreBox.getBoundingClientRect();
              if (r.top < (window.innerHeight || 0) + 600) loadNext();
            });
          } else {
            moreBox.remove();   /* plus rien a charger : l'observateur n'a plus de cible */
            loading = false;
          }
          if (moreWait) moreWait.hidden = true;
        })
        .catch(function () {
          /* Reseau coupe : on rend le lien, le clic fera la navigation classique. */
          if (moreWait) moreWait.hidden = true;
          moreLink.hidden = false;
          loading = false;
        });
    };

    moreLink.addEventListener("click", function (e) {
      e.preventDefault();
      loadNext();
    });

    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) loadNext(); });
      }, { rootMargin: "600px 0px" });   /* on precharge avant que le bas soit atteint */
      io.observe(moreBox);
    }
    }
  }

  /* Tri hors barre filtres (collection sans facettes) : radios ou select de secours. */
  var sortForm = $("[data-sort-form]");
  if (sortForm) {
    sortForm.addEventListener("change", function (e) {
      if (e.target && e.target.matches && e.target.matches("[data-sort-select]")) sortForm.submit();
    });
  }

  /* ⛔ LE MENU DE TRI SE FERME AU CLIC EN DEHORS (Adrien, 10/08/2026). C'est un <details>
     ordinaire, hors du jeu `[data-nav-sub]` qui a deja sa fermeture quelques lignes plus bas :
     personne ne s'occupait de lui, et il restait ouvert par-dessus la grille tant qu'on ne
     recliquait pas sur son propre titre. La touche Echap ferme aussi, pour le clavier. */
  var triGroupes = $$("details.filters__group--sort");
  if (triGroupes.length) {
    document.addEventListener("click", function (e) {
      triGroupes.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      triGroupes.forEach(function (d) { d.open = false; });
    });
  }

  /* Sous-menus : ouverture au survol a la souris, au clic au doigt et au clavier.
     On pilote `open` en JS plutot qu'en CSS : <details> masque son contenu par un
     mecanisme interne du navigateur qu'une regle `display` ne leve pas de facon
     fiable. Sans JS, le <details> reste cliquable — rien n'est perdu. */
  var navSubs = $$("[data-nav-sub]");
  if (navSubs.length) {
    var isDesktopNav = function () {
      return !window.matchMedia || window.matchMedia("(min-width: 981px)").matches;
    };
    var closeTimer = null;
    var closeAll = function (except) {
      navSubs.forEach(function (o) { if (o !== except) o.open = false; });
    };
    navSubs.forEach(function (d) {
      d.addEventListener("toggle", function () { if (d.open) closeAll(d); });

      d.addEventListener("mouseenter", function () {
        if (!isDesktopNav()) return;
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        closeAll(d);
        d.open = true;
      });
      /* Petit délai : sans lui, frôler le bord referme le menu avant d'y arriver. */
      d.addEventListener("mouseleave", function () {
        if (!isDesktopNav()) return;
        closeTimer = setTimeout(function () { d.open = false; }, 180);
      });
      /* Sur desktop, le titre sert d'onglet de survol : le clic ne change pas l'état. */
      var sum = $("summary", d);
      if (sum) {
        sum.addEventListener("click", function (e) {
          if (!isDesktopNav()) return;
          e.preventDefault();
          closeAll(d);
          d.open = true;
        });
      }
      /* Le clavier garde la main : Tab dedans ouvre, sortir ferme. Desktop seulement :
         sur mobile, un focusin au tap forçait `open=true` juste avant que le clic natif
         du <details> ne le referme → le sous-menu ne s'ouvrait jamais au doigt. */
      d.addEventListener("focusin", function () { if (!isDesktopNav()) return; closeAll(d); d.open = true; });
    });
    document.addEventListener("click", function (e) {
      navSubs.forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeAll(null);
    });
  }

  // La recherche partage le client recherche-client.js entre la barre et la page.

  /* Le Liquid rend déjà l'état initial de la barre, mais une page servie depuis le cache
     peut porter un total périmé : on resynchronise sur le panier réel. */
  if ($("#ship-bar") || $("#reco")) {
    fetchCart().then(function (cart) { renderShipBar(cart.total_price); }).catch(function () {});
  }

  document.addEventListener("click", function (e) {
    var openBtn = e.target.closest("[data-open-cart]");
    var closeBtn = e.target.closest("[data-close-cart]");
    var ov = e.target.closest("#cart-overlay");
    if (openBtn) {
      e.preventDefault();
      // Mobile Desenio : l'icône panier du header bascule en ✕ pour fermer.
      if (document.body.classList.contains("cart-open")) closeDrawer();
      else openDrawer();
    }
    if (closeBtn || ov) { closeDrawer(); }

    var rm = e.target.closest("[data-remove]");
    if (rm) { changeLine(parseInt(rm.getAttribute("data-remove"), 10), 0); }
    var ln = e.target.closest("[data-line]");
    if (ln) { changeLine(parseInt(ln.getAttribute("data-line"), 10), parseInt(ln.getAttribute("data-qty"), 10)); }
    var up = e.target.closest("[data-upsell-add]");
    if (up) {
      e.preventDefault();
      var vid = parseInt(up.getAttribute("data-upsell-add"), 10);
      if (vid) {
        up.disabled = true;
        addToCart({ id: vid, quantity: 1 }).finally(function () { up.disabled = false; });
      }
    }

    // promo close
    if (e.target.closest("[data-close-promo]")) { var p = $(".promo"); if (p) p.style.display = "none"; }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeDrawer(); } });

  // Menu burger (mobile) : tiroir latéral off-canvas.
  (function () {
    var toggle = $("[data-nav-toggle]"), nav = $("[data-nav]"), overlay = $("[data-nav-overlay]");
    if (!toggle || !nav) return;
    function openNav() { nav.classList.add("open"); if (overlay) { overlay.hidden = false; overlay.classList.add("open"); } document.body.classList.add("nav-open"); toggle.setAttribute("aria-expanded", "true"); }
    function closeNav() { nav.classList.remove("open"); if (overlay) { overlay.classList.remove("open"); overlay.hidden = true; } document.body.classList.remove("nav-open"); toggle.setAttribute("aria-expanded", "false"); }
    toggle.addEventListener("click", function () { nav.classList.contains("open") ? closeNav() : openNav(); });
    $$("[data-nav-close]").forEach(function (btn) { btn.addEventListener("click", closeNav); });
    if (overlay) overlay.addEventListener("click", closeNav);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeNav(); });
    // Clic sur un vrai lien = on ferme (puis la navigation se fait). Les <summary> des sous-menus ne ferment pas.
    nav.addEventListener("click", function (e) { if (e.target.closest("a")) closeNav(); });
  })();

  document.addEventListener("DOMContentLoaded", function () {
    (function regroupCreateLinks() {
      var nav = $(".nav-row__inner");
      if (!nav) return;
      var first = nav.children[0], second = nav.children[1];
      if (!first || !second || first.tagName !== "A" || second.tagName !== "A") return;
      if (first.textContent.trim() !== "Personnaliser" || second.textContent.trim() !== "Composer mon mur") return;
      var d = document.createElement("details");
      d.className = "nav-sub";
      d.setAttribute("data-nav-sub", "");
      var persoHref = (window.MURMURE_I18N && MURMURE_I18N.perso_url) || "/products/affiche-personnalisee";
      var wallHref = (window.MURMURE_I18N && MURMURE_I18N.composition_url) || "/pages/composition";
      d.innerHTML = '<summary>' + t("header_create_title", "Créer") + '<span class="nav-sub__caret" aria-hidden="true"></span></summary>' +
        '<div class="nav-sub__panel nav-sub__panel--create">' +
        '<a class="nav-sub__create-card" href="' + persoHref + '">' +
        '<span class="nav-sub__create-img" style="background-image:url(//cdn.shopify.com/s/files/1/0836/6158/6676/files/mockup-chambre.jpg);background-position:82% 50%"></span>' +
        '<strong>' + t("header_create_personalize", "Personnaliser") + '</strong>' +
        '<em>' + t("header_feature_text", "Votre image, imprimée à la main à Fayence.") + '</em></a>' +
        '<a class="nav-sub__create-card" href="' + wallHref + '">' +
        '<span class="nav-sub__create-img" style="background-image:url(//cdn.shopify.com/s/files/1/0836/6158/6676/files/mockup-salon2.jpg)"></span>' +
        '<strong>' + t("header_create_wall", "Composer mon mur") + '</strong>' +
        '<em>' + t("header_create_wall_text", "Créez un ensemble d affiches harmonieux pour votre intérieur.") + '</em></a>' +
        '</div>';
      nav.insertBefore(d, first);
      first.remove();
      second.remove();
      var closeTimer = null;
      var isDesktopNav = function () { return !window.matchMedia || window.matchMedia("(min-width: 981px)").matches; };
      d.addEventListener("mouseenter", function () {
        if (!isDesktopNav()) return;
        if (closeTimer) clearTimeout(closeTimer);
        $$("[data-nav-sub]").forEach(function (o) { if (o !== d) o.open = false; });
        d.open = true;
      });
      d.addEventListener("mouseleave", function () {
        if (!isDesktopNav()) return;
        closeTimer = setTimeout(function () { d.open = false; }, 180);
      });
      var summary = $("summary", d);
      if (summary) {
        summary.addEventListener("click", function (e) {
          if (window.matchMedia && !window.matchMedia("(min-width: 981px)").matches) return;
          e.preventDefault();
          $$("[data-nav-sub]").forEach(function (o) { if (o !== d) o.open = false; });
          d.open = true;
        });
      }
    })();
    /* ⛔⛔⛔ LE SCRIPT QUI ECRASAIT LES VIGNETTES DE MENU EST PARTI (Adrien, serie 190 :
       « c'est pas du tout la meilleure vente dans art »). Il vivait ici sous le nom
       `replaceStaleMenuFeatures` et remplacait la carte rendue par `header.liquid` par une
       affiche prise dans une table ecrite a la main le 07/08. Deux mecanismes pour la meme
       case ; celui qui gagnait etait celui qui ne suivait rien.
       ⚠️ CE QU'IL FAUT GARDER DE LUI : il est ne parce que les URL d'images ecrites en dur
       dans ce fichier ont rendu 404 toutes ensemble apres un remplacement de medias. La carte
       de header.liquid prend `featured_media` du produit, jamais un nom de fichier : c'est la
       reponse durable a ce probleme-la, et elle rend le script inutile.
       ⚠️ `window.MURMURE_MENU_FEATURES` disparait avec lui dans theme.liquid, meme commit :
       plus personne ne le lit. */
    fetchCart().then(renderCart);
    $$("h1,h2,h3,p,span,strong,em,div").forEach(function (el) {
      if (el.childElementCount || el.textContent.trim() !== "Imprimées une à une, puis contrôlées à la main.") return;
      el.textContent = T.home_atelier_title || "Imprimées à la main à Fayence";
    });

    /* Hero home : carrousel d'affiches (autoplay + swipe/drag + dots), mobile et desktop. */
    (function homegHeroCarousel() {
      var root = document.querySelector("[data-homeg-carousel]");
      if (!root) return;
      /* ⛔ LE CARROUSEL NE MELANGE PAS LES DEUX PUBLICS. Les diapositives des deux parcours sont
         rendues ensemble : le serveur ne voit pas `?pro=1`. C'est ici qu'on choisit, et non en
         retirant des noeuds depuis `pro-funnel.js` : cela aurait dependu de qui, de lui ou de
         cette fonction, tourne en premier. */
      var estPro = document.documentElement.getAttribute("data-pro") === "1";
      var slides = Array.prototype.slice.call(root.querySelectorAll("[data-homeg-slide]"))
        .filter(function (s) { return s.hasAttribute("data-pro-slide") === estPro; });
      if (slides.length < 2) return;
      var dotsWrap = root.querySelector("[data-homeg-dots]");
      var i = Math.max(0, slides.findIndex(function (s) { return s.classList.contains("is-on"); }));
      var timer = null;
      var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
      var INTERVAL = 4200;
      var x0 = null, y0 = null, axis = null, swiping = false, active = false;

      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, idx) {
          var on = idx === i;
          s.classList.toggle("is-on", on);
          if (on) s.setAttribute("aria-current", "true");
          else s.removeAttribute("aria-current");
        });
        if (dotsWrap) {
          Array.prototype.forEach.call(dotsWrap.children, function (d, idx) {
            d.classList.toggle("is-on", idx === i);
          });
        }
      }
      function next() { go(i + 1); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        stop();
        if (reduce) return;
        timer = setInterval(next, INTERVAL);
      }
      function markSwipe() {
        root.setAttribute("data-swiping", "1");
        setTimeout(function () { root.removeAttribute("data-swiping"); }, 400);
      }

      if (dotsWrap) {
        slides.forEach(function (_, idx) {
          var b = document.createElement("button");
          b.type = "button";
          b.className = "homeg-hero__dot" + (idx === i ? " is-on" : "");
          b.setAttribute("aria-label", String(idx + 1));
          b.addEventListener("click", function () { go(idx); start(); });
          dotsWrap.appendChild(b);
        });
      }

      root.addEventListener("touchstart", function (e) {
        if (!e.touches || !e.touches[0]) return;
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; axis = null; swiping = false; active = true;
        stop();
      }, { passive: true });
      root.addEventListener("touchmove", function (e) {
        if (!active || x0 === null || !e.touches || !e.touches[0]) return;
        var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
        if (axis === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          axis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
        }
        if (axis === "x" && e.cancelable) { e.preventDefault(); swiping = true; }
      }, { passive: false });
      root.addEventListener("touchend", function (e) {
        if (!active || x0 === null) return;
        var t = e.changedTouches && e.changedTouches[0];
        var dx = t ? t.clientX - x0 : 0;
        var horizontal = axis === "x" || (axis === null && Math.abs(dx) >= 40);
        x0 = null; y0 = null; axis = null; active = false;
        if (horizontal && Math.abs(dx) >= 40) {
          swiping = true;
          go(dx < 0 ? i + 1 : i - 1);
          markSwipe();
        }
        start();
      }, { passive: true });
      root.addEventListener("touchcancel", function () {
        x0 = null; y0 = null; axis = null; active = false; start();
      }, { passive: true });

      root.addEventListener("pointerdown", function (e) {
        if (e.pointerType !== "mouse" || e.button !== 0) return;
        if (e.target.closest && e.target.closest(".homeg-hero__dots")) return;
        x0 = e.clientX; y0 = e.clientY; axis = null; swiping = false; active = true;
        stop();
      });
      root.addEventListener("pointermove", function (e) {
        if (e.pointerType !== "mouse" || !active || x0 === null) return;
        var dx = e.clientX - x0, dy = e.clientY - y0;
        if (axis === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          axis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
        }
        if (axis === "x") swiping = true;
      });
      root.addEventListener("pointerup", function (e) {
        if (e.pointerType !== "mouse" || !active || x0 === null) return;
        var dx = e.clientX - x0;
        var horizontal = axis === "x" || (axis === null && Math.abs(dx) >= 40);
        x0 = null; y0 = null; axis = null; active = false;
        if (horizontal && Math.abs(dx) >= 40) {
          go(dx < 0 ? i + 1 : i - 1);
          markSwipe();
        }
        start();
      });
      root.addEventListener("pointercancel", function (e) {
        if (e.pointerType !== "mouse") return;
        x0 = null; y0 = null; axis = null; active = false; start();
      });

      root.addEventListener("click", function (e) {
        if (root.getAttribute("data-swiping") === "1") {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      go(i);
      start();
      document.addEventListener("visibilitychange", function () {
        if (document.hidden) stop(); else start();
      });
    })();
  });
})();

/* Affiches récemment vues (fiche produit + composeur mur). */
window.MurRecent = (function () {
  var KEY = "affichely:recently-viewed";
  var MAX = 24;
  /* Une valeur illisible ou d'un ancien format restait bloquée pour toujours : read()
     renvoyait [] sans jamais rien réécrire, donc la liste paraissait vide en permanence
     sur cette session alors qu'elle fonctionnait en navigation privée. On purge la clé
     dès qu'elle n'est pas exploitable — la reconstituer coûte une visite de fiche. */
  function read() {
    var brut = localStorage.getItem(KEY);
    if (brut == null) return [];
    try {
      var a = JSON.parse(brut);
      if (!Array.isArray(a)) { localStorage.removeItem(KEY); return []; }
      var ok = a.filter(function (x) { return x && x.handle && x.img; });
      if (!ok.length && a.length) localStorage.removeItem(KEY);
      return ok;
    } catch (e) {
      try { localStorage.removeItem(KEY); } catch (e2) {}
      return [];
    }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); } catch (e) {}
  }
  function push(item) {
    if (!item || !item.handle || !item.img) return;
    var a = read().filter(function (x) { return x.handle !== item.handle; });
    a.unshift({
      handle: String(item.handle),
      title: String(item.title || item.handle),
      img: String(item.img),
      variants: item.variants && typeof item.variants === "object" ? item.variants : {},
      ts: Date.now()
    });
    write(a);
  }
  return { KEY: KEY, MAX: MAX, read: read, push: push };
})();

/* Infobulles « i » des specs : fermeture au clic ailleurs.
 *
 * Elles sont des <details> natifs, ce qui leur donne le clavier et le toucher sans JS. Mais un
 * <details> n'a AUCUNE fermeture au clic extérieur : à la souris le :hover masquait le problème,
 * au doigt il n'y a pas de survol, et la bulle restait ouverte tant qu'on ne retapait pas
 * exactement sur le « i » de 16 px. Signalé sur mobile le 31/07/2026.
 *
 * Une seule ouverte à la fois : deux bulles voisines se chevauchent (la première s'ouvre vers le
 * haut, les deux dernières vers le bas), et deux boîtes sombres superposées ne se lisent plus.
 */
(function () {
  "use strict";
  function toutes() { return [].slice.call(document.querySelectorAll("details.spec-info[open]")); }
  function fermer(sauf) {
    toutes().forEach(function (d) { if (d !== sauf) d.removeAttribute("open"); });
  }
  // `toggle` ne remonte pas naturellement : capture, sinon l'ouverture d'une bulle passe inaperçue.
  document.addEventListener("toggle", function (e) {
    var d = e.target;
    if (d && d.matches && d.matches("details.spec-info") && d.open) fermer(d);
  }, true);
  /* pointerdown, pas click : sur iOS un tap sur une zone sans gestionnaire ne produit pas
     toujours de `click`, et la bulle survivait au geste censé la fermer. */
  document.addEventListener("pointerdown", function (e) {
    if (!toutes().length) return;
    var dans = e.target && e.target.closest ? e.target.closest("details.spec-info") : null;
    fermer(dans);
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") fermer(null); });
})();
/* recover-bust-20260723210308 */

/* Aide (en-tete) : la fenetre se referme au clic ailleurs et a Echap. */
(function () {
  document.addEventListener("click", function (e) {
    var aide = document.getElementById("aide-menu");
    if (aide && aide.open && !aide.contains(e.target)) aide.open = false;
  });
  document.addEventListener("keydown", function (e) {
    var aide = document.getElementById("aide-menu");
    if (e.key === "Escape" && aide && aide.open) aide.open = false;
  });
})();

/* Balise panier pour le Studio : chaque ajout reussi au panier envoie une empreinte
   anonyme a l'endpoint de la popup de sortie, qui remplit les colonnes Panier / Achat
   des reponses recentes (02/08/2026). Le corps ne porte que le chemin de la page ;
   l'empreinte se calcule cote serveur, comme pour les reponses. */
(function () {
  var ENDPOINT = 'https://runway.dcomdtf.app/exit-survey/panier';

  /* ⛔ LE PAIEMENT INITIE N'A PAS DE WEBHOOK (12/08/2026). Shopify previent le serveur quand une
     commande est PAYEE, jamais quand quelqu'un entre dans le tunnel : cote serveur, ce geste
     n'existe pas si le navigateur ne le dit pas. On l'annonce donc au moment ou la personne
     part vers /checkout, avant que la page ne change.
     ⚠️ `keepalive`, sinon la navigation tue la requete a mi-chemin et le geste se perd
     exactement quand il compte le plus. */
  function baliser(geste, cents) {
    try {
      /* ⛔ `forigine`, PAS `window.fetch`. Cette fermeture remplace window.fetch pour espionner
         /cart/add : passer par la version remplacee ferait transiter nos propres balises par
         l'espion. Ca ne boucle pas aujourd'hui parce que l'endpoint n'est pas /cart/add, mais
         c'est un piege qui n'attend qu'une URL. */
      forigine(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          path: location.pathname,
          geste: geste,
          valeur_cents: cents || 0,
          clic: (window.afSignal && window.afSignal.clic()) || '',
          consentement: (window.afSignal && window.afSignal.consentement()) || ''
        }),
        keepalive: true, mode: 'cors', credentials: 'omit', signal: afSignalCourt(2500)
      }).catch(function () {});
    } catch (e) {}
  }

  /* ⛔ PAS DE SECOND ECOUTEUR DE PAIEMENT. Le theme en a deja un, `noteCheckout`, et il sait
     trois choses que ma premiere version ignorait : il y a DEUX boutons « Commander » (le tiroir
     rend un lien, la page /cart un bouton de formulaire), il faut aussi ecouter le `submit` pour
     la validation au clavier, et le montant se lit sur `[data-cart-total]` du panier reellement
     rendu, avec le dernier total connu en repli. Tout cela a ete paye une fois, le 03/08/2026,
     quand « 0 passage au paiement » s'affichait a cote de commandes bien reelles.
     On expose donc la balise, et c'est `noteCheckout` qui l'appelle. */
  window.afBaliser = baliser;
  var forigine = window.fetch;
  if (!forigine) return;
  window.fetch = function (entree) {
    var url = typeof entree === 'string' ? entree : (entree && entree.url) || '';
    var p = forigine.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (r) {
        if (!r || !r.ok) return;
        /* ⛔⛔ LA VALEUR DE L'ARTICLE AJOUTE, A COTE DE CELLE DU PANIER (Adrien, 13/08/2026,
           mesure sur les deux exports). Google recevait le TOTAL DU PANIER sur chaque ajout au
           panier, Meta la valeur de l'article : sur un panier de trois articles, Google comptait
           26,67 + 39,08 + 47,58 = 113 € d'AddToCart pour un panier qui en vaut 47,58. L'addition
           le prouvait a l'euro pres (47,58 = 29,83 + 17,75). Les deux regies ne pouvaient donc
           ni se comparer, ni optimiser sur la meme chose, et c'est Google qui avait tort : sa
           doc demande la valeur des ARTICLES AJOUTES.
           ⚠️ LE TOTAL DU PANIER RESTE, il ne change pas de sens : c'est lui que le Studio affiche
           dans « ce que la personne avait dans son panier en partant » (03/08/2026). On ajoute un
           champ, on n'en detourne pas un.
           ⚠️ `clone()` PARCE QUE LE CORPS NE SE LIT QU'UNE FOIS : le theme lit lui aussi cette
           reponse pour rafraichir le tiroir. Sans le clone, l'un des deux recevrait un flux deja
           consomme, et c'est le tiroir qui casserait. */
        var ajoutCents = null;
        var lireAjout = function () {
          try {
            return r.clone().json().then(function (j) {
              /* `final_line_price` = le prix de la ligne ajoutee, quantite comprise et remises
                 appliquees. `items[0]` couvre la forme /cart/add.js qui rend un objet `items`. */
              var l = j && (j.items && j.items.length ? j.items[0] : j);
              var c = l && (l.final_line_price != null ? l.final_line_price : l.line_price);
              ajoutCents = (typeof c === 'number' && isFinite(c) && c >= 0) ? c : null;
            }).catch(function () {});
          } catch (e) { return Promise.resolve(); }
        };
        var envoyer = function (cents) {
          try {
            forigine(ENDPOINT, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              /* Le MONTANT du panier, pas seulement le fait : le Studio affiche ce que
                 la personne avait dans son panier en partant, pas une coche
                 (Adrien, 03/08/2026). */
              /* ⛔ LE CLIC ET LE CONSENTEMENT VOYAGENT AVEC LE GESTE (12/08/2026). Un
                 ClickConversion sans identifiant de clic n'est rattachable a rien, et Google le
                 refuse : sans ces deux champs, l'ajout au panier serveur ne peut pas exister.
                 ⚠️ On les envoie TELS QUELS, y compris « pub=no » : c'est le SERVEUR qui refuse
                 d'envoyer, pas le navigateur qui se tait. Une balise qui s'abstient toute seule
                 rend le refus invisible, et on ne saurait plus distinguer « pas de consentement »
                 de « la balise n'est pas passee ». */
              body: JSON.stringify({
                path: location.pathname,
                geste: 'ajout_panier',
                valeur_cents: cents || 0,
                /* La valeur de CE QUI VIENT D'ETRE AJOUTE : c'est elle qui part aux regies.
                   Absente, le serveur retombe sur le total du panier, comme avant. */
                valeur_ajout_cents: ajoutCents,
                clic: (window.afSignal && window.afSignal.clic()) || '',
                consentement: (window.afSignal && window.afSignal.consentement()) || ''
              }),
              keepalive: true,
              mode: 'cors',
              credentials: 'omit'
            }).catch(function () {});
          } catch (e) {}
        };
        /* On relit le panier APRES l'ajout : la reponse de /cart/add ne porte que la
           ligne ajoutee, et c'est le total qui nous interesse. Sans prefixe de langue :
           un nombre n'a pas de traduction, et l'endpoint repond partout. */
        try {
          lireAjout().then(function () {
            return forigine('/cart.js', { credentials: 'same-origin' })
              .then(function (rc) { return rc && rc.ok ? rc.json() : null; })
              .then(function (j) { envoyer(j && j.total_price); });
          }).catch(function () { envoyer(0); });
        } catch (e) { envoyer(0); }
      }).catch(function () {});
    }
    return p;
  };
})();

/* ⛔ QUELLE PORTE A OUVERT LE COMPOSEUR (Adrien, 07/08/2026). La page de composition mesure
   sa source d'ouverture, et elle ne peut pas la deduire : deux portes y menent, l'entree du
   menu Creer et la carte « Composer mon mur » de la fiche produit, et le referent ne les
   distingue pas. Il disait « produit » quand on cliquait le MENU depuis une fiche, et
   « direct » quand la carte de la fiche ouvrait la modale, faute de navigation.
   Chaque porte porte donc son nom, et le clic le depose dans la session ; la page le lit et
   le consomme. Ce fichier est charge partout, l'ecoute est deleguee : les liens du menu sont
   reconstruits a chaque ouverture de rubrique. */
/* ⚠️ UN SEUL MECANISME POUR LES DEUX OUTILS. « Ma piece » n'enregistrait aucune porte : sa
   colonne Source aurait demande une deuxieme plomberie, qui aurait diverge de la premiere
   des la premiere retouche. L'attribut s'appelle donc `data-creation-source`, pas
   `data-composeur-source`, et le composeur comme la palette le lisent au meme endroit.
   ⛔ ET IL PORTE LE HANDLE. La valeur est « produit:<handle> » quand la porte est une fiche,
   « menu » sinon : le Studio veut savoir QUELLE affiche envoie vers l'outil. */
(function () {
  document.addEventListener("click", function (e) {
    var a = e.target && e.target.closest ? e.target.closest("[data-creation-source]") : null;
    if (!a) return;
    var src = a.getAttribute("data-creation-source") || "";
    var handle = a.getAttribute("data-creation-handle") || "";
    try { sessionStorage.setItem("af:creation-src", handle ? src + ":" + handle : src); } catch (err) {}
  }, true);
})();
/* La porte declaree, lue UNE fois : la modale la pose sur window (aucune navigation), le
   clic la depose en session quand il y a vraiment navigation. On la consomme pour qu'un
   retour en arriere n'attribue pas la meme porte deux fois. */
window.afPorteCreation = function () {
  try {
    if (window.__creationSource) { var w = window.__creationSource; window.__creationSource = ""; return w; }
    var jeton = sessionStorage.getItem("af:creation-src") || "";
    if (jeton) sessionStorage.removeItem("af:creation-src");
    return jeton;
  } catch (e) { return ""; }
};

/* La racine de langue, pour les blocs qui vivent HORS de la grande fermeture de ce fichier et
   qui n'ont donc pas acces a `urlPanier`. Meme source, `window.MURMURE_RACINE`, jamais une
   deduction depuis `location.pathname` : un chemin peut porter une langue sans que la boutique
   la serve. */
function afRacine() {
  return String(window.MURMURE_RACINE || '/').replace(/\/$/, '');
}

/* ⛔ L'APPAREIL DE LA COMMANDE, POSE SUR LE PANIER (Adrien, 10/08/2026).
 *
 * Shopify NE DONNE PAS l'appareil d'une commande : verifie dans son schema, `CustomerVisit`
 * expose la source, la page d'arrivee et les UTM, jamais le materiel. Sans cette ligne, l'onglet
 * Ventes par appareil serait une devinette.
 *
 * Un attribut de panier, lui, remonte tel quel sur la commande et survit au passage en caisse.
 * C'est le chemin standard, et le seul qui soit EXACT.
 *
 * ⚠️ LES MEMES REGLES QUE LE SERVEUR, MOT POUR MOT. Si le navigateur classait autrement que
 * `exitDeviceFromUa`, les visiteurs et les ventes ne parleraient pas du meme decoupage, et le
 * taux de conversion par appareil serait faux sans que rien ne le signale. Les trois tests
 * ci-dessous sont la copie de ceux du serveur : toute retouche va aux DEUX endroits.
 *
 * ⚠️ POSE UNE SEULE FOIS PAR SESSION : l'attribut ne change pas en cours de route, et une
 * ecriture par ajout au panier serait autant d'appels pour rien.
 */
(function appareilSurLePanier() {
  var forigine = window.fetch;
  if (!forigine) return;
  var appareil = (function (s) {
    if (/iPad|Tablet|Kindle|Silk|PlayBook|(Android(?!.*Mobile))/i.test(s)) return 'tablet';
    if (/Mobi|iPhone|iPod|Android.*Mobile|Windows Phone|Opera Mini|webOS|BlackBerry/i.test(s)) {
      return 'mobile';
    }
    return 'desktop';
  })(navigator.userAgent || '');
  var pose = false;
  var poser = function () {
    if (pose) return;
    try { if (sessionStorage.getItem('appareil_panier') === appareil) { pose = true; return; } } catch (e) {}
    pose = true;
    try {
      /* ⛔ LA RACINE DE LANGUE, ICI AUSSI. L'adresse etait ecrite en dur « /cart/update.js » :
         c'est exactement la faute deja apprise plus haut dans ce fichier (« TOUJOURS LA RACINE
         DE LANGUE SUR LES ADRESSES PANIER »), et elle se reproduit parce que ce bloc vit HORS
         de la fermeture qui tient `urlPanier`. On relit donc la meme source, `MURMURE_RACINE`. */
      forigine(afRacine() + '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: { appareil: appareil } })
      }).then(function () {
        try { sessionStorage.setItem('appareil_panier', appareil); } catch (e) {}
      }).catch(function () {});
    } catch (e) {}
  };
  var vieux = window.fetch;
  window.fetch = function (entree) {
    var url = typeof entree === 'string' ? entree : (entree && entree.url) || '';
    var p = vieux.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (r) { if (r && r.ok) poser(); }).catch(function () {});
    }
    return p;
  };
})();

/* ⛔ L'ORIGINE DE LA COMMANDE, PORTEE JUSQU'AU PANIER (Adrien, 10/08/2026).
 *
 * MESURE QUI JUSTIFIE CE BLOC, faite le 10/08/2026 sur trente jours : 99 commandes valides,
 * ZERO portant le moindre identifiant de clic. Les identifiants existent pourtant dans le
 * navigateur (`_fbc`, `__parkour_fbclid`, `__parkour_gclid`) et ils s'y arretent. Meta recoit
 * donc des achats sans identifiant de clic et ne peut les rattacher a aucune campagne : c'est
 * exactement ce qu'Adrien constatait, et la cause est ici, pas chez Meta.
 *
 * ⛔ PREMIER TOUCHE **ET** DERNIER TOUCHE, DEUX CHAMPS, PAS UN. Un client qui arrive par Meta
 * puis revient par Google n'a pas une origine, il en a deux. Les ecraser l'une par l'autre
 * fabrique une reponse nette a une question qu'on n'a pas posee, et c'est le genre de chiffre
 * qui se lit comme une verite parce qu'il est unique.
 *
 * ⛔ ON N'OUVRE JAMAIS UN PANIER POUR ECRIRE UN ATTRIBUT. `/cart/update.js` CREE un panier s'il
 * n'y en a pas : appele a l'arrivee, il fabriquerait un panier vide par visiteur et noierait les
 * paniers abandonnes sous des fantomes. On n'ecrit donc qu'APRES un ajout reussi, comme
 * `appareil` au-dessus, et jamais avant.
 *
 * ⚠️ `_fbp` N'EXISTE QU'APRES LE CONSENTEMENT, et le consentement peut arriver APRES l'ajout au
 * panier. Poser une seule fois par session, comme `appareil`, perdrait ce cas. L'attribut se
 * repose donc quand sa signature change, et SEULEMENT dans ce cas.
 *
 * ⚠️ LE CONSENTEMENT VOYAGE AVEC LA DONNEE. Adrien a tranche le 10/08/2026 pour l'envoi cote
 * serveur de tous les visiteurs, l'etat du consentement joint. Le serveur ne peut le joindre que
 * si le navigateur le lui dit : c'est `_af_cons`. Sans ce champ, la decision serait intenable.
 */
(function origineSurLePanier() {
  var forigine = window.fetch;
  if (!forigine) return;

  var CLE1 = 'af:o1';   /* premier touche, ecrit une fois, jamais reecrit */
  var CLEN = 'af:of';   /* dernier touche, reecrit a chaque nouvelle arrivee de campagne */
  var CLES = 'af:osig'; /* signature de ce qui a deja ete pose, pour ne pas reposer pour rien */

  function lireStock(cle) {
    try { return JSON.parse(localStorage.getItem(cle) || 'null'); } catch (e) { return null; }
  }
  function ecrireStock(cle, v) {
    try { localStorage.setItem(cle, JSON.stringify(v)); } catch (e) {}
  }
  function cookie(nom) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + nom.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function coupe(s, n) { return String(s || '').slice(0, n); }

  var params = (function () {
    try { return new URLSearchParams(location.search); } catch (e) { return { get: function () { return null; } }; }
  })();
  function p(n) { return coupe(params.get(n) || '', 200); }

  /* La source telle qu'on la lira plus tard, deduite dans un ordre qui ne se discute pas :
     un identifiant de clic BAT un utm, parce qu'il est pose par la regie elle-meme et qu'un
     utm se recopie a la main dans n'importe quel lien. */
  function origineCourante() {
    var fbclid = p('fbclid');
    var gclid = p('gclid') || p('gbraid') || p('wbraid');
    var us = p('utm_source'), um = p('utm_medium');
    var src = '', med = '';
    if (gclid) { src = 'google'; med = 'cpc'; }
    else if (fbclid) { src = 'meta'; med = 'paid'; }
    else if (us) { src = us; med = um || 'inconnu'; }
    else {
      var ref = '';
      try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
      if (ref && ref.indexOf(location.hostname) === -1) { src = ref; med = 'referral'; }
      else { src = 'direct'; med = 'aucun'; }
    }
    return {
      s: src, m: med,
      c: p('utm_campaign'), n: p('utm_content'), t: p('utm_term'),
      d: new Date().toISOString().slice(0, 19) + 'Z',
      /* La page d'ARRIVEE, sans les identifiants de clic : ils vivent dans `_af_clic`, et ils
         n'ont rien a faire dans un champ qu'un humain lira dans la fiche de commande.
         ⚠️ ECRIT PAR DECOUPAGE, PAS PAR EXPRESSION REGULIERE. La premiere version filtrait
         `(^|&)(fbclid|...)=` sur `location.search`, qui commence par « ? » : le motif ne
         trouvait donc jamais le PREMIER parametre, et le fbclid restait en clair. Le banc
         d'essai l'a vu au premier cas. Un decoupage n'a pas de bord a rater. */
      p: coupe(location.pathname + (function () {
        var reste = String(location.search || '').replace(/^\?/, '').split('&').filter(function (kv) {
          return kv && !/^(fbclid|gclid|gbraid|wbraid)=/.test(kv);
        });
        return reste.length ? '?' + reste.join('&') : '';
      })(), 180)
    };
  }

  /* Une arrivee de CAMPAGNE, pas une simple page vue : sans ca, le dernier touche deviendrait
     « direct » a chaque clic interne, et effacerait la vraie derniere origine. */
  function estArrivee() {
    return !!(p('fbclid') || p('gclid') || p('gbraid') || p('wbraid') || p('utm_source'));
  }

  /* ⛔ LES IDENTIFIANTS DE CLIC SE GARDENT, ILS NE SE RELISENT PAS DANS L'URL.
     `identifiants()` les prenait dans `location.search` a l'instant ou l'attribut de panier se
     pose. Or ce moment n'est presque jamais la page d'arrivee : le visiteur clique la pub,
     navigue, ajoute au panier trois pages plus loin, et le parametre a disparu depuis
     longtemps. Le `gclid` avait un repli, le cookie `__parkour_gclid` de l'app Google ; mais
     `gbraid` et `wbraid` n'en avaient AUCUN, et ce sont precisement les identifiants du trafic
     iOS, celui qu'on rattache deja le plus mal.
     ⛔ ET `fbclid` N'ETAIT ECRIT NULLE PART. Le pixel Meta lit pourtant une cle `fbclid` en
     stockage pour reconstruire `fbc` : elle n'a jamais existe. Tant que l'app Facebook posait
     le cookie `_fbc`, le repli suffisait ; depuis sa deconnexion le 10/08/2026, plus personne
     ne le pose, et l'identifiant de clic Meta se perdait des la seconde page.
     ⚠️ 90 JOURS, ET L'HORODATAGE DU CLIC AVEC. La fenetre de reflexion de Google va jusqu'a 90
     jours ; au-dela, l'identifiant ne vaut plus rien et le garder ferait rattacher une vente a
     un clic hors fenetre. L'horodatage sert aussi a fabriquer un `fbc` a la bonne date : le
     dater d'aujourd'hui sortirait la conversion de sa fenetre d'attribution. */
  var CLECLIC = 'af:clic';
  var CLIC_MS = 90 * 24 * 60 * 60 * 1000;

  function lireClics() {
    var v = lireStock(CLECLIC);
    if (!v || !v.ts) return null;
    if (Date.now() - v.ts > CLIC_MS) return null;
    return v;
  }

  function memoriserClics() {
    var neuf = {
      gclid: p('gclid'),
      gbraid: p('gbraid'),
      wbraid: p('wbraid'),
      fbclid: p('fbclid')
    };
    if (!neuf.gclid && !neuf.gbraid && !neuf.wbraid && !neuf.fbclid) return;
    /* Le dernier clic ecrase le precedent : c'est le modele d'attribution des deux regies, et
       garder l'ancien attribuerait la vente a la mauvaise campagne. */
    neuf.ts = Date.now();
    ecrireStock(CLECLIC, neuf);
    /* Sous le nom que le pixel Meta lit deja, et dans la forme qu'il sait ouvrir : un seul
       ecrivain, un seul lecteur, aucune convention a retenir de part et d'autre. */
    if (neuf.fbclid) ecrireStock('fbclid', { value: neuf.fbclid, ts: neuf.ts });
  }
  memoriserClics();

  /* ⛔ LE CONTEXTE DE SESSION DE GOOGLE (`AdIdentifiers.sessionAttributes`), pose le 11/08/2026.
     Il rattache les arrivees qui ont garde le marqueur de campagne mais PERDU le gclid : Safari
     et son ITP, le mode consentement, les chaines de redirection. Ni `gclid` ni `gbraid` ne
     savent le faire, et c'est la seule chose qui les complete.

     ⛔ IL SE CONSTRUIT A L'ARRIVEE, PAS A LA COMMANDE, parce qu'il DECRIT l'arrivee : l'URL, le
     referent, l'instant, le navigateur de ce moment-la. Le fabriquer au panier donnerait un
     contexte de session qui ne decrit aucune session.
     ⚠️ ET LA CONDITION VIENT DE GOOGLE, mot pour mot : on ne fabrique la valeur QUE si l'URL
     porte un `gad_*`, un `gclid` ou un `gbraid`. Une arrivee sans aucun des trois ne produit
     RIEN, et c'est normal : il n'y a pas de campagne a decrire. Sinon on relit la memoire.

     ⛔⛔ `btoa` NE SAIT PAS ENCODER L'UTF-8, ET LE CODE D'EXEMPLE DE GOOGLE NON PLUS. Il leve
     une `InvalidCharacterError` des qu'un caractere depasse U+00FF. Un referent ou une URL
     d'arrivee accentuee suffirait a faire lever la fonction ENTIERE, donc a perdre le contexte
     de session ET tout ce que ce bloc pose apres lui. On passe donc par `encodeURIComponent`,
     qui rend de l'ASCII, avant d'encoder. Ce n'est pas de la prudence de principe : nos handles
     de collection et nos pages de recherche portent des accents. */
  var CLESESS = 'af:gsa';

  function encodeBase64Url(texte) {
    /* UTF-8 vers latin1 : chaque octet devient un caractere que `btoa` accepte. */
    var octets = unescape(encodeURIComponent(texte));
    return btoa(octets).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  function memoriserSession() {
    var q = String(location.search || '');
    var gads = {};
    String(q.replace(/^\?/, '')).split('&').forEach(function (kv) {
      var i = kv.indexOf('=');
      if (i <= 0) return;
      var k = decodeURIComponent(kv.slice(0, i));
      if (k.indexOf('gad_') === 0) gads[k] = decodeURIComponent(kv.slice(i + 1).replace(/\+/g, ' '));
    });
    var marque = Object.keys(gads).length || p('gclid') || p('gbraid');
    if (!marque) return;

    var champs = {};
    Object.keys(gads).forEach(function (k) { champs[k] = gads[k]; });
    /* ⛔ MICROSECONDES, PAS MILLISECONDES. `Date.now()` rend des millisecondes ; la doc demande
       des microsecondes. Un facteur mille place la session en 1970, et Google ne s'en plaint
       PAS : il rattache juste moins bien, en silence. C'est le defaut le plus couteux de ce
       champ, parce qu'aucun symptome ne le signale. */
    champs.session_start_time_usec = String(Date.now() * 1000);
    champs.landing_page_url = coupe(location.href, 900);
    champs.landing_page_referrer = coupe(document.referrer || '', 900);
    champs.landing_page_user_agent = coupe(navigator.userAgent || '', 500);

    var jeton;
    try { jeton = encodeBase64Url(JSON.stringify(champs)); } catch (e) { return; }
    /* 5 ko conseilles par Google. On coupe les deux champs FACULTATIFS avant de renoncer :
       l'URL et le referent sont les seuls a pouvoir gonfler, et le socle doit survivre. */
    if (jeton.length > 5120) {
      delete champs.landing_page_referrer;
      delete champs.landing_page_url;
      try { jeton = encodeBase64Url(JSON.stringify(champs)); } catch (e) { return; }
      if (jeton.length > 5120) return;
    }
    ecrireStock(CLESESS, { v: jeton, ts: Date.now() });
  }
  /* ⛔ SOUS FILET, ET CE N'EST PAS DE LA PRUDENCE DE PRINCIPE. Cette fonction lit `navigator`,
     `document.referrer` et `localStorage`, et elle tourne AVANT `_af_clic` et les origines. Une
     seule de ces lectures qui leve emporterait tout le bloc d'attribution avec elle : on
     perdrait le gclid, le fbc et le premier touche pour gagner un contexte de session. Le
     contexte est un COMPLEMENT, il ne peut pas coûter le socle.
     ⚠️ Le banc `origine.test.js` l'a montre en une ligne le 11/08/2026 : son DOM de theatre
     n'avait pas de `navigator`, et les deux cas d'origine sont tombes d'un coup. */
  try { memoriserSession(); } catch (e) {}

  /* La memoire vaut ce que vaut la fenetre de reflexion : au-dela de 90 jours, le contexte ne
     rattache plus rien et le garder ferait decrire une session qui n'existe plus. Meme borne
     que les identifiants de clic, juste au-dessus. */
  function lireSession() {
    var v = lireStock(CLESESS);
    if (!v || !v.ts || !v.v) return '';
    if (Date.now() - v.ts > CLIC_MS) return '';
    return String(v.v);
  }

  var o = origineCourante();
  if (!lireStock(CLE1)) ecrireStock(CLE1, o);
  if (estArrivee() || !lireStock(CLEN)) ecrireStock(CLEN, o);

  function plat(x) {
    if (!x) return '';
    var bouts = [];
    if (x.s) bouts.push('s=' + x.s);
    if (x.m) bouts.push('m=' + x.m);
    if (x.c) bouts.push('c=' + x.c);
    if (x.n) bouts.push('n=' + x.n);
    if (x.t) bouts.push('t=' + x.t);
    if (x.d) bouts.push('d=' + x.d);
    return coupe(bouts.join(';'), 400);
  }

  function identifiants() {
    var bouts = [];
    /* L'URL d'abord quand elle porte le clic, la memoire ensuite. Le cookie de l'app Google
       ne vient qu'en dernier : il n'existe que sous consentement, et l'app peut disparaitre. */
    var garde = lireClics() || {};
    var fbclid = p('fbclid') || garde.fbclid || '';
    var quand = garde.ts || Date.now();
    var fbc = cookie('_fbc') || (fbclid ? 'fb.1.' + quand + '.' + fbclid : '');
    var fbp = cookie('_fbp');
    var g = p('gclid') || garde.gclid || cookie('__parkour_gclid');
    var gb = p('gbraid') || garde.gbraid;
    var wb = p('wbraid') || garde.wbraid;
    if (fbc) bouts.push('fbc=' + fbc);
    if (fbp) bouts.push('fbp=' + fbp);
    if (g) bouts.push('gclid=' + g);
    if (gb) bouts.push('gbraid=' + gb);
    if (wb) bouts.push('wbraid=' + wb);
    return coupe(bouts.join(';'), 500);
  }

  /* ⚠️ L'ETAT DU CONSENTEMENT SE LIT, IL NE SE SUPPOSE PAS. CookieYes ecrit son verdict dans un
     cookie ; on rend « pub » et « mesure » separement, parce que les deux se refusent
     separement et que le serveur n'en fait pas le meme usage. */
  function consentement() {
    var c = cookie('cookieyes-consent');
    if (!c) return 'inconnu';
    var pub = /advertisement:(yes|no)/.exec(c);
    var mes = /analytics:(yes|no)/.exec(c);
    return 'pub=' + (pub ? pub[1] : '?') + ';mesure=' + (mes ? mes[1] : '?');
  }

  function aPoser() {
    return {
      _af_o1: plat(lireStock(CLE1)),
      _af_of: plat(lireStock(CLEN)),
      _af_land: coupe((lireStock(CLE1) || {}).p || '', 180),
      _af_clic: identifiants(),
      /* ⚠️ SON PROPRE ATTRIBUT, PAS `_af_clic`. Celui-ci est une liste `cle=valeur` separee par
         des `;` ; le jeton fait jusqu'a 5 ko de base64url, et l'y glisser ferait dependre un
         champ long d'un format concu pour cinq identifiants courts. */
      _af_gsa: lireSession(),
      _af_cons: consentement()
    };
  }

  /* ⛔ UNE SEULE FORMULE POUR L'IDENTIFIANT DE CLIC ET POUR LE CONSENTEMENT.
     La balise panier vit dans une autre fermeture et en a besoin aussi : sans ce pont, elle
     relirait l'URL, la memoire et les cookies de son cote, et les deux lectures divergeraient
     le jour ou l'une des trois sources change. Le clic pose sur la COMMANDE et le clic pose sur
     le PANIER doivent etre le meme, sinon Google recevra deux histoires du meme visiteur. */
  window.afSignal = { clic: identifiants, consentement: consentement };

  var enCours = false;
  /* ⛔⛔ LE PANIER FAIT FOI, PAS `sessionStorage` (13/08/2026, tache 280).
   *
   * MESURE : sur les 52 commandes depuis la mise en ligne de ces attributs (10/08 10:50), TROIS
   * n'en portent AUCUN — 1107, 1119 et 1143 — alors que `_af_cons` ne peut jamais etre vide
   * (`consentement()` rend « inconnu » a defaut de cookie). Leur absence prouve donc que
   * l'ecriture n'a pas eu lieu, et pas qu'il n'y avait rien a ecrire. C'est la commande 1143 qui
   * explique la vente manquante du 12/08 dans l'import serveur : sans identifiant de clic sur la
   * commande, le serveur n'a rien a envoyer a Google, qui l'a comptee de son cote.
   *
   * ⛔ CE QUE LA GARDE AFFIRMAIT DE FAUX. `sessionStorage` dit « je l'ai deja pose », pas « il y
   * est ». Entre les deux, le panier peut avoir ete recree : il expire, le client le vide, ou
   * Shopify en ouvre un neuf. La signature, elle, ne change pas — c'est la meme visite, donc la
   * meme origine et le meme consentement. La garde renvoyait alors « rien a faire » sur un
   * panier VIDE d'attributs, et la commande partait sans son identifiant de clic.
   *
   * ⚠️ ON NE SUPPRIME PAS LA GARDE, ON LA REBRANCHE SUR LA BONNE SOURCE. La supprimer ferait
   * repartir un `cart/update.js` a chaque evenement, y compris pour rien. La question n'est pas
   * « l'ai-je deja envoye » mais « le panier les a-t-il », et cette reponse-la se lit dans le
   * panier. Un ajout au panier force la verification : c'est exactement le moment ou un panier
   * neuf peut venir d'apparaitre.
   */
  function poser(forcer) {
    if (enCours) return;
    var attrs = aPoser();
    var sig = JSON.stringify(attrs);
    var deja = '';
    try { deja = sessionStorage.getItem(CLES) || ''; } catch (e) {}
    if (sig === deja && !forcer) return;
    if (sig === deja && forcer) {
      /* Meme signature ET ajout au panier : on va VOIR si le panier les porte encore, au lieu
         de croire la memoire de session. Une seule lecture, et seulement dans ce cas. */
      forigine(afRacine() + '/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (c) {
          var a = (c && c.attributes) || {};
          /* `_af_cons` n'est jamais vide quand l'ecriture a abouti : c'est le temoin le plus
             sur, et il ne depend ni d'une origine ni d'un identifiant de clic, qui peuvent
             legitimement manquer sur une visite directe. */
          if (!a._af_cons) { try { sessionStorage.removeItem(CLES); } catch (e) {} poser(); }
        })
        .catch(function () {});
      return;
    }
    enCours = true;
    forigine(afRacine() + '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) {
      enCours = false;
      if (!r || !r.ok) return;
      try { sessionStorage.setItem(CLES, sig); } catch (e) {}
    }).catch(function () { enCours = false; });
  }

  var vieux2 = window.fetch;
  window.fetch = function (entree) {
    var url = typeof entree === 'string' ? entree : (entree && entree.url) || '';
    var pr = vieux2.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      /* `true` : un ajout au panier est le seul moment ou un panier NEUF peut apparaitre. On
         verifie donc que les attributs y sont, au lieu de se fier a la memoire de session. */
      pr.then(function (r) { if (r && r.ok) poser(true); }).catch(function () {});
    }
    return pr;
  };

  /* Le consentement peut arriver APRES l'ajout au panier : `_fbp` n'existe qu'a ce moment. On
     ne repose que si un panier existe DEJA, c'est-a-dire si on a deja pose une fois. */
  document.addEventListener('cookieyes_consent_update', function () {
    try { if (sessionStorage.getItem(CLES)) setTimeout(poser, 1200); } catch (e) {}
  });
})();

/* ------------------------------------------------------------------ bandeau promo compact

   LA BARRE DE PROMOTION SE TASSE QUAND ON DESCEND, SUR TELEPHONE (Adrien, 15/08/2026 : « quand
   on scroll vers le bas sur mobile, la barre de promotion doit rester sticky mais reduite en
   hauteur, sans le compteur »).

   ⛔ ELLE EST DEJA STICKY, ET C'EST TOUT L'INTERET. `.site-header` porte `position:sticky` et
   la barre vit dedans : elle suit donc deja le scroll. Ce qu'on ajoute n'est pas un
   positionnement, c'est un ETAT. Le refaire en `position:fixed` aurait sorti la barre du flux,
   decolle le menu, et casse le calcul de hauteur dont depend la galerie collante des fiches.

   ⚠️ LA CLASSE SE POSE TOUJOURS, LA MISE EN FORME EST GARDEE PAR LA FEUILLE. Tester la largeur
   ici obligerait a re-tester a chaque rotation d'ecran et a chaque redimensionnement, et un
   telephone tourne en cours de lecture serait reste dans l'etat de l'orientation precedente.
   Le media query de `base.css` decide, lui, a chaque peinture.

   ⚠️ SEUIL A 40 px ET NON A ZERO : sur iOS, le rebond en haut de page rend des valeurs
   negatives puis positives en rafale, et un seuil a zero ferait clignoter la barre pendant le
   rebond. 40 px, c'est plus que le rebond et moins qu'une premiere ligne de texte. */
(function () {
  var entete = document.querySelector('.site-header');
  /* ⛔ LE BANDEAU PRO SE TASSE COMME CELUI DE LA PROMO (Adrien, 23/08/2026). Le garde-fou ne
     nommait que `.summer-bar`, donc rien ne se tassait sur le parcours professionnel : la promo
     y est masquee, et hors periode de promo elle n'est meme pas rendue.
     ⛔ ET LA CONDITION RESTE EXACTEMENT CELLE D'AVANT POUR LE GRAND PUBLIC. `.pro-bar` est rendu
     sur TOUTES les pages, donc le nommer sans condition aurait mis l'en-tete en tassement chez
     tout le monde, y compris les jours sans promo ou il ne se tassait pas. On ne le compte que
     si le parcours professionnel est ouvert, et `pro-funnel.js` a deja pose l'attribut : il est
     charge sans `defer`, ce fichier avec. */
  var barreTassable = entete && (entete.querySelector('.summer-bar')
    || (document.documentElement.getAttribute('data-pro') === '1' && entete.querySelector('.pro-bar')));
  if (!entete || !barreTassable) return;

  /* ⛔ LA BANDE DE PROMESSES S'EN VA EN DEFILANT, PAS EN SE REPLIANT (Adrien, 15/08/2026 :
     « comme si on scrollait a l'interieur et qu'elle etait bloquee », desenio.fr en exemple).
     Le mecanisme est entierement dans base.css : `#shopify-section-header` colle a
     `top: calc(-1 * var(--promise-h))`, donc la hauteur de la bande passe au-dessus du bord
     de l'ecran avant que le reste ne s'epingle. Il ne manque que la valeur.

     ⚠️ ELLE SE MESURE, ELLE NE S'ECRIT PAS. Elle change avec la largeur (10,5 px de texte sous
     1200, 12,1 au-dessus) et surtout avec la LANGUE : trois promesses allemandes passent sur
     deux lignes la ou le francais tient sur une. Une valeur en dur couperait la deuxieme ligne
     dans certaines langues et laisserait un bord vide dans d'autres.
     ⚠️ ZERO EST UNE MESURE VALIDE ICI, ET UNE SEULE FOIS. Sous 980 px la bande est en
     `display:none` : sa hauteur vaut 0, l'en-tete colle a `top:0`, l'ancien comportement, et
     c'est exactement ce qu'il faut. Mais un 0 rendu par un onglet qui n'a pas encore de mise
     en page ne veut rien dire : on ne l'ecrit que si `display` confirme que la bande est bien
     masquee. Un zero doit etre explique avant d'etre cru. */
  function mesurerBande() {
    var bande = entete.querySelector('.menu-promise');
    /* ⚠️ ON DEMANDE AVANT DE MESURER. `tests/pied-tiroir.test.js` evalue ce fichier dans un DOM
       simule qui n'a ni `getComputedStyle` ni mise en page : l'appel direct y levait une
       exception au chargement, et emportait le banc entier. Sans navigateur il n'y a rien a
       mesurer et rien a poser, ce qui est la bonne conduite, pas un contournement. */
    if (!bande || typeof window.getComputedStyle !== 'function') return;
    var masquee = window.getComputedStyle(bande).display === 'none';
    var h = masquee ? 0 : bande.offsetHeight;
    if (!masquee && h === 0) return;            /* mise en page pas encore faite : on repassera */
    document.documentElement.style.setProperty('--promise-h', h + 'px');
  }
  mesurerBande();
  window.addEventListener('resize', mesurerBande, { passive: true });
  window.addEventListener('load', mesurerBande);
  /* ⛔ DEUX SEUILS, PAS UN, ET L'ECART EST CALCULE (Adrien, 15/08/2026 : « il y a des positions
     ou le promotion bar est instable et montre plusieurs etats en meme temps »). Se tasser
     RACCOURCIT l'en-tete : le contenu remonte d'autant, l'ancrage du navigateur corrige la
     position de defilement, celle-ci retraverse le seuil, la barre se detasse, et ainsi de
     suite. Un seuil unique se recroise lui-meme, et l'oscillation se voyait a l'ecran.

     L'ECART DOIT DEPASSER LA HAUTEUR RENDUE PAR LE PASSAGE A L'ETAT TASSE :
       telephone   bandeau tasse                    ~22 px
       ordinateur  bandeau tasse, compteur compris  ~35 px
     ⚠️ LA BANDE DE PROMESSES N'ENTRE PLUS DANS CE CALCUL. Elle a compte pendant une heure, le
     15/08 : masquee a l'etat tasse, elle rendait 31 px de plus et portait le saut a ~66, ce
     qui obligeait a entrer a 120. Elle ne se masque plus, elle DEFILE (decalage negatif de
     `#shopify-section-header`), donc elle ne change plus rien a la hauteur de l'etat tasse.
     Le calcul redevient celui du tassement seul, et le seuil revient a 64.
     On entre a 64, on ne sort qu'en dessous de 8 : 56 px d'ecart, plus du double du plus grand
     saut. ⚠️ CES DEUX NOMBRES SE LISENT AVEC LE TABLEAU CI-DESSUS. Toute regle qui ajoute ou
     retire de la hauteur a l'etat tasse doit repasser par ce calcul, sinon elle rouvre
     l'oscillation sans rien toucher a ce fichier. */
  var dernierY = window.pageYOffset || document.documentElement.scrollTop || 0;
  var montee = 0;
  function juger() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var compact = entete.classList.contains('is-compact');
    /* ⛔ IL REVIENT AU GESTE, PAS A L'ARRIVEE EN HAUT DE PAGE (Adrien, serie 335 : « il doit
       revenir a sa taille normale au scroll vers le haut, pas quand on arrive en haut »).
       La condition de sortie etait `y < 8` : depuis le bas d'une collection il fallait
       remonter toute la page pour retrouver la recherche et le logo entier.

       ON SORT SUR LE SENS DU DOIGT, et on entre toujours sur la position. Mais on ACCUMULE la
       remontee au lieu de lire un ecart entre deux evenements, et ce detail est tout le
       correctif : mesure du 15/08, un saut de defilement suivi du tassement de la page
       (chargement paresseux des cartes) rendait 61 px vers le HAUT sans qu'aucun doigt ne
       bouge, et la barre se depliait toute seule. Un ecart instantane ne distingue pas un
       geste d'un reflux ; une somme, si, parce que le reflux s'arrete et le geste continue.
       56 px, c'est le meme nombre que l'ancienne hysterese : plus grand que tout tassement
       observe, bien plus petit qu'une vraie remontee pour retrouver le menu.
       ⚠️ `y > 64` RESTE LA CONDITION D'ENTREE. Sans elle, le moindre geste vers le bas en
       haut de page tasserait l'en-tete alors qu'il n'y a rien a gagner. */
    /* ⛔ DEUX ETATS, PAS UN (Adrien, serie 335 : « pas la promotion bar, celle-ci revient a sa
       hauteur initiale uniquement quand on arrive en haut de la page »). `is-compact` garde
       EXACTEMENT son ancienne loi, celle de la position : elle tasse le bandeau promo, et il
       ne se rouvre qu'au sommet. `is-replie` est neuve et suit le SENS du doigt : elle replie
       le bloc du logo, la recherche et les marges, qui doivent revenir des qu'on remonte.
       Les confondre revenait a donner au bandeau une loi qu'Adrien ne veut pas pour lui. */
    if (!compact && y > 64) entete.classList.add('is-compact');
    else if (compact && y < 8) entete.classList.remove('is-compact');

    var replie = entete.classList.contains('is-replie');
    if (document.body.classList.contains('template-product')) {
      entete.classList.remove('is-replie');
    } else if (y >= dernierY) {
      montee = 0;
      if (!replie && y > 64) entete.classList.add('is-replie');
    } else {
      montee += dernierY - y;
      if (replie && (montee > 56 || y < 8)) { entete.classList.remove('is-replie'); montee = 0; }
    }
    dernierY = y;

    /* ⛔ LA GALERIE GRANDIT AU MOMENT OU LE MENU A FINI DE PARTIR, PAS AVANT, PAS EN PERMANENCE
       (Adrien, serie 304 : « elle ne s'agrandit pas au scroll vers le bas, au moment ou le menu
       disparait completement, comme demande. Les clients ne voient pas bien le rendu live »).

       ⚠️ J'AVAIS LIVRE UN AGRANDISSEMENT PERMANENT en jugeant que c'etait plus propre : pas
       d'etat, pas de saut. Il l'avait demande DECLENCHE, deux fois, et il a raison sur le fond :
       en haut de page l'en-tete est deplie et la place n'existe pas encore ; une galerie deja
       grande y serait coupee. C'est la disparition du menu qui LIBERE les 132 px, donc c'est
       elle qui doit declencher.

       LE SEUIL N'EST PAS UN NOMBRE, C'EST LA COURSE DU MENU : `--site-header-h` moins
       `--promo-h`, les deux mesurees. Quand le defilement a parcouru cette distance, l'en-tete
       a fini de passer au-dessus du bord et il ne reste que le bandeau. Un seuil ecrit en dur
       se decalerait a la premiere langue plus longue ou au premier compteur retire.

       ⛔ ET CE N'EST PLUS UN SEUIL DU TOUT DEPUIS LE 15/08/2026, C'EST UNE COURSE. Adrien :
       « l'agrandissement doit etre progressif, elle doit s'agrandir proportionnellement au
       scroll jusqu'a atteindre sa taille finale quand le menu est completement masque ». Une
       bascule, meme avec hysteresis, restait un saut ; la galerie suit desormais le doigt.
       C'est `poserEchelle` dans product.js qui lit cette course et en tire une echelle, et
       c'est bien LE MEME nombre fige qui sert aux deux : la classe `galerie-agrandie` qui
       vivait ici n'avait plus aucun lecteur, elle est retiree plutot que laissee a trainer. */
  }
  /* ⛔ PAS DE requestAnimationFrame POUR LE VERROU, ET CE DEFAUT ETAIT DEJA LA AVANT MOI. Mesure
     dans le Chrome d'Adrien : `document.visibilityState` valait « hidden », et rAF NE TIRE PAS
     dans un onglet cache. `juger` n'etait jamais rappelee et `attendu` restait a `true` POUR
     TOUJOURS : le verrou ne se relachait plus. Un client qui defile, passe a une autre
     application puis revient tombe dedans, et l'en-tete cesse de reagir pour le reste de la
     visite, sans erreur. Un verrou qui depend d'un RENDU depend de la visibilite, qui n'est pas
     sous notre controle : on limite au TEMPS, qui avance toujours. */
  var dernierJugement = 0;
  var traine = null;
  window.addEventListener('scroll', function () {
    var t = Date.now();
    /* ⛔ TOUJOURS UNE DERNIERE FOIS, MEME QUAND L'EVENEMENT EST JETE (Adrien, serie 342 :
       « sur desktop, le bandeau promotion ne revient pas a sa hauteur initiale quand on
       scrolle a nouveau tout en haut »).

       LA BRIDE NE GARDAIT QUE LE PREMIER EVENEMENT DE CHAQUE FENETRE DE 80 ms, et jetait les
       autres SANS JAMAIS LES RATTRAPER. Or le dernier evenement d'un geste est precisement
       celui qui porte la position finale : jete, `juger` ne tourne plus, et l'en-tete reste
       fige dans l'etat de l'avant-dernier releve. `is-compact` ne se retire qu'en dessous de
       8 px ; si le dernier releve vu vaut 40, le bandeau reste tasse alors qu'on est en haut.

       ⛔ POURQUOI SUR ORDINATEUR ET PAS SUR TELEPHONE, et c'est ce qui designe la cause : une
       molette ou un trackpad S'ARRETE NET, donc le dernier evenement tombe presque toujours
       dans la fenetre de bride et meurt la. Le defilement tactile, lui, continue d'emettre
       pendant des centaines de millisecondes apres que le doigt est parti : un evenement
       finit toujours par sortir de la fenetre, et la barre se rouvre. Le meme defaut, invisible
       d'un cote, visible de l'autre.

       Le rattrapage se REPROGRAMME a chaque evenement : pendant un defilement continu il est
       sans cesse repousse et ne coute rien ; il ne tire qu'une fois, quand tout s'est arrete. */
    if (traine) clearTimeout(traine);
    traine = setTimeout(function () { traine = null; juger(); }, 90);
    if (t - dernierJugement < 80) return;
    dernierJugement = t;
    juger();
  }, { passive: true });
  juger();
})();

(function initProductScrollHeader() {
  var body = document.body;
  if (!body || !body.classList.contains('template-product')) return;
  var header = document.querySelector('.site-header');
  var section = document.getElementById('shopify-section-header');
  if (!header || !section) return;

  var previousY = position();
  var direction = 0;
  var distance = 0;
  var ignoreLayoutScroll = false;
  body.classList.add('pdp-header-scroll');

  function position() {
    var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    return Math.max(0, Math.min(window.pageYOffset || 0, max));
  }
  function reveal() {
    body.classList.remove('pdp-header-hidden');
    previousY = position();
    direction = 0;
    distance = 0;
  }
  function scrolling() {
    var y = position();
    var delta = y - previousY;
    var focused = document.activeElement;
    previousY = y;
    if (y <= 8 || body.classList.contains('nav-open') || body.classList.contains('cart-open')
        || (focused && header.contains(focused) && focused.matches(':focus-visible, input, textarea, select'))
        || header.querySelector('details[open], .head-search.is-sug-open')) {
      reveal();
      return;
    }
    if (ignoreLayoutScroll) {
      direction = 0;
      distance = 0;
      return;
    }
    if (!delta) return;
    var nextDirection = delta > 0 ? 1 : -1;
    distance = nextDirection === direction ? distance + Math.abs(delta) : Math.abs(delta);
    direction = nextDirection;
    if (direction < 0 && distance >= 6) {
      body.classList.remove('pdp-header-hidden');
    } else if (direction > 0 && distance >= 12 && y > section.offsetHeight) {
      body.classList.add('pdp-header-hidden');
    }
  }
  function resumeScroll() {
    if (!ignoreLayoutScroll) return;
    ignoreLayoutScroll = false;
    previousY = position();
    direction = 0;
    distance = 0;
  }
  function interaction(event) {
    if (event.target === document.documentElement || event.clientX >= document.documentElement.clientWidth) {
      resumeScroll();
      return;
    }
    ignoreLayoutScroll = true;
  }
  document.addEventListener('pointerdown', interaction, true);
  document.addEventListener('click', interaction, true);
  document.addEventListener('wheel', resumeScroll, { passive: true, capture: true });
  document.addEventListener('touchmove', resumeScroll, { passive: true, capture: true });
  document.addEventListener('keydown', function (event) {
    var target = event.target;
    var control = target && target.matches('input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="slider"], [role="spinbutton"], [role="listbox"], [role="combobox"]');
    var buttonSpace = event.key === ' ' && target && target.matches('button, [role="button"], summary');
    if (!control && !buttonSpace && /^(ArrowUp|ArrowDown|PageUp|PageDown|Home|End| )$/.test(event.key)) resumeScroll();
    else ignoreLayoutScroll = true;
  }, true);
  window.addEventListener('scroll', scrolling, { passive: true });
  window.addEventListener('resize', reveal, { passive: true });
  window.addEventListener('pageshow', reveal);
  header.addEventListener('focusin', reveal);
})();

/* =========================================================================================
   LE PARCOURS DES LECTEURS DU BLOG (serie 419-57).

   Adrien : « ajoute un onglet blog pour suivre les visites uniques, paniers et ventes, clic
   dans composer, ajouts au panier... des gens passes par le blog. Il faut que ce soit
   dynamique et ajoute les nouveaux articles automatiquement. Leurs urls ont toujours la meme
   structure de chemin. »

   ⛔ LA RECONNAISSANCE SE FAIT SUR LA FORME DU CHEMIN, ET C'EST TOUT CE QUI REND LA MESURE
   AUTOMATIQUE. `/blogs/<blog>/<article>`, avec ou sans prefixe de langue devant. Le nom du
   blog change d'une langue a l'autre (conseils-deco, deko-tipps, stylingtips) et les handles
   d'article aussi : aucune liste ne tiendrait, et il faudrait penser a l'allonger a chaque
   publication. Le mot `blogs`, lui, ne change dans aucune des treize langues : c'est deja le
   constat ecrit dans `snippets/nav-link-title.liquid`.

   ⛔ ET CE N'EST PAS LE COMPTEUR DE VUES D'ARTICLE. Celui de `templates/article.liquid` reste,
   il sert au CLASSEMENT du blog : anonyme, sans identifiant, dedoublonne par un jeton d'IP
   renouvele chaque jour. Ce jeton ne traverse pas la nuit et n'arrive jamais jusqu'a une
   commande, donc il ne peut repondre a aucune des questions posees ici. Le parcours, lui, se
   suit avec `af:vid`, la meme identite que Ma piece, Perso et le Composeur : un uuid tire au
   sort dans le navigateur, sans aucune donnee personnelle.

   ⛔ L'ACHAT NE PART PAS D'ICI. On pose deux attributs de panier, `blog_src` (l'article) et
   `blog_vid` (la personne) ; le Studio lit les commandes qui les portent. Un POST du
   navigateur ne doit jamais pouvoir fabriquer une vente : c'est la regle des trois autres
   funnels.
   ========================================================================================= */
(function parcoursBlog() {
  var SERVEUR = "https://runway.dcomdtf.app/blog-log";
  /* ⛔ TRENTE JOURS, LA MEME FENETRE QUE L'ATTRIBUTION PUBLICITAIRE. Quelqu'un lit un article
     le lundi et commande le jeudi : sur une fenetre de session, cette vente serait perdue et
     le blog paraitrait ne rien vendre. Au-dela d'un mois, le lien devient trop lache pour
     qu'on l'appelle une attribution. */
  var JOURS = 30;
  var CLE = "af:blog";

  /* Le chemin d'une page de blog, prefixe de langue compris. Le troisieme groupe n'existe
     que sur un ARTICLE : sur l'index du blog il est absent, et on ne compte rien. */
  var MOTIF = /(?:^|\/)blogs\/([a-z0-9-]+)(?:\/([a-z0-9-]{2,200}))?\/?$/;

  function vid() {
    /* ⚠️ LA MEME CLE QUE LES TROIS AUTRES FUNNELS, exprès : un parcours doit pouvoir se
       suivre d'un outil a l'autre. Ce bloc vit hors de la fermeture qui tient `afVid`, on
       relit donc le meme localStorage plutot que d'en fabriquer un second. */
    try {
      var v = localStorage.getItem("af:vid");
      if (!v) {
        v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
          : "v" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
        localStorage.setItem("af:vid", v);
      }
      return v;
    } catch (e) { return ""; }
  }

  function appareil() {
    var s = navigator.userAgent || "";
    if (/iPad|Tablet|Kindle|Silk|PlayBook|(Android(?!.*Mobile))/i.test(s)) return "tablet";
    if (/Mobi|iPhone|iPod|Android.*Mobile|Windows Phone|Opera Mini|webOS|BlackBerry/i.test(s)) {
      return "mobile";
    }
    return "desktop";
  }

  /* L'article lu le plus recemment, s'il est encore dans la fenetre. Rend "" sinon, et c'est
     ce "" qui fait que rien n'est pose sur le panier d'un visiteur qui ne vient pas du blog. */
  function articleRetenu() {
    try {
      var brut = JSON.parse(localStorage.getItem(CLE) || "null");
      if (!brut || !brut.h || !brut.ts) return "";
      if (Date.now() - brut.ts > JOURS * 86400000) return "";
      return String(brut.h);
    } catch (e) { return ""; }
  }

  function poster(evenement, article, montant) {
    var v = vid();
    if (!v) return;
    var charge = { vid: v, evenement: evenement, article: article || "",
      device: appareil(), locale: (document.documentElement.lang || "").slice(0, 8) };
    if (montant != null) charge.montant = montant;
    try {
      fetch(SERVEUR, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(charge),
        /* keepalive : on ferme souvent un article aussitot ouvert, et sans lui la requete est
           annulee au depart de la page. Le biais irait toujours dans le meme sens. */
        keepalive: true, mode: "cors", credentials: "omit", signal: afSignalCourt(2500)
      }).catch(function () {});
    } catch (e) {}
  }

  /* ---- 1. La lecture d'un article ------------------------------------------------------ */
  var trouve = MOTIF.exec(String(location.pathname || ""));
  var article = trouve && trouve[2] ? trouve[2] : "";
  if (article) {
    try {
      /* La fenetre repart de la DERNIERE lecture : c'est le dernier article lu qui sera
         credite de la vente, et c'est le modele de toutes les regies. Garder le premier
         rendrait des chiffres qu'aucun autre outil ne reconnaitrait. */
      localStorage.setItem(CLE, JSON.stringify({ h: article, ts: Date.now() }));
    } catch (e) {}
    /* ⚠️ UNE FOIS PAR SESSION ET PAR ARTICLE. Le serveur dedoublonne par personne sur la
       fenetre, mais autant ne pas lui envoyer trente requetes pour un aller-retour entre
       l'article et le blog. */
    try {
      var cle = "af:blog-vu:" + article;
      if (!sessionStorage.getItem(cle)) {
        sessionStorage.setItem(cle, "1");
        poster("vue", article);
      }
    } catch (e) { poster("vue", article); }
  }

  /* ---- 2. L'entree dans le composeur --------------------------------------------------- */
  /* ⛔ ON ECOUTE LE MEME CLIC QUE LA PORTE DE CREATION, PAS UNE NAVIGATION. Le composeur
     s'ouvre en modale : `location` reste celui de la page hote, et guetter un changement
     d'URL ne verrait jamais rien. `[data-creation-source]` est deja l'endroit ou le theme
     declare cette entree. */
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest("[data-creation-source]")) return;
    var lu = articleRetenu();
    if (!lu) return;
    try {
      if (sessionStorage.getItem("af:blog-compo")) return;
      sessionStorage.setItem("af:blog-compo", "1");
    } catch (err) {}
    poster("composeur", lu);
  }, true);

  /* ---- 3. L'ajout au panier, et les deux attributs qui porteront la vente --------------- */
  /* ⛔ ON INTERCEPTE `/cart/add.js` PLUTOT QUE D'APPELER DEPUIS `addToCart`. La fiche produit,
     le composeur, le pele-mele et le tiroir ajoutent chacun par leur propre chemin : se
     brancher sur une seule de ces fonctions mesurerait un quart des paniers, et l'ecart ne se
     verrait pas, faute de savoir ce qu'on ne compte pas. */
  var forigine = window.fetch;
  if (!forigine) return;
  window.fetch = function (entree) {
    var url = "";
    try { url = (typeof entree === "string") ? entree : (entree && entree.url) || ""; } catch (e) {}
    var reponse = forigine.apply(this, arguments);
    if (!/\/cart\/add\.js/.test(url)) return reponse;
    try {
      reponse.then(function () {
        var lu = articleRetenu();
        if (!lu) return;
        /* ⛔ LA RACINE DE LANGUE, JAMAIS UNE ADRESSE EN DUR. Faute deja commise deux fois dans
           ce fichier : elle ne leve rien sur /de, /nl, /en, elle rend juste une reponse vide. */
        var racine = String(window.MURMURE_RACINE || "/").replace(/\/$/, "");
        /* ⛔⛔ ON LIT LE PANIER, ON NE CROIT PAS LA MEMOIRE DE SESSION. Defaut mesure le
           13/08/2026 sur les attributs d'attribution : `sessionStorage` dit « je l'ai deja
           pose », pas « il y est ». Entre les deux, le panier a pu etre recree (il expire, le
           client le vide, Shopify en ouvre un neuf) sans que la session change, et la garde
           repondait « rien a faire » sur un panier VIDE d'attributs. Trois commandes sur
           cinquante-deux avaient perdu leur attribution comme ca.
           ⚠️ ET CETTE LECTURE NE COUTE RIEN DE PLUS : on lit deja le panier pour son total.
           Une seule requete repond aux deux questions. */
        forigine(racine + "/cart.js", { credentials: "same-origin" })
          .then(function (r) { return r.json(); })
          .then(function (panier) {
            var attrs = (panier && panier.attributes) || {};
            if (attrs.blog_src !== lu || !attrs.blog_vid) {
              forigine(racine + "/cart/update.js", {
                method: "POST", headers: { "Content-Type": "application/json" },
                credentials: "same-origin",
                body: JSON.stringify({ attributes: { blog_src: lu, blog_vid: vid() } })
              }).catch(function () {});
            }
            /* ⛔ LE MONTANT DU PANIER, PAS UNE COCHE. « Panier ✓ » ne dit pas ce qu'il pesait :
               deux lignes identiques a l'ecran peuvent valoir 10 € et 120 €. Meme lecon que les
               trois autres funnels, apprise le 11/08/2026. Le total vient du panier REEL, jamais
               d'une deduction sur le produit ajoute. */
            var total = panier && Number(panier.total_price);
            poster("panier", lu, Number.isFinite(total) ? total / 100 : null);
          }).catch(function () { poster("panier", lu, null); });
      }).catch(function () {});
    } catch (e) {}
    return reponse;
  };
})();

/* ==============================================================================================
 * LA FENETRE DE RENDU, PARTAGEE PAR LES TROIS PRODUITS PERSONNALISES (Adrien, 20/08/2026).
 *
 * « Pour TOUS LES PRODUITS PERSONNALISÉS il faut s'assurer que le rendu affiché dans la modale
 * soit EXACTEMENT ce qui est envoyé pour impression, pas de concession possible. »
 *
 * ⛔ C'EST POUR CA QU'ELLE VIT ICI, ET PAS TROIS FOIS. Chaque configurateur a sa fonction de
 * composition — `composeImpression` pour le pele-mele et le panneau, `composePersoWithText` pour
 * l'affiche personnalisee — et c'est CELLE-LA qui fabrique le fichier envoye a l'impression.
 * Cette fenetre ne dessine RIEN : elle recoit la fonction, l'appelle, et montre son resultat.
 * Ecrite trois fois, elle aurait fini par dessiner elle-meme quelque part, et le client aurait
 * valide une image que la presse n'aurait jamais recue. C'est exactement la divergence qui a
 * coute trois tirages entre le 01/08 et le 08/08.
 *
 * ⛔ ET LE CADRE EST UN DECOR AUTOUR, JAMAIS DANS LE FICHIER. Le client choisit un cadre PHYSIQUE :
 * l'imprimer sur l'affiche reviendrait a lui vendre une photo de cadre. La fenetre reprend donc
 * la bordure telle qu'elle est CALCULEE sur `#pdp-frame`, l'apercu de la fiche, pour que les deux
 * montrent la meme moulure sans qu'une seconde table de moulures existe.
 * ============================================================================================ */
/* ⛔ LE CHEMIN PAR LA FENETRE EST MOBILE, ET SEULEMENT MOBILE (Adrien, 20/08/2026 : « je veux
   que ce chemin d'achat avec la modale soit uniquement sur mobile. Laisse comme c'etait avant
   sur desktop, on voit deja l'apercu en grand »). Sur un grand ecran l'apercu occupe la moitie
   de la page : ouvrir une fenetre pour remontrer ce qui est deja sous les yeux ajoute un clic et
   n'apprend rien. Sur telephone, l'apercu tient dans un timbre au-dessus du formulaire, et c'est
   la que le client a besoin de voir avant de payer.
   ⚠️ LE SEUIL EST CELUI DU THEME, `max-width:900px`, le meme que `device:` plus haut et que les
   seize regles de la feuille. Un second seuil ferait un ecran « mobile » pour le script et
   « desktop » pour le style, sur la meme largeur. */
/* ⛔⛔ ALLER AUX AVIS : LE DOUX D'ABORD, L'ARRIVEE GARANTIE ENSUITE.
 *
 * Adrien, 21/08/2026 : « tu as modifie le comportement au clic de l'autre bloc, qui avait un
 * defilement fluide vers les avis auparavant, maintenant ca fait un saut ». Il a raison, et
 * c'est moi qui l'ai casse le matin meme : ma mesure disait le defilement doux INERTE sur cette
 * fiche, je l'ai donc remplace par un saut sec. Chez lui il marchait. Un releve fait dans un
 * navigateur pilote n'est pas la realite du client, et c'est cette realite-la qui decide.
 *
 * Ce que la mesure disait de vrai : le doux est INTERMITTENT. Juste apres l'arrivee sur la
 * fiche, images differees et galerie collante remettent la page en page, et l'animation en
 * cours est annulee sans un mot. On ne choisit donc pas entre les deux : on lance le doux, et
 * si rien n'a bouge on arrive quand meme. Un embellissement s'AJOUTE au geste, il ne le
 * remplace pas, et il ne l'empeche pas non plus.
 *
 * ⚠️ LA RESERVE D'EN-TETE SE LIT DANS LE CSS (`scroll-margin-top`), qui sait ce que mesure
 * l'en-tete collante : la recopier ici serait un second chiffre a garder d'accord.
 */
window.murVersLesAvis = function (e) {
  var cible = document.getElementById("avisline");
  if (!cible) return false;          /* le bloc a ete retire : pas de saut en haut de page */
  if (e && e.preventDefault) e.preventDefault();
  var marge = parseFloat(getComputedStyle(cible).scrollMarginTop) || 0;
  var vise = function () {
    return Math.max(0, cible.getBoundingClientRect().top + (window.scrollY || 0) - marge);
  };
  var depart = window.scrollY || 0;
  window.scrollTo({ top: vise(), behavior: "smooth" });
  /* ⚠️ ON RECALCULE LA CIBLE AU REPLI : entre-temps une image a pu se poser et tout descendre. */
  setTimeout(function () {
    if (Math.abs((window.scrollY || 0) - depart) < 4) {
      window.scrollTo({ top: vise(), behavior: "instant" });
    }
  }, 450);
  /* L'adresse dit ou l'on est : elle se copie, et le retour arriere ramene ou l'on etait. */
  if (window.history && history.pushState) history.pushState(null, "", "#avisline");
  return true;
};

window.murEstMobile = function () {
  return !!(window.matchMedia && window.matchMedia("(max-width:900px)").matches);
};

/* ⛔ QUAND L'ACHAT PASSE PAR LA FENETRE, LA PAGE NE GARDE PAS SON BLOC D'ACHAT (Adrien,
   20/08/2026 : « l'ancien bloc d'achat est encore present sur la page mobile »). Le choix des
   tailles et les options vivent alors DANS la fenetre : les laisser aussi sous le configurateur
   fait deux jeux de commandes pour un seul reglage, et le client ne sait plus lequel compte.
   ⚠️ LE BOUTON, LUI, RESTE : c'est la porte de la fenetre. Le retirer fermerait le seul chemin
   vers l'achat, et la barre collante ne parait justement que lorsque ce bloc sort de l'ecran.
   ⚠️ ET LE DRAPEAU SE POSE, IL NE SE DEVINE PAS : chaque configurateur sait, lui, si sa fenetre
   est reellement le chemin d'achat (photos deposees, telephone). Une regle de style qui le
   devinerait cacherait les formats a un client qui n'a encore rien depose, donc sans aucun
   moyen d'acheter. */
var murIntentionAchat = null;
/* ⛔ ET UNE PHOTO POSEE FAIT TOMBER LA MOULURE DE L'APERCU (Adrien, 20/08/2026 : « ne mets jamais
   le cadre quand quelqu'un a importe une photo, garde uniquement pour le placeholder pour la
   projection. Sinon on perd de la place. Toujours mobile uniquement »). Sur telephone, la
   moulure prend de la largeur des deux cotes d'un apercu qui n'en a deja pas beaucoup ; devant
   le placeholder elle sert la projection, devant la photo du client elle ne fait que retrecir ce
   qu'il est venu regarder. La fenetre de rendu, elle, GARDE son cadre : il y a la place, et
   c'est la qu'on juge l'objet fini (correction du meme jour).
   ⚠️ LE DRAPEAU SE POSE, IL NE SE DEVINE PAS, et surtout pas depuis `.pdp--perso-has-photo` :
   cette classe n'est ecrite qu'a un import REEL, et une photo restauree de session ne la porte
   pas. Chaque configurateur connait son etat, il le DIT. */
var murIntentionPhoto = null;
window.murPhotoPosee = function (actif) {
  if (typeof actif === "function") murIntentionPhoto = actif;
  var oui = typeof actif === "function" ? !!actif() : !!actif;
  document.documentElement.classList.toggle("mur-photo-posee", oui);
};

window.murAchatParModale = function (actif) {
  if (typeof actif === "function") murIntentionAchat = actif;
  var oui = typeof actif === "function" ? !!actif() : !!actif;
  document.documentElement.classList.toggle("mur-achat-modale", oui);
};
/* ⚠️ ET LE DRAPEAU SUIT LE PIVOTEMENT DE L'APPAREIL, EN UN SEUL ENDROIT. Un telephone tourne en
   paysage passe la barre des 900 px : sans ce rappel, la page resterait sans formats sur un
   ecran ou la fenetre ne s'ouvre plus. Pose ici plutot que dans les trois configurateurs, ou
   deux d'entre eux l'auraient oublie. */
if (window.matchMedia) {
  window.matchMedia("(max-width:900px)").addEventListener("change", function () {
    if (murIntentionAchat) window.murAchatParModale(murIntentionAchat);
  });
}

/* ⛔ LES COMMANDES D'ACHAT SUIVENT LE RENDU DANS LA FENETRE (Adrien, 20/08/2026 : « il faut
   deplacer le choix des tailles et options a l'interieur de la modale »). Sur telephone, le
   client qui venait de voir son rendu retombait sur « Choisissez une taille » : la fenetre lui
   montrait ce qu'il achete sans lui donner de quoi l'acheter, et il fallait la fermer pour
   trouver les formats.
   ⛔ ON DEPLACE LES VRAIS ELEMENTS, ON N'EN FABRIQUE PAS DE COPIES. Deux jeux de pastilles de
   taille finiraient par diverger, et c'est celui qu'on ne regarde pas qui vendrait le mauvais
   format. Les noeuds partent avec leurs ecouteurs et reviennent a leur place a la fermeture.
   ⛔ ET LA FENETRE VIT DANS `#pdp-form`. `#pdp-upsell` porte les deux seuls champs
   `properties[...]` de la page (`_bordure` et `Bordure blanche`), et `product.js` les relit par
   `#pdp-form [name^="properties["]` : sortis du formulaire, ils disparaitraient de la ligne de
   panier sans lever la moindre erreur. */
/* ⛔ C'EST `[data-apres-format]` QU'ON DEPLACE, PAS `#pdp-upsell`. Le wrapper porte la SERRURE :
   `product.js` y ecrit `el.hidden = !formatChosen()`, et c'est ce qui garde les options fermees
   tant qu'aucune taille n'est choisie (Adrien, 20/08/2026 : « les options doivent toujours
   s'afficher au clic sur la taille uniquement, comme dans la fiche produit, c'est le meme
   comportement »). Ma premiere version sortait `#pdp-upsell` de ce wrapper : les options
   s'ouvraient d'emblee dans la fenetre, avant meme qu'une taille existe.
   ⚠️ `#pdp-upsell` RESTE DANS LA LISTE POUR LE PANNEAU DE MARIAGE, ou la case de perforation vit
   HORS du wrapper a dessein : c'est une finition du produit, pas un accessoire, et elle est
   visible d'emblee. Sur les autres fiches il est DEJA parti avec le wrapper, et la boucle le
   saute. */
/* ⛔ ET ON NE DEPLACE PAS LE BLOC DE TAILLE EN ENTIER : le selecteur portrait/paysage vit dedans,
   et il n'a rien a faire dans la fenetre (Adrien, 20/08/2026 : « le selecteur portrait/paysage ne
   doit pas etre dans la modale »). Ce n'est pas un reglage d'ACHAT mais de COMPOSITION : il
   change la forme de l'affiche qu'on est en train de fabriquer, au meme titre que le nombre de
   cases, et il reste donc avec le configurateur. On emporte les deux morceaux qui l'encadrent,
   l'en-tete (« TAILLE » et le guide) et la rangee des formats, et il demeure seul sur la page. */
window.murCommandesAchat = [".pdp-option-bloc > .pdp-option__head", ".pdp-option-bloc > .pdp-option",
  "[data-apres-format]", "#pdp-upsell"];

window.murRenduModale = function (opts) {
  var o = opts || {};
  if (typeof o.compose !== "function") return Promise.resolve(false);
  if (document.querySelector(".mur-rendu")) return Promise.resolve(false);

  return o.compose().then(function (fichier) {
    var url = URL.createObjectURL(fichier);
    var voile = document.createElement("div");
    voile.className = "mur-rendu";
    voile.setAttribute("role", "dialog");
    voile.setAttribute("aria-modal", "true");

    var boite = document.createElement("div");
    boite.className = "mur-rendu__boite";

    var fermer = document.createElement("button");
    fermer.type = "button";
    fermer.className = "mur-rendu__x";
    fermer.setAttribute("aria-label", o.fermer || "Fermer");
    fermer.textContent = "×";

    /* ⛔ UNE SCENE SOUPLE AUTOUR DU CADRE (Adrien, 20/08/2026 : « il y a de l'espace perdu, le
       but de la modale est de voir en grand »). Le rendu etait plafonne a 55 dvh : sur son
       telephone il occupait 323 x 466 px alors que 406 x 586 tenaient, et il restait 122 px de
       vide en haut, autant en bas, plus deux bandes sur les cotes. La scene prend TOUT ce que le
       panneau et le pied laissent, et `ajusteRendu` y inscrit la plus grande affiche possible.
       ⚠️ POURQUOI PAS EN CSS SEUL : `max-height:100%` sur l'image ne se resout pas contre un
       parent de hauteur automatique, et le cadre DOIT rester de hauteur automatique pour epouser
       l'affiche. Mesure a l'appui : force en `height:100%`, l'image sortait a 0,569 de ratio au
       lieu de 0,692. Le calcul est donc fait ici, une fois, sur des nombres qu'on peut lire. */
    var scene = document.createElement("div");
    scene.className = "mur-rendu__scene";
    var cadre = document.createElement("div");
    cadre.className = "mur-rendu__cadre";
    var img = document.createElement("img");
    img.className = "mur-rendu__img";
    img.src = url;
    img.alt = "";
    cadre.appendChild(img);
    scene.appendChild(cadre);

    /* ⛔ LA MOULURE SE LIT SUR L'APERCU, ELLE NE SE REDECRIT PAS. `#pdp-frame` porte deja la
       bonne bordure, choisie par la cliente et peinte par une regle CSS qui connait les trois
       moulures. La recopier ici ferait une seconde table, et c'est toujours la copie qu'on ne
       regarde pas qui vieillit.
       ⚠️ LA LARGEUR SE MET A L'ECHELLE : la fenetre est plus grande que l'apercu, et une bordure
       de 8 px y paraitrait un filet. On garde la PROPORTION, pas les pixels. */
    var part = 0;
    /* ⛔ ET LA BORDURE CHOISIE SE LIT AU MEME ENDROIT QUE LA MOULURE (Adrien, 23/08/2026 :
       « y'a rien qui te choque la alors que j'ai choisi une bordure rouge ? »). La cliente
       choisissait « Avec bordure » puis une couleur, et la fenetre continuait de montrer une
       affiche nue : le fichier compose ne porte pas la bordure, elle est ajoutee a la presse.
       La fenetre promet pourtant de montrer ce qui sera imprime.
       ⚠️ ON NE REDESSINE RIEN ET ON NE RECALCULE RIEN : `#pdp-frame` porte deja le passe-partout
       exact, en pourcentage de la feuille et dans la teinte cliquee, pose par `bordure-blanche
       .js` depuis la seule table d'impression. On en lit la PROPORTION, comme pour la moulure.
       Une seconde table ici serait la troisieme, et c'est toujours la copie qu'on ne regarde
       pas qui vieillit. */
    var matH = 0, matC = 0, matTeinte = "";
    var vrai = document.querySelector("#pdp-frame");
    /* ⛔ ON LIT LA MOULURE DRAPEAU RETIRE. Sur telephone et photo posee, une regle met la bordure
       de l'apercu a zero pour gagner de la largeur : la lire telle quelle donnerait une fenetre
       sans cadre, alors qu'elle doit justement le garder (Adrien, 20/08/2026). On retire le
       drapeau le temps de la mesure, puis on le remet : `getComputedStyle` recalcule sur-le-champ,
       et la table des moulures reste unique, dans la feuille.
       ⛔ ET ON RELIT A CHAQUE CHANGEMENT DE MOULURE. Le choix du cadre vit DANS la fenetre depuis
       ce matin : lu une seule fois a l'ouverture, il y montrait le chene alors que la cliente
       venait de choisir le noir (mesure du 20/08/2026, `data-moulure` passe a « noir » et le
       cadre de la fenetre n'avait pas bouge). */
    function poseMoulure() {
      if (!vrai) return;
      var racine = document.documentElement;
      var avaitPhoto = racine.classList.contains("mur-photo-posee");
      if (avaitPhoto) racine.classList.remove("mur-photo-posee");
      var cs = getComputedStyle(vrai);
      var epais = parseFloat(cs.borderTopWidth) || 0;
      var largeur = vrai.getBoundingClientRect().width || 1;
      part = epais / largeur;
      /* Les quatre cotes se rapportent a la MEME largeur, exactement comme un padding en
         pourcentage : c'est la regle du CSS, et c'est ce que `partCadre` a calcule. */
      matH = (parseFloat(cs.paddingTop) || 0) / largeur;
      matC = (parseFloat(cs.paddingLeft) || 0) / largeur;
      matTeinte = (matH > 0 || matC > 0) ? cs.backgroundColor : "";
      if (epais > 0) {
        cadre.style.borderStyle = cs.borderTopStyle;
        cadre.style.borderColor = cs.borderTopColor;
        if (cs.borderImageSource && cs.borderImageSource !== "none") {
          cadre.style.borderImageSource = cs.borderImageSource;
          cadre.style.borderImageSlice = cs.borderImageSlice;
          cadre.style.borderImageRepeat = cs.borderImageRepeat;
        } else {
          /* ⛔ ET ON EFFACE LA TEXTURE PRECEDENTE : passer du chene au noir laisse sinon le bois
             par-dessus la couleur unie, une moulure qui n'existe dans aucun catalogue. */
          cadre.style.borderImageSource = "";
        }
      } else {
        cadre.style.borderWidth = "0";
        cadre.style.borderImageSource = "";
      }
      if (avaitPhoto) racine.classList.add("mur-photo-posee");
    }
    poseMoulure();
    /* La teinte choisie s'ecrit sur `data-moulure` du conteneur de galerie : c'est le seul signe
       qu'un cadre a change, et il ne coute qu'un attribut a surveiller. */
    /* ⛔ ET ON RELIT APRES QUE LA FICHE AIT FINI DE POSER SA MOULURE, pas au moment ou l'attribut
       change. Mesure du 20/08/2026 : lue dans la foulee, la fenetre avait UN TOUR DE RETARD, elle
       montrait le chene apres un clic sur le noir, et le noir apres un clic sur le chene. La
       teinte n'est donc pas peinte dans la meme tache que l'attribut. Deux relectures, une a la
       image suivante et une un peu plus tard : la premiere suffit presque toujours, la seconde
       rattrape un chargement de texture. */
    function relisMoulure() {
      poseMoulure(); ajusteRendu();
      if (window.requestAnimationFrame) requestAnimationFrame(function () { poseMoulure(); ajusteRendu(); });
      setTimeout(function () { poseMoulure(); ajusteRendu(); }, 220);
    }
    var oeilMoulure = null;
    var galerie = document.querySelector(".pdp-gallery__wrap");
    if (window.MutationObserver) {
      oeilMoulure = new MutationObserver(relisMoulure);
      if (galerie) oeilMoulure.observe(galerie, { attributes: true, attributeFilter: ["data-moulure", "data-framed"] });
      /* ⚠️ ET SUR L'APERCU LUI-MEME : la fiche y ecrit aussi des styles en ligne, et une teinte
         posee la sans toucher a l'attribut du conteneur passerait inapercue. */
      if (vrai) oeilMoulure.observe(vrai, { attributes: true, attributeFilter: ["style", "class"] });
    }

    /* ⛔ LA PLUS GRANDE AFFICHE QUI TIENNE DANS LA SCENE, MOULURE COMPRISE. Trois nombres et pas
       un de plus : la place disponible, la proportion du fichier, l'epaisseur de la moulure.
       ⚠️ LA MOULURE ET LA LARGEUR SE COMMANDENT L'UNE L'AUTRE : son epaisseur est une PART de la
       largeur de l'affiche, et cette largeur depend de la place que la moulure laisse. Deux
       passes suffisent a converger, et la seconde part d'une valeur deja juste a quelques
       pixels. Une seule passe posait un filet sur les grands formats. */
    function ajusteRendu() {
      var d = scene.getBoundingClientRect();
      var ratio = (img.naturalWidth || 0) / (img.naturalHeight || 1);
      if (!(d.width > 0 && d.height > 0 && ratio > 0)) return;
      /* ⛔ UNE SEULE EQUATION, RESOLUE, PLUTOT QUE DEUX PASSES QUI CONVERGENT. La moulure et le
         passe-partout sont tous deux des PARTS de la largeur hors-tout de l'affiche : la taille
         se pose donc d'un coup, sans iterer, et le meme calcul vaut avec ou sans bordure.
           L        largeur hors-tout (passe-partout compris)
           l = L(1-2·matC)                  largeur de l'image
           H = L·((1-2·matC)/ratio + 2·matH) hauteur hors-tout
           b = part·L                       epaisseur de moulure
         La place tient si L(1+2·part) <= largeur de scene et L(K+2·part) <= hauteur de scene. */
      var K = (1 - 2 * matC) / ratio + 2 * matH;
      if (K <= 0 || (1 - 2 * matC) <= 0) return;
      var L = Math.min(d.width / (1 + 2 * part), d.height / (K + 2 * part));
      if (!(L > 0)) return;
      var l = L * (1 - 2 * matC);
      var h = l / ratio;
      var b = part > 0 ? Math.max(2, Math.round(part * L)) : 0;
      /* ⛔ ON N'ECRIT QUE SI LA VALEUR CHANGE. Ecrire la meme taille refait une passe de mise
         en page, que l'observateur de taille relit, qui rappelle cette fonction : le navigateur
         s'en sort en abandonnant la boucle, mais il le dit dans la console (« ResizeObserver
         loop completed with undelivered notifications », sept fois par ouverture, mesure du
         20/08/2026). Une ecriture inutile n'est jamais gratuite quand quelqu'un la surveille. */
      var lPx = Math.floor(l) + "px";
      var hPx = Math.floor(h) + "px";
      if (img.style.width !== lPx) img.style.width = lPx;
      if (img.style.height !== hPx) img.style.height = hPx;
      var padPx = (matH > 0 || matC > 0)
        ? Math.round(matH * L) + "px " + Math.round(matC * L) + "px" : "";
      if (cadre.style.padding !== padPx) cadre.style.padding = padPx;
      if (cadre.style.backgroundColor !== matTeinte) cadre.style.backgroundColor = matTeinte;
      var bPx = b + "px";
      if (part > 0 && cadre.style.borderWidth !== bPx) cadre.style.borderWidth = bPx;
    }
    img.addEventListener("load", ajusteRendu);
    /* ⛔ LE RENDU SUIT LA BORDURE BLANCHE (Adrien, 20/08/2026 : « l'apercu avec/sans bordure ne
       fonctionne pas dans la modale »). La bordure entre dans le FICHIER d'impression : une
       fenetre qui montre l'ancienne image pendant que la case est cochee promet au client autre
       chose que ce qu'on tirera, et c'est precisement ce que cette fenetre existe pour empecher.
       `bordure-blanche.js` publie deja `af:bordure` ; on refabrique le fichier, sans jamais
       dessiner soi-meme.
       ⚠️ UN JETON CONTRE LES CLICS RAPIDES : deux compositions lancees coup sur coup peuvent
       rendre dans le desordre, et la fenetre garderait la premiere terminee, c'est-a-dire la
       mauvaise. */
    var tour = 0;
    function refaisRendu() {
      var mien = (tour += 1);
      o.compose().then(function (autre) {
        if (mien !== tour || !document.body.contains(voile)) return;
        var vieille = url;
        url = URL.createObjectURL(autre);
        img.src = url;
        URL.revokeObjectURL(vieille);
      }).catch(function () {});
    }
    window.addEventListener("af:bordure", refaisRendu);
    /* ⚠️ ET IL SE REJOUE QUAND LA SCENE CHANGE DE TAILLE : les options qui s'ouvrent poussent le
       panneau, donc rognent la scene, et une affiche restee a l'ancienne taille deborderait par
       le bas. La rotation de l'appareil passe par le meme chemin. */
    var mesureur = null;
    if (window.ResizeObserver) {
      /* ⛔ LE CALCUL SORT DE LA BOUCLE D'OBSERVATION. Ecrire une taille depuis le rappel d'un
         `ResizeObserver` fait manquer au navigateur sa fenetre de livraison, et il s'en plaint
         dans la console (« loop completed with undelivered notifications »). Repousse a l'image
         suivante, le meme calcul ne le derange plus. */
      mesureur = new ResizeObserver(function () {
        if (window.requestAnimationFrame) requestAnimationFrame(ajusteRendu);
        else ajusteRendu();
      });
      mesureur.observe(scene);
    }

    /* Les commandes deplacees vivent ici, entre le rendu et le bouton : on voit ce qu'on
       achete, on choisit, on achete, dans cet ordre. */
    var commandes = document.createElement("div");
    commandes.className = "mur-rendu__commandes";
    var deplaces = [];
    (o.commandes || []).forEach(function (sel) {
      /* ⚠️ TOUS LES NOEUDS QUI REPONDENT, pas le premier : une fiche a autant de `.pdp-option`
         que d'options Shopify, et n'en emporter qu'une laisserait les autres sur une page qui
         vient justement de les cacher. */
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
      if (!el) return;
      /* ⛔ ON NE DEPLACE PAS DEUX FOIS, ET SURTOUT PAS UN ENFANT DE CE QU'ON VIENT DE DEPLACER :
         `#pdp-upsell` vit DANS `[data-apres-format]` sur toutes les fiches sauf le panneau. Le
         ressortir de son wrapper lui retirerait sa serrure, et les options s'ouvriraient sans
         qu'aucune taille soit choisie. `closest(".mur-rendu")` ne suffit pas : a cet instant la
         fenetre n'est pas encore montee. */
      if (deplaces.some(function (d) { return d.el === el || d.el.contains(el); })) return;
      /* Le jalon garde la place exacte, y compris entre deux freres : rendre l'element au
         formulaire par un `appendChild` le poserait en fin de colonne, sous le bouton. */
      var jalon = document.createComment("mur-rendu:" + sel);
      el.parentNode.insertBefore(jalon, el);
      commandes.appendChild(el);
      deplaces.push({ el: el, jalon: jalon });
      });
    });
    /* ⚠️ LE TEST PORTE SUR LE PANNEAU, PAS SUR `deplaces` : le selecteur d'unites entre plus bas
       dans la MEME liste mais va dans le pied. Compter la liste ferait poser la mise en page du
       panneau, et un panneau vide avec elle, sur une fenetre qui n'a deplace qu'une quantite. */
    if (commandes.children.length) voile.classList.add("mur-rendu--commandes");

    var pied = document.createElement("div");
    pied.className = "mur-rendu__pied";
    /* ⛔ LE SELECTEUR D'UNITES SUIT LE BOUTON, IL NE RESTE PAS SUR LA PAGE (Adrien, 20/08/2026 :
       « ca n'a aucun sens de le mettre a cote de "voir le rendu" »). Une quantite posee a cote
       d'un bouton qui OUVRE une fenetre ne se rapporte a rien : on ne choisit pas combien
       d'exemplaires on regarde. Elle se rapporte a l'achat, donc elle vit a cote du bouton qui
       achete. Meme mecanique que les formats : le vrai noeud, pas une copie, et il rentre a sa
       place a la fermeture. */
    if (o.quantite) {
      var qte = document.querySelector(o.quantite);
      if (qte && !deplaces.some(function (d) { return d.el === qte || d.el.contains(qte); })) {
        var jalonQ = document.createComment("mur-rendu:" + o.quantite);
        qte.parentNode.insertBefore(jalonQ, qte);
        pied.appendChild(qte);
        deplaces.push({ el: qte, jalon: jalonQ });
      }
    }
    var acheter = document.createElement("button");
    acheter.type = "button";
    acheter.className = "btn btn-copper mur-rendu__add";
    acheter.textContent = o.libelleAjout || "Ajouter au panier";
    pied.appendChild(acheter);

    /* ⛔ LA PREUVE CLIENT SUIT LE BOUTON (Adrien, 20/08/2026 : « il manque les etoiles junip sous
       le CTA de la modale aussi »). Sur la fiche, la note se lit juste sous l'achat ; la fenetre
       est desormais l'ecran ou l'on achete, et elle s'y arretait au bouton. C'est la MEME ligne
       qu'on deplace, pas une copie : une note recopiee vieillirait le jour ou le Studio en
       calcule une autre, et un chiffre d'avis faux est pire qu'absent. */
    var noteAvis = null, jalonNote = null;
    if (o.reassurance) {
      noteAvis = document.querySelector(o.reassurance);
      if (noteAvis && !noteAvis.closest(".mur-rendu")) {
        jalonNote = document.createComment("mur-rendu:" + o.reassurance);
        noteAvis.parentNode.insertBefore(jalonNote, noteAvis);
        deplaces.push({ el: noteAvis, jalon: jalonNote });
      } else { noteAvis = null; }
    }

    boite.appendChild(fermer);
    boite.appendChild(scene);
    if (commandes.children.length) boite.appendChild(commandes);
    boite.appendChild(pied);
    if (noteAvis) boite.appendChild(noteAvis);
    voile.appendChild(boite);
    /* ⛔ DANS LE FORMULAIRE QUAND IL Y EN A UN, voir l'en-tete : les champs `properties[...]`
       qui viennent d'entrer dans la fenetre doivent rester sous `#pdp-form`. La fenetre est en
       `position:fixed` et aucun ancetre du formulaire ne fabrique de bloc conteneur (mesure du
       20/08/2026 : ni `transform`, ni `filter`, ni `contain`), donc elle se peint pareil. */
    var hote = (deplaces.length && document.querySelector("#pdp-form")) || document.body;
    hote.appendChild(voile);

    /* ⛔ LE BOUTON DIT CE QUE DIT CELUI DE LA FICHE, ET SURTOUT SES ETATS. « Choisissez une
       taille » n'est pas un libelle : c'est ce qui MANQUE au client. Le recouvrir par
       « Ajouter au panier » lui ferait cliquer dans le vide, et la fenetre se refermerait sans
       rien mettre au panier. Le seul mot qu'on remplace est « Voir le rendu », qui appartient au
       bouton de la fiche : ici le rendu est deja sous les yeux. */
    var boutonFiche = document.querySelector("#pdp-add");
    var sansTaille = false;
    function suitLaFiche() {
      var ajouter = o.libelleAjout || "Ajouter au panier";
      if (!boutonFiche) { acheter.textContent = ajouter; return; }
      var t = boutonFiche.textContent || "";
      var i = t.indexOf(" · ");
      var tete = i >= 0 ? t.slice(0, i) : t;
      var queue = i >= 0 ? t.slice(i) : "";
      var etat = tete !== ajouter && (!o.libelleVoir || tete !== o.libelleVoir);
      /* ⛔⛔ ET C'EST LA SERRURE DU FORMAT QUI DIT S'IL EST CLIQUABLE, PAS LE TEXTE DU BOUTON.
         Le texte etait ma premiere source, et il a cesse d'etre fiable le jour meme : sur ce
         chemin le bouton de la fiche dit « Voir le rendu » en permanence, taille choisie ou non,
         donc plus aucun etat n'y paraissait et la fenetre offrait « Ajouter au panier » sans
         qu'aucune taille existe. `[data-apres-format]` porte `hidden = !formatChosen()`, ecrit
         par `product.js` : c'est la meme et unique verite que celle qui ouvre les options.
         ⚠️ Repli sur le texte quand ce wrapper n'existe pas, pour ne pas bloquer une fiche qui
         n'en aurait pas. */
      var porte = document.querySelector("[data-apres-format]");
      sansTaille = porte ? !!porte.hidden : etat;
      /* ⛔ LE BOUTON REDIT L'ETAT, IL NE LE RECOUVRE PAS (Adrien, 20/08/2026 : « ce n'est pas
         "ajouter au panier" mais "choisissez une taille" si aucune taille n'a ete choisie »).
         J'avais fait l'inverse plus tot dans la journee, a sa demande d'alors ; il a tranche
         l'autre sens, et c'est le sens d'origine du theme : un bouton qui promet d'ajouter au
         panier sans qu'aucune taille existe promet ce qu'il ne fera pas, meme grise.
         ⚠️ LE MOT VIENT DE LA FICHE, JAMAIS D'ICI. Trois sources possibles, dans cet ordre : le
         texte du bouton quand il porte encore son etat (perso, panneau) ; ce que le
         configurateur a mis de cote en le recouvrant (`murEtatAchat`, pele-mele) ; le libelle du
         panier a defaut. Ecrire « Choisissez une taille » dans ce fichier en ferait une seconde
         version, non traduite, qui vieillirait seule. */
      var mot = etat ? tete : (sansTaille ? (window.murEtatAchat || ajouter) : ajouter);
      acheter.textContent = mot + queue;
      /* ⛔ LE BOUTON RESTE CLIQUABLE SANS TAILLE, ET SON CLIC DESIGNE LES FORMATS (Adrien,
         20/08/2026 : « ca doit etre le meme comportement que sur les autres pages produit, ca met
         un highlight autour du bloc taille »). Grise, il refusait sans rien apprendre : le client
         lit « Choisissez une taille » sans savoir OU. La fiche, elle, surligne la rangee depuis
         toujours. On ne desactive plus que sur un vrai blocage du bouton d'origine. */
      acheter.disabled = !!boutonFiche.disabled;
    }
    suitLaFiche();
    var oeil = null;
    if (window.MutationObserver && deplaces.length) {
      oeil = new MutationObserver(suitLaFiche);
      if (boutonFiche) oeil.observe(boutonFiche, { childList: true, characterData: true, subtree: true, attributes: true });
      /* ⚠️ ET ON REGARDE AUSSI LA SERRURE. Sur ce chemin le texte du bouton de la fiche ne bouge
         plus au choix d'une taille : sans cet oeil-la, le bouton de la fenetre resterait grise
         apres le clic sur un format. */
      var porteOeil = document.querySelector("[data-apres-format]");
      if (porteOeil) oeil.observe(porteOeil, { attributes: true, attributeFilter: ["hidden"] });
    }
    /* ⚠️ LA PAGE NE DEFILE PLUS DERRIERE : sur telephone, le doigt qui veut faire glisser
       l'image emmene la fiche entiere, et on perd la fenetre de vue sans l'avoir fermee. */
    document.documentElement.style.overflow = "hidden";

    function ferme() {
      /* ⛔ L'URL SE LIBERE A LA FERMETURE, pas apres un delai : l'image vit tant que la fenetre
         vit, et une liberation minutee la ferait disparaitre sous les yeux. */
      URL.revokeObjectURL(url);
      if (oeil) oeil.disconnect();
      if (mesureur) mesureur.disconnect();
      window.removeEventListener("af:bordure", refaisRendu);
      if (oeilMoulure) oeilMoulure.disconnect();
      /* ⛔ LES COMMANDES RENTRENT AVANT QUE LA FENETRE PARTE. Dans l'autre ordre, `voile.remove()`
         emporterait le choix des tailles et les options avec lui : la fiche se retrouverait sans
         formats, sans erreur, et le client ne pourrait plus rien acheter. */
      deplaces.forEach(function (d) {
        if (d.jalon.parentNode) d.jalon.parentNode.insertBefore(d.el, d.jalon);
        d.jalon.remove();
      });
      voile.remove();
      document.documentElement.style.overflow = "";
      document.removeEventListener("keydown", surEchap);
      if (typeof o.onFermer === "function") o.onFermer();
    }
    function surEchap(e) { if (e.key === "Escape") ferme(); }
    fermer.addEventListener("click", ferme);
    voile.addEventListener("click", function (e) { if (e.target === voile) ferme(); });
    document.addEventListener("keydown", surEchap);
    /* ⛔ LE MEME GESTE QUE LA FICHE : on surligne la rangee des formats et on ne ferme rien. La
       classe est celle du theme, `pdp-option--ask`, et son animation dure 1,4 s : en ecrire une
       seconde ici ferait deux surlignages a maintenir, dont un que personne ne regarde.
       ⚠️ ET ON AMENE LA RANGEE SOUS LES YEUX : dans la fenetre elle peut avoir defile hors du
       panneau, et un surlignage qu'on ne voit pas ne vaut rien. */
    function designeLesFormats() {
      var rangee = voile.querySelector(".pdp-option");
      if (!rangee) return;
      if (commandes.scrollHeight > commandes.clientHeight) {
        try { rangee.scrollIntoView({ behavior: "smooth", block: "nearest" }); } catch (e) {}
      }
      rangee.classList.remove("pdp-option--ask");
      /* Relancer une animation demande de la laisser repartir : sans ce temps mort, un second
         clic ne rejoue rien et le bouton parait mort. */
      void rangee.offsetWidth;
      rangee.classList.add("pdp-option--ask");
      setTimeout(function () { rangee.classList.remove("pdp-option--ask"); }, 1400);
    }
    acheter.addEventListener("click", function () {
      if (sansTaille) { designeLesFormats(); return; }
      ferme();
      if (typeof o.onAjouter === "function") o.onAjouter();
    });
    fermer.focus();
    return true;
  });
};
